import React, { createContext, useMemo, useEffect, useState, useRef, useContext, useCallback } from 'react';
import { jsx, css, Global } from '@emotion/react';
import { Flex, Text, Div, LoadingSpinner, AnimatedCheckMark, Spacer, Grid, CloseButton, ImageUploader, Button, GridItem, Image as Image$1, Span, Icon, VStack, IconLink, Accordion, HStack, IncrementSetting, Input, Tabs, Tab, List, ListItem, SettingInput, QuantumColorPicker, Sidebar, Section, Tooltip, InfiniteScroller, ButtonWithMenu, Pill, Banner, Stoplight, ColorOption, Zoom, ReleaseNoteDialog, FeatureAnnouncement, QuantumThemeWrapper, Drawer, ImageUploadWidget, useColorSwatch } from '@sendoutcards/quantum-design-ui';
import isNumber from 'lodash/isNumber';
import { useDispatch, useSelector, connect as connect$1, Provider } from 'react-redux';
import { bindActionCreators, combineReducers, createStore } from 'redux';
import { ActionCreator } from '@sendoutcards/core';
import InfiniteScroll from 'react-infinite-scroll-component';
import useResizeObserver from 'use-resize-observer';
import { AnimatePresence, useAnimation } from 'framer-motion';
import Color from 'color';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { gql } from 'graphql-tag';
import equal from 'fast-deep-equal';
import ReactResizeDetector from 'react-resize-detector';
import AvatarEditor from 'react-avatar-editor';
import Moveable from 'react-moveable';
import { useMergeRefs } from 'use-callback-ref';
import LogRocket from 'logrocket';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { Queue } from 'typescript-structures';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
  module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _extends = /*@__PURE__*/getDefaultExportFromCjs(_extends_1);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var EditorChromeContext = /*#__PURE__*/createContext({
  layouts: [],
  images: {
    hasMore: false,
    loadMore: function () {},
    isLoadingMore: false,
    results: []
  },
  fonts: [],
  signatures: [],
  placeholders: [],
  defaultBackPanels: {
    hasMore: false,
    isLoadingMore: false,
    loadMore: function () {},
    results: []
  },
  customBackPanels: {
    hasMore: false,
    isLoadingMore: false,
    loadMore: function () {},
    results: []
  },
  colorPalettes: {
    isLoading: false,
    palette: []
  }
});
var EditorChromeProvider = EditorChromeContext.Provider;
var EditorChromeConsumer = EditorChromeContext.Consumer;

var black = {
  r: 0,
  g: 0,
  b: 0
};
var rgbString = function (color) {
  return "rgb(" + color.r + ", " + color.g + ", " + color.b + ")";
};

var defaultFragment = {
  fontFamily: 'HelveticaV2',
  fontSize: 16,
  color: black,
  textAlign: 'CENTER'
};
var signatureCharacter = 'æ'; // type IncompleteFragment = {

var textState = function (editor) {
  var element = selectedElement(editor);
  var textSelection = editor.textSelection;
  return element && element.text && textSelection ? __assign(__assign({}, textSelection), {
    fragments: element.text.fragments
  }) : {
    fragments: [defaultFragment],
    start: 1,
    end: 1,
    overrideProperties: {}
  };
};
var paragraphStart = function (textState) {
  return textState.fragments.slice(0, textState.start).reduce(function (acc, fragment, index) {
    return fragment.textAlign ? index : acc;
  }, 0);
};
var insertionTextAlign = function (textState) {
  return textState.fragments[paragraphStart(textState)].textAlign;
};
var insertionProperties = function (textState) {
  var insertionProperties = __assign(__assign({}, textState.fragments[textState.start === textState.end ? textState.start - 1 : textState.start]), textState.overrideProperties);

  var textAlign = insertionProperties.textAlign,
      signatureFontFamily = insertionProperties.signatureFontFamily,
      text = insertionProperties.text,
      remainingProperties = __rest(insertionProperties, ["textAlign", "signatureFontFamily", "text"]);

  return remainingProperties;
};
var paragraphs = function (fragments) {
  return fragments.reduce(function (paragraphs, fragment, index) {
    var lastIndex = paragraphs.length - 1;
    var lastParagraph = paragraphs[lastIndex];
    return fragment.textAlign ? __spread(paragraphs, [{
      index: index,
      fontFamily: fragment.fontFamily,
      fontSize: fragment.fontSize,
      color: fragment.color,
      textAlign: fragment.textAlign,
      fragments: []
    }]) : __spread(paragraphs.slice(0, lastIndex), [__assign(__assign({}, lastParagraph), {
      fragments: __spread(lastParagraph.fragments, [__assign(__assign({}, fragment), {
        index: index
      })])
    })]);
  }, []);
};

var selectedFragments = function (textState) {
  // todo look into alignment and why first element is being pulled, is it a line break?
  return textState.fragments.slice(1, textState.end);
};

var selectedText = function (textState) {
  return textState.fragments.map(function (fragment) {
    return fragment.text ? fragment.text : fragment.signatureFontFamily ? '' : '\n';
  }).join('');
};

var selectedProperty = function (textState, key) {
  return textState.start === textState.end ? insertionProperties(textState)[key] : textState.fragments.slice(textState.start, textState.end).map(function (fragment) {
    return fragment[key];
  }).reduce(function (acc, value) {
    return acc === value ? acc : undefined;
  });
}; // TODO change any types
var selectedFontSize = function (textState) {
  return selectedProperty(textState, 'fontSize');
};
var selectedColor = function (textState) {
  return selectedProperty(textState, 'color');
};

var selectionPaths = function (textState) {
  return textState.fragments.reduce(function (_a, fragment) {
    var paragraph = _a.paragraph,
        offset = _a.offset,
        selectionPaths = _a.selectionPaths;
    var newParagraph = fragment.textAlign ? paragraph + 1 : paragraph;
    var newOffset = fragment.textAlign ? 0 : offset + 1;
    return {
      paragraph: newParagraph,
      offset: newOffset,
      selectionPaths: __spread(selectionPaths, [{
        paragraph: newParagraph,
        offset: newOffset
      }])
    };
  }, {
    paragraph: -1,
    offset: -1,
    selectionPaths: Array()
  }).selectionPaths;
};

var paragraphSelection = function (textState) {
  var paths = selectionPaths(textState);
  return {
    start: __assign(__assign({}, paths[textState.start - 1]), {
      index: textState.start
    }),
    end: __assign(__assign({}, paths[textState.end - 1]), {
      index: textState.end
    }),
    fragments: selectedFragments(textState),
    text: selectedText(textState)
  };
};
var computedElementText = function (textState, isSelected) {
  return {
    paragraphs: paragraphs(textState.fragments),
    selectionUpperBound: textState.fragments.length,
    selection: isSelected ? paragraphSelection(textState) : undefined
  };
};

var selectedFullBleed = function (_a) {
  var card = _a.card,
      fullBleedLocation = _a.fullBleedLocation;
  return card && isNumber(fullBleedLocation) ? card.fullBleeds[fullBleedLocation] : undefined;
};
var selectedPanel = function (_a) {
  var card = _a.card,
      fullBleedLocation = _a.fullBleedLocation,
      panelLocation = _a.panelLocation;
  return card && isNumber(panelLocation) ? card.fullBleeds[fullBleedLocation].panels[panelLocation !== null && panelLocation !== void 0 ? panelLocation : 0] : undefined;
};
var selectedElement = function (editor) {
  var _a;

  var card = editor.card,
      fullBleedLocation = editor.fullBleedLocation,
      panelLocation = editor.panelLocation,
      activeElement = editor.activeElement;

  if (!card || !isNumber(activeElement.location)) {
    return undefined;
  }

  if (isNumber(panelLocation)) {
    var panel = selectedPanel(editor);
    return panel ? panel.elements[(_a = activeElement.location) !== null && _a !== void 0 ? _a : 0] : undefined;
  } else {
    return card.fullBleeds[fullBleedLocation].backgroundElement;
  }
}; // TODO: Type this

var computedElements = function (elements, panel, fullBleed, selection) {
  return elements.map(function (element, location) {
    var points = {
      x: element.x * panel.width,
      y: element.y * panel.height,
      width: element.width * panel.width,
      height: element.height * panel.height
    };
    var isSelected = fullBleed.location === selection.fullBleed && panel.location === selection.panel && location === selection.element;

    var textState = __assign({
      fragments: element.text ? element.text.fragments : []
    }, selection.textSelection || {
      start: 0,
      end: 0,
      overrideProperties: {}
    });

    var computedElement = __assign(__assign({}, element), {
      text: element.text ? computedElementText(textState, isSelected) : null,
      location: location,
      isSelected: isSelected,
      points: points
    });

    return computedElement;
  });
};

var computedPanels = function (panels, fullBleed, selection) {
  return panels.map(function (panel, location) {
    var points = {
      x: panel.x * fullBleed.width,
      y: panel.y * fullBleed.height,
      width: panel.width * fullBleed.width,
      height: panel.height * fullBleed.height
    };
    return __assign(__assign({}, panel), {
      location: location,
      isSelected: fullBleed.location === selection.fullBleed && location === selection.panel,
      points: points,
      elements: computedElements(panel.elements, {
        location: location,
        width: points.width,
        height: points.height
      }, fullBleed, selection)
    });
  });
}; // TODO - was ComputedFullBleed[] (causing errors with flatMap)


var computedFullBleeds = function (editor) {
  return editor.card ? editor.card.fullBleeds.map(function (fullBleed, location) {
    return __assign(__assign({}, fullBleed), {
      location: location,
      backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
        location: 0,
        isSelected: !isNumber(editor.panelLocation),
        points: {
          x: fullBleed.backgroundElement.x * fullBleed.width,
          y: fullBleed.backgroundElement.y * fullBleed.height,
          width: fullBleed.backgroundElement.width * fullBleed.width,
          height: fullBleed.backgroundElement.height * fullBleed.height
        }
      }) : null,
      panels: computedPanels(fullBleed.panels, {
        location: location,
        width: fullBleed.width,
        height: fullBleed.height
      }, {
        fullBleed: editor.fullBleedLocation,
        panel: editor.panelLocation,
        element: editor.activeElement.location,
        textSelection: editor.textSelection
      })
    });
  }) : [];
};
var computedSingleFullBleeds = function (editor) {
  return computedFullBleeds(editor).flatMap(function (fullbleed) {
    return fullbleed.panels.map(function (panel) {
      return __assign(__assign({}, fullbleed), {
        panels: [panel]
      });
    });
  });
};
var getPanelLocations = function (editor) {
  return computedFullBleeds(editor).flatMap(function (fullbleed, fullbleedLocation) {
    return fullbleed.panels.map(function (_, panelLocation) {
      return {
        fullbleed: fullbleedLocation,
        panel: panelLocation
      };
    });
  });
};
var isHorizontalFullBleed = function (view, index, numFullBleeds, numPanels, isHorizontal) {
  // All back panels (for now) are portrait
  if (index === numFullBleeds - 1) {
    return false;
  }

  if (view === 'panel') {
    return isHorizontal;
  } else {
    if (index !== 1) {
      return isHorizontal;
    }

    if (numPanels > 1) {
      return !isHorizontal;
    }
  }

  return isHorizontal;
};

var selectImageScale = ActionCreator('SELECT_IMAGE_SCALE', function (scale) {
  return {
    scale: scale
  };
});
var removeImage = ActionCreator('REMOVE_IMAGE');
var selectElement = ActionCreator('SELECT_ELEMENT', function (activeElement, panelLocation, textStart, textEnd) {
  return {
    activeElement: activeElement,
    panelLocation: panelLocation,
    textStart: textStart,
    textEnd: textEnd
  };
});
var deselectElement = ActionCreator('DESELECT_ELEMENT');
var toggleElementDraggable = ActionCreator('TOGGLE_ELEMENT_DRAGGABLE');
var setCard = ActionCreator('SET_CARD', function (card) {
  return {
    card: card
  };
});
var openFacebookImageDrawer = ActionCreator('OPEN_FACEBOOK_IMAGE_DRAWER');
var clearCard = ActionCreator('CLEAR_CARD');
var setToolbarAction = ActionCreator('SET_TOOLBAR_ACTION', function (toolbarAction) {
  return {
    toolbarAction: toolbarAction
  };
});
var selectBackPanel = ActionCreator('SELECT_BACK_PANEL', function (layout) {
  return {
    layout: layout
  };
});
var updateCard = ActionCreator('UPDATE_CARD', function (card) {
  return {
    card: card
  };
});
var setPanelBackground = ActionCreator('SET_PANEL_BACKGROUND', function (color) {
  return {
    color: color
  };
});
var openFilterDrawer = ActionCreator('OPEN_FILTER_DRAWER');
var selectFilter = ActionCreator('SELECT_FILTER', function (filterName, url) {
  return {
    filterName: filterName,
    url: url
  };
});
var removeSpan = ActionCreator('REMOVE_SPAN');
var openBackgroundDrawer = ActionCreator('OPEN_BACKGROUND_DRAWER');
var addTextElement = ActionCreator('ADD_TEXT_ELEMENT', function (isFullPanel) {
  return {
    isFullPanel: isFullPanel
  };
});
var addImageElement = ActionCreator('ADD_IMAGE_ELEMENT', function (image, isFullPanel) {
  return {
    image: image,
    isFullPanel: isFullPanel
  };
});
var disableSelectingElements = ActionCreator('DISABLE_SELECTING_ELEMENTS');
var enableSelectingElements = ActionCreator('ENABLE_SELECTING_ELEMENTS');
var updateElementSize = ActionCreator('UPDATE_ELEMENT_SIZE', function (elementLocation, width, height) {
  return {
    elementLocation: elementLocation,
    width: width,
    height: height
  };
});
var selectImagePosition = ActionCreator('SELECT_IMAGE_POSITION', function (x, y) {
  return {
    x: x,
    y: y
  };
});
var updateElementPosition = ActionCreator('UPDATE_ELEMENT_POSITION', function (elementLocation, x, y) {
  return {
    elementLocation: elementLocation,
    x: x,
    y: y
  };
});
var updateElementRotation = ActionCreator('UPDATE_ELEMENT_ROTATION', function (elementLocation, rotation) {
  return {
    elementLocation: elementLocation,
    rotation: rotation
  };
});
var selectImage = ActionCreator('SELECT_IMAGE', function (photo) {
  return {
    photo: photo
  };
});
var removeElement = ActionCreator('REMOVE_ELEMENT');
var clearPanel = ActionCreator('CLEAR_PANEL');
var selectLayoutToLoad = ActionCreator('SELECT_LAYOUT_TO_LOAD', function (layoutId) {
  return {
    layoutId: layoutId
  };
});
var selectFullBleed = ActionCreator('SELECT_FULL_BLEED', function (fullBleedLocation) {
  return {
    fullBleedLocation: fullBleedLocation
  };
});
var selectSinglePanel = ActionCreator('SELECT_SINGLE_PANEL', function (fullBleedLocation, panelLocation) {
  return {
    fullBleedLocation: fullBleedLocation,
    panelLocation: panelLocation
  };
});
var selectLayout = ActionCreator('SELECT_LAYOUT', function (layout) {
  return {
    layout: layout
  };
});
var loadedCard = ActionCreator('LOADED_CARD', function (card) {
  return {
    card: card
  };
});
var selectPanel = ActionCreator('SELECT_PANEL', function (panelLocation, fullBleedLocation) {
  return {
    panelLocation: panelLocation,
    fullBleedLocation: fullBleedLocation
  };
});
var closeEditorDrawer = ActionCreator('CLOSE_EDITOR_DRAWER');
var resetState = ActionCreator('RESET_STATE');
var editorUndo = ActionCreator('UNDO_EDITOR_CHANGE');
var editorRedo = ActionCreator('REDO_EDITOR_CHANGE');
var duplicateElement = ActionCreator('DUPLICATE_ELEMENT');
var layerUp = ActionCreator('LAYER_UP', function (elementLocation) {
  return {
    elementLocation: elementLocation
  };
});
var layerDown = ActionCreator('LAYER_DOWN', function (elementLocation) {
  return {
    elementLocation: elementLocation
  };
});
var setEditing = ActionCreator('SET_EDITING', function (editing) {
  return {
    editing: editing
  };
});
var setFullBleedBackgroundImage = ActionCreator('SET_FULLBLEED_BACKGROUND_IMAGE', function (image) {
  return {
    image: image
  };
});
var deleteFullBleedBackgroundImage = ActionCreator('DELETE_FULL_BLEED_BACKGROUND_IMAGE');
var updateFullBleedBackgroundImagePosition = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_IMAGE_POSITION', function (x, y) {
  return {
    x: x,
    y: y
  };
});
var updateFullBleedBackgroundImageScale = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_IMAGE_SCALE', function (scale) {
  return {
    scale: scale
  };
});
var updateFullBleedBackgroundElementPosition = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_ELEMENT_POSITION', function (x, y) {
  return {
    x: x,
    y: y
  };
});
var updateFullBleedBackgroundElementSize = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_ELEMENT_SIZE', function (width, height) {
  return {
    width: width,
    height: height
  };
});
var updateFullBleedBackgroundElementRotation = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_ELEMENT_ROTATION', function (rotation) {
  return {
    rotation: rotation
  };
});
var selectVariation = ActionCreator('SELECT_VARIATION', function (variationID) {
  return {
    variationID: variationID
  };
});
var enablePreviewMode = ActionCreator('ENABLE_PREVIEW_MODE');
var updateClientAsset = ActionCreator('UPDATE_CLIENT_ASSET', function (image) {
  return {
    image: image
  };
});

var openElementInsertDrawer = ActionCreator('OPEN_ELEMENT_INSERT_DRAWER', function (insertType) {
  return {
    insertType: insertType
  };
});
var closeElementInsertDrawer = ActionCreator('CLOSE_ELEMENT_INSERT_DRAWER');
var openElementSettingsDrawer = ActionCreator('OPEN_ELEMENT_SETTINGS_DRAWER', function (settingType) {
  return {
    settingType: settingType
  };
});
var closeElementSettingsDrawer = ActionCreator('CLOSE_ELEMENT_SETTINGS_DRAWER');
var setActiveImageSetting = ActionCreator('SET_ACTIVE_IMAGE_SETTING', function (activeSetting) {
  return {
    activeSetting: activeSetting
  };
});
var setActiveTextSetting = ActionCreator('SET_ACTIVE_TEXT_SETTING', function (activeSetting) {
  return {
    activeSetting: activeSetting
  };
});
var setShouldReplaceSelectedImage = ActionCreator('SET_SHOULD_REPLACE_SELECTED_IMAGE', function (shouldReplaceSelectedImage) {
  return {
    shouldReplaceSelectedImage: shouldReplaceSelectedImage
  };
});
var setIsTextCursorActive = ActionCreator('SET_IS_TEXT_CURSOR_ACTIVE', function (isTextCursorActive) {
  return {
    isTextCursorActive: isTextCursorActive
  };
});
var toggleInteractionMode = ActionCreator('TOGGLE_INTERACTION_MODE');
var closeBetaBanner = ActionCreator('CLOSED_BETA_BANNER');
var setReleaseData = ActionCreator('SET_RELEASE_DATA', function (releaseData) {
  return {
    releaseData: releaseData
  };
});
var popReleaseFeature = ActionCreator('POP_RELEASE_FEATURE');
var setReleaseOpenState = ActionCreator('SET_RELEASE_OPEN_STATE', function (isOpen) {
  return {
    isOpen: isOpen
  };
});
var toggleImageUploaderWidget = ActionCreator('TOGGLED_IMAGE_UPLOADER_WIDGET');
var setHasUploadedImage = ActionCreator('SET_HAS_UPLOADED_IMAGE', function (hasUploadedImage) {
  return {
    hasUploadedImage: hasUploadedImage
  };
});
var saveAndSend = ActionCreator('SAVED_AND_SENT');

var uploadedImage = ActionCreator('UPLOADED_IMAGE', function (image) {
  return {
    image: image
  };
});
var showImages = ActionCreator('SHOW_IMAGES');

var insertText = ActionCreator('INSERT_TEXT', function (text) {
  return {
    text: text
  };
});
var selectFontFamily = ActionCreator('SELECT_FONT_FAMILY', function (fontFamily) {
  return {
    fontFamily: fontFamily
  };
});
var insertNewLine = ActionCreator('INSERT_NEW_LINE');
var selectColor = ActionCreator('SELECT_COLOR', function (color) {
  return {
    color: color
  };
});
var insertCharacter = ActionCreator('INSERT_CHARACTER', function (character) {
  return {
    character: character
  };
});
var insertSignature = ActionCreator('INSERT_SIGNATURE', function (signature) {
  return {
    signature: signature
  };
});
var insertFragments = ActionCreator('INSERT_FRAGMENTS', function (fragments) {
  return {
    fragments: fragments
  };
});
var selectTextAlign = ActionCreator('SELECT_TEXT_ALIGN', function (textAlign) {
  return {
    textAlign: textAlign
  };
});
var deleteForwardFragments = ActionCreator('DELETE_FORWARD_FRAGMENTS');
var deleteFragments = ActionCreator('DELETE_FRAGMENTS');
var selectFontSize = ActionCreator('SELECT_FONT_SIZE', function (fontSize) {
  return {
    fontSize: fontSize
  };
});
var insertPlaceholder = ActionCreator('INSERT_PLACEHOLDER', function (placeholder) {
  return {
    placeholder: placeholder
  };
});
var updateTextCasing = ActionCreator('UPDATE_TEXT_CASING', function (casing) {
  return {
    casing: casing
  };
});
var clearText = ActionCreator('CLEAR_TEXT');

var actions = /*#__PURE__*/Object.freeze({
	__proto__: null,
	selectImageScale: selectImageScale,
	removeImage: removeImage,
	selectElement: selectElement,
	deselectElement: deselectElement,
	toggleElementDraggable: toggleElementDraggable,
	setCard: setCard,
	openFacebookImageDrawer: openFacebookImageDrawer,
	clearCard: clearCard,
	setToolbarAction: setToolbarAction,
	selectBackPanel: selectBackPanel,
	updateCard: updateCard,
	setPanelBackground: setPanelBackground,
	openFilterDrawer: openFilterDrawer,
	selectFilter: selectFilter,
	removeSpan: removeSpan,
	openBackgroundDrawer: openBackgroundDrawer,
	addTextElement: addTextElement,
	addImageElement: addImageElement,
	disableSelectingElements: disableSelectingElements,
	enableSelectingElements: enableSelectingElements,
	updateElementSize: updateElementSize,
	selectImagePosition: selectImagePosition,
	updateElementPosition: updateElementPosition,
	updateElementRotation: updateElementRotation,
	selectImage: selectImage,
	removeElement: removeElement,
	clearPanel: clearPanel,
	selectLayoutToLoad: selectLayoutToLoad,
	selectFullBleed: selectFullBleed,
	selectSinglePanel: selectSinglePanel,
	selectLayout: selectLayout,
	loadedCard: loadedCard,
	selectPanel: selectPanel,
	closeEditorDrawer: closeEditorDrawer,
	resetState: resetState,
	editorUndo: editorUndo,
	editorRedo: editorRedo,
	duplicateElement: duplicateElement,
	layerUp: layerUp,
	layerDown: layerDown,
	setEditing: setEditing,
	setFullBleedBackgroundImage: setFullBleedBackgroundImage,
	deleteFullBleedBackgroundImage: deleteFullBleedBackgroundImage,
	updateFullBleedBackgroundImagePosition: updateFullBleedBackgroundImagePosition,
	updateFullBleedBackgroundImageScale: updateFullBleedBackgroundImageScale,
	updateFullBleedBackgroundElementPosition: updateFullBleedBackgroundElementPosition,
	updateFullBleedBackgroundElementSize: updateFullBleedBackgroundElementSize,
	updateFullBleedBackgroundElementRotation: updateFullBleedBackgroundElementRotation,
	selectVariation: selectVariation,
	enablePreviewMode: enablePreviewMode,
	updateClientAsset: updateClientAsset,
	openElementInsertDrawer: openElementInsertDrawer,
	closeElementInsertDrawer: closeElementInsertDrawer,
	openElementSettingsDrawer: openElementSettingsDrawer,
	closeElementSettingsDrawer: closeElementSettingsDrawer,
	setActiveImageSetting: setActiveImageSetting,
	setActiveTextSetting: setActiveTextSetting,
	setShouldReplaceSelectedImage: setShouldReplaceSelectedImage,
	setIsTextCursorActive: setIsTextCursorActive,
	toggleInteractionMode: toggleInteractionMode,
	closeBetaBanner: closeBetaBanner,
	setReleaseData: setReleaseData,
	popReleaseFeature: popReleaseFeature,
	setReleaseOpenState: setReleaseOpenState,
	toggleImageUploaderWidget: toggleImageUploaderWidget,
	setHasUploadedImage: setHasUploadedImage,
	saveAndSend: saveAndSend,
	uploadedImage: uploadedImage,
	showImages: showImages,
	insertText: insertText,
	selectFontFamily: selectFontFamily,
	insertNewLine: insertNewLine,
	selectColor: selectColor,
	insertCharacter: insertCharacter,
	insertSignature: insertSignature,
	insertFragments: insertFragments,
	selectTextAlign: selectTextAlign,
	deleteForwardFragments: deleteForwardFragments,
	deleteFragments: deleteFragments,
	selectFontSize: selectFontSize,
	insertPlaceholder: insertPlaceholder,
	updateTextCasing: updateTextCasing,
	clearText: clearText
});

var useReduxActions = function () {
  var dispatch = useDispatch();
  return useMemo(function () {
    return bindActionCreators(actions, dispatch);
  }, [dispatch]);
};

function useReduxState(selector, equalityFn) {
  return useSelector(typeof selector === 'string' ? function (state) {
    return state[selector];
  } : selector, equalityFn);
}

var DrawerSummary = function (_a) {
  var title = _a.title,
      elementCount = _a.elementCount,
      outset = _a.outset,
      _b = _a.color,
      color = _b === void 0 ? 'primaryHeading' : _b;
  return jsx(Flex, {
    outset: outset,
    flexDirection: "row",
    justifyContent: "space-between"
  }, jsx(Text, {
    inset: "x0",
    outset: "x0",
    lineHeight: 1.2,
    type: "footnote",
    weight: "semiBold",
    content: title,
    color: color
  }), jsx(Text, {
    inset: "x0",
    outset: "x0",
    lineHeight: 1.2,
    type: "footnote",
    content: "(" + elementCount + ")",
    color: color
  }));
};

var styles = {
  stickersContainer: /*#__PURE__*/css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ::-webkit-scrollbar {\n      width: 0; /* Remove scrollbar space */\n      background: transparent; /* Optional: just make scrollbar invisible */\n    }\n    scrollbar-width: none;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:stickersContainer;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHdUIiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBzdGlja2Vyc0NvbnRhaW5lcjogY3NzKHRlbXBsYXRlT2JqZWN0XzEgfHwgKHRlbXBsYXRlT2JqZWN0XzEgPSBfX21ha2VUZW1wbGF0ZU9iamVjdChbXCJcXG4gICAgOjotd2Via2l0LXNjcm9sbGJhciB7XFxuICAgICAgd2lkdGg6IDA7IC8qIFJlbW92ZSBzY3JvbGxiYXIgc3BhY2UgKi9cXG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDsgLyogT3B0aW9uYWw6IGp1c3QgbWFrZSBzY3JvbGxiYXIgaW52aXNpYmxlICovXFxuICAgIH1cXG4gICAgc2Nyb2xsYmFyLXdpZHRoOiBub25lO1xcbiAgXCJdLCBbXCJcXG4gICAgOjotd2Via2l0LXNjcm9sbGJhciB7XFxuICAgICAgd2lkdGg6IDA7IC8qIFJlbW92ZSBzY3JvbGxiYXIgc3BhY2UgKi9cXG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDsgLyogT3B0aW9uYWw6IGp1c3QgbWFrZSBzY3JvbGxiYXIgaW52aXNpYmxlICovXFxuICAgIH1cXG4gICAgc2Nyb2xsYmFyLXdpZHRoOiBub25lO1xcbiAgXCJdKSkpLFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")], ["\n    ::-webkit-scrollbar {\n      width: 0; /* Remove scrollbar space */\n      background: transparent; /* Optional: just make scrollbar invisible */\n    }\n    scrollbar-width: none;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:stickersContainer;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHdUIiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBzdGlja2Vyc0NvbnRhaW5lcjogY3NzKHRlbXBsYXRlT2JqZWN0XzEgfHwgKHRlbXBsYXRlT2JqZWN0XzEgPSBfX21ha2VUZW1wbGF0ZU9iamVjdChbXCJcXG4gICAgOjotd2Via2l0LXNjcm9sbGJhciB7XFxuICAgICAgd2lkdGg6IDA7IC8qIFJlbW92ZSBzY3JvbGxiYXIgc3BhY2UgKi9cXG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDsgLyogT3B0aW9uYWw6IGp1c3QgbWFrZSBzY3JvbGxiYXIgaW52aXNpYmxlICovXFxuICAgIH1cXG4gICAgc2Nyb2xsYmFyLXdpZHRoOiBub25lO1xcbiAgXCJdLCBbXCJcXG4gICAgOjotd2Via2l0LXNjcm9sbGJhciB7XFxuICAgICAgd2lkdGg6IDA7IC8qIFJlbW92ZSBzY3JvbGxiYXIgc3BhY2UgKi9cXG4gICAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDsgLyogT3B0aW9uYWw6IGp1c3QgbWFrZSBzY3JvbGxiYXIgaW52aXNpYmxlICovXFxuICAgIH1cXG4gICAgc2Nyb2xsYmFyLXdpZHRoOiBub25lO1xcbiAgXCJdKSkpLFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")])))
};
var templateObject_1;

var InsertDrawerContent = function (_a) {
  var heading = _a.heading,
      description = _a.description,
      dataLength = _a.dataLength,
      hasMore = _a.hasMore,
      loadMore = _a.loadMore,
      grid = _a.grid,
      endMessage = _a.endMessage,
      drawerSummaryTitle = _a.drawerSummaryTitle,
      children = _a.children,
      actionElement = _a.actionElement,
      totalDataCount = _a.totalDataCount;

  var _b = useResizeObserver(),
      height = _b.height,
      ref = _b.ref;

  useEffect(function () {
    if (height && window.innerHeight > height && hasMore) {
      loadMore();
    }
  }, [height]); //eslint-disable-line

  return jsx(Flex, {
    inset: 'x1',
    height: '100%',
    width: "100%",
    flexDirection: "column"
  }, jsx(Div, null, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, heading), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, description)), actionElement && jsx(Div, {
    inset: {
      vertical: 'x2'
    }
  }, actionElement), typeof totalDataCount === 'number' && jsx(DrawerSummary, {
    outset: {
      vertical: 'x2'
    },
    elementCount: totalDataCount,
    title: drawerSummaryTitle
  }), jsx(Div, {
    overflowY: "auto",
    css: styles.stickersContainer,
    id: "scrollAble",
    ref: ref,
    height: "100%"
  }, jsx(InfiniteScroll, {
    css: styles.stickersContainer,
    hasMore: hasMore,
    dataLength: dataLength,
    height: height + "px",
    loader: jsx(Div, {
      inset: "x8"
    }, jsx(LoadingSpinner, {
      size: "xLarge"
    })),
    endMessage: jsx(Flex, {
      position: "relative",
      width: "100%",
      flexDirection: "column",
      alignItems: "center",
      outset: {
        top: 'x4'
      }
    }, jsx(AnimatedCheckMark, {
      size: "small"
    }), jsx(Spacer, {
      space: "x1"
    }), jsx(Text, {
      type: "body"
    }, endMessage)),
    next: loadMore,
    scrollableTarget: "scrollAble"
  }, jsx(Grid, {
    columnSize: grid === null || grid === void 0 ? void 0 : grid.columnSize,
    rowSize: grid === null || grid === void 0 ? void 0 : grid.rowSize,
    gap: 16
  }, children))));
};

var UploadImagesOverlay = function (_a) {
  var title = _a.title,
      subtitle = _a.subtitle,
      onFinished = _a.onFinished,
      onUpload = _a.onUpload,
      _b = _a.hasMuliUpload,
      hasMuliUpload = _b === void 0 ? false : _b;
  return jsx(Flex, {
    animate: {
      opacity: 1
    },
    initial: {
      opacity: 0
    },
    exit: {
      opacity: 0
    },
    flexDirection: "column",
    height: "100%",
    width: "100%",
    backgroundColor: "background",
    position: "absolute",
    top: "0",
    inset: {
      left: 'x3',
      right: 'x1_5',
      vertical: 'x1'
    }
  }, jsx(CloseButton, {
    fill: "danger",
    top: "12px",
    right: "12px",
    onClose: function () {
      return onFinished();
    }
  }), jsx(Text, {
    weight: "extraBold",
    type: "largeBody",
    content: title
  }), jsx(Flex, {
    width: "80%"
  }, jsx(Text, {
    alignment: "left",
    lineHeight: 1.4,
    type: "caption",
    content: subtitle
  })), jsx(Spacer, {
    space: "x2"
  }), jsx(Div, {
    height: "100%",
    inset: {
      bottom: 'x4'
    }
  }, jsx(ImageUploader, {
    onUpload: function (files, fileList) {
      onUpload(files, fileList);
      onFinished();
    },
    acceptedFiles: ['gif', 'jpeg', 'jpg', 'png'],
    hasMultiupload: hasMuliUpload,
    backgroundColor: "foreground"
  })));
};

var Images = function (props) {
  var _a, _b;

  var images = props.images,
      onUploadImages = props.onUploadImages,
      onDelete = props.onDelete,
      isFullPanel = props.isFullPanel;
  var editor = useReduxState('editor');
  var activeElement = editor.activeElement;
  var editing = editor.editing;
  var selectedFullBleed$1 = selectedFullBleed(editor);
  var selectedPanel$1 = selectedPanel(editor);
  var selectedElement$1 = selectedElement(editor);
  var shouldReplaceSelectedImage = useReduxState('editorChrome').shouldReplaceSelectedImage;
  var actions = useReduxActions();
  var selectImage = actions.selectImage;

  var _c = __read(useState(false), 2),
      isUploadOverlayOpen = _c[0],
      setIsUploadOverlayOpen = _c[1];

  var _d = __read(useState(false), 2),
      isEditable = _d[0],
      setIsEditable = _d[1];

  var _e = __read(useState(images.results.length), 2),
      imageQty = _e[0],
      setImageQty = _e[1];

  var hasFullBleedImage = ((_b = (_a = selectedFullBleed$1 === null || selectedFullBleed$1 === void 0 ? void 0 : selectedFullBleed$1.backgroundElement) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.image) ? true : false;

  var isImageElementIsSelected = function (location, elementType) {
    if (typeof location === 'number' && elementType === 'image') {
      return true;
    }

    return false;
  };

  var handleAddImage = function (image) {
    var _a;

    if (editing === 'fullbleed') {
      actions.setFullBleedBackgroundImage(image);
    } else if (shouldReplaceSelectedImage && isImageElementIsSelected(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, activeElement === null || activeElement === void 0 ? void 0 : activeElement.type)) {
      actions.selectImage(image);
      actions.setActiveImageSetting('crop');
    } else if (isFullPanel) {
      var backgroundImage = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.elements.find(function (element) {
        var _a;

        return (element === null || element === void 0 ? void 0 : element.isFullPanel) && ((_a = element === null || element === void 0 ? void 0 : element.image) === null || _a === void 0 ? void 0 : _a.image);
      });

      if ((_a = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _a === void 0 ? void 0 : _a.image) {
        actions.selectImage(backgroundImage.image.image);
        actions.removeElement();
      }

      actions.addImageElement(image, true);
      actions.setActiveImageSetting('crop');
      actions.setShouldReplaceSelectedImage(false);
    } else {
      actions.openElementSettingsDrawer('image');
      actions.addImageElement(image);
      actions.setShouldReplaceSelectedImage(false);
      actions.setActiveImageSetting(null);
    }
  };

  useEffect(function () {
    var _a, _b;

    var isElementSticker = (_b = (_a = selectedElement$1 === null || selectedElement$1 === void 0 ? void 0 : selectedElement$1.image) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.isSticker;

    if (images.results.length - 1 === imageQty && selectedElement$1 && !isElementSticker) {
      var uploadedImage = images.results[0];
      uploadedImage && selectImage(uploadedImage);
    }

    setImageQty(images.results.length);
  }, [images, selectImage, selectedElement$1, imageQty, setImageQty]);
  return jsx(AnimatePresence, null, isUploadOverlayOpen ? jsx(UploadImagesOverlay, {
    onUpload: function (_files, fileList) {
      if (_files.rejected.length > 0) {
        return;
      }

      if (fileList && fileList.length > 0 && _files.accepted.length > 0) {
        onUploadImages === null || onUploadImages === void 0 ? void 0 : onUploadImages(fileList);
      }
    },
    onFinished: function () {
      return setIsUploadOverlayOpen(false);
    },
    title: "Upload Images",
    subtitle: "Personalize your card by adding an image"
  }) : jsx(InsertDrawerContent, {
    dataLength: images.results.length,
    heading: editing === 'fullbleed' ? hasFullBleedImage ? 'Change background image' : 'Add background image' : isImageElementIsSelected(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, activeElement === null || activeElement === void 0 ? void 0 : activeElement.type) && shouldReplaceSelectedImage ? 'Change your image' : 'Add an image',
    description: isImageElementIsSelected(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, activeElement === null || activeElement === void 0 ? void 0 : activeElement.type) && shouldReplaceSelectedImage ? 'Choose an image below to replace your current selection' : 'Choose an image below to add it to your selected panel',
    drawerSummaryTitle: "All Images",
    hasMore: images.hasMore,
    loadMore: images.loadMore,
    grid: {
      columnSize: 42,
      rowSize: 35
    },
    endMessage: "All Images Loaded",
    actionElement: jsx(Flex, {
      justifyContent: "space-between",
      alignItems: "center"
    }, jsx(Button, {
      size: "xSmall",
      type: "smoke",
      onClick: function () {
        return setIsUploadOverlayOpen(true);
      },
      title: "Upload Photo"
    }), jsx(Button, {
      size: "xSmall",
      type: "primary",
      onClick: function () {
        return setIsEditable(!isEditable);
      },
      outlined: true
    }, isEditable ? 'Select' : 'Delete'))
  }, images.results.map(function (image) {
    return jsx(GridItem, {
      gridColSpan: 2,
      gridRowSpan: image.width > image.height ? 2 : 4,
      borderRadius: 'medium',
      key: image.id
    }, jsx(Div, {
      position: "relative",
      width: "100%",
      height: "100%"
    }, isEditable && jsx(CloseButton, {
      onClose: function () {
        return onDelete === null || onDelete === void 0 ? void 0 : onDelete(image.id);
      }
    }), jsx(Image$1, {
      image: {
        url: image.thumbnailUrl
      },
      onClick: function () {
        if (isEditable) {
          return;
        }

        handleAddImage(image);
      },
      width: '100%',
      height: '100%',
      isActive: true,
      borderRadius: 'small'
    })));
  })));
};

var DEFAULT_BACK_PANEL_ID = '66495';

var defaultBackPanelLabelStyles = {
  color: 'white',
  backgroundColor: '#14f243',
  position: 'absolute',
  zIndex: 2,
  top: 0,
  width: '70%',
  borderRadius: '2px',
  borderTopLeftRadius: '0px',
  borderTopRightRadius: '0px',
  boxShadow: '0 1px 18px -1px #a8a8a8'
};
var defaultBackPanelBorderStyles = {
  borderColor: '#14f243',
  borderWidth: 'bold',
  borderStyle: 'solid'
};

var Layouts = function (_a) {
  var layouts = _a.layouts,
      title = _a.title,
      subtitle = _a.subtitle,
      canDelete = _a.canDelete,
      onDelete = _a.onDelete,
      isOnBackPanel = _a.isOnBackPanel,
      onSetDefaultBackPanel = _a.onSetDefaultBackPanel,
      defaultBackPanelId = _a.defaultBackPanelId,
      onSelectBackLayout = _a.onSelectBackLayout;
  var card = useReduxState('editor').card;
  var actions = useReduxActions();

  var _b = __read(useState(), 2),
      isHoveringId = _b[0],
      setIsHoveringId = _b[1];

  var orientation = card === null || card === void 0 ? void 0 : card.orientation;

  var handleLayout = function (layout) {
    if (isOnBackPanel) {
      onSelectBackLayout === null || onSelectBackLayout === void 0 ? void 0 : onSelectBackLayout(layout.id.toString());
      actions.selectBackPanel(layout);
    } else {
      actions.selectLayout(layout);
    }
  }; // AspectRatio is defined by layout image sizes stored in our servers


  var getAspectRatio = function () {
    if ((card === null || card === void 0 ? void 0 : card.type) === 'POSTCARD') {
      return '735/850';
    } else if (orientation === 'LANDSCAPE') {
      return '14/10';
    } else {
      return '10/14';
    }
  };

  return jsx(Flex, {
    inset: 'x1',
    flexDirection: 'column',
    height: '100%'
  }, title && jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, title), subtitle && jsx(Text, {
    type: "caption",
    weight: "thin"
  }, subtitle), jsx(Div, {
    width: '100%',
    outset: {
      vertical: 'x4'
    }
  }, jsx(Grid, {
    height: '100%',
    columnSize: 42,
    rowSize: 25,
    gap: 16
  }, layouts.map(function (layout) {
    var id = typeof layout.id === 'number' ? layout.id.toString() : layout.id;
    var isHorizontal = orientation === 'LANDSCAPE';
    var isDefaultBackPanel = id === defaultBackPanelId;
    var isDefaultSocBackPanel = layout.id.toString() === DEFAULT_BACK_PANEL_ID;
    return jsx(GridItem, {
      key: id,
      gridColSpan: 2,
      gridRowSpan: isHorizontal ? 2 : 4,
      borderRadius: 'medium',
      aspectRatio: getAspectRatio()
    }, jsx(Div, _extends({}, isDefaultBackPanel ? defaultBackPanelBorderStyles : {}, {
      position: "relative",
      width: "100%",
      height: "100%",
      onHoverStart: function () {
        return setIsHoveringId(id);
      },
      onHoverEnd: function () {
        return setIsHoveringId(undefined);
      }
    }), canDelete && !isDefaultSocBackPanel && jsx(Div, {
      width: "100%",
      height: "100%",
      alignItems: "center",
      position: "absolute",
      zIndex: 1,
      backgroundColor: "#343434b8",
      display: "flex",
      justifyContent: "center",
      borderRadius: "small"
    }, jsx(Span, {
      cursor: "pointer"
    }, jsx(Icon, {
      size: "medium",
      name: "delete",
      primaryColor: "danger",
      onClick: function () {
        return onDelete === null || onDelete === void 0 ? void 0 : onDelete(id);
      }
    }))), isDefaultBackPanel && jsx(Div, {
      display: "flex",
      justifyContent: "center",
      onClick: function () {
        handleLayout(layout);
      }
    }, jsx(Div, isDefaultBackPanel ? defaultBackPanelLabelStyles : {}, jsx(Text, {
      alignment: "center",
      type: "caption",
      color: "inverseBody"
    }, "Default"))), jsx(Image$1, {
      image: layout.thumbnail,
      onClick: function () {
        if (canDelete) {
          return;
        }

        handleLayout(layout);
      },
      width: '100%',
      height: '100%',
      isActive: true,
      borderRadius: 'small'
    }), id === isHoveringId && isOnBackPanel && onSetDefaultBackPanel && id !== defaultBackPanelId && !canDelete && jsx(Div, {
      bottom: "30px",
      zIndex: 2,
      position: "relative",
      display: "flex",
      justifyContent: "center"
    }, jsx(Button, {
      size: "xSmall",
      title: "set as default",
      onClick: function () {
        return onSetDefaultBackPanel(layout.id.toString());
      }
    }))));
  }))));
};

var ClientNavigation = function (_a) {
  var clientNav = _a.clientNav;
  return jsx(React.Fragment, null, jsx(Div, {
    inset: "x1"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Navigation"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Navigate around your sendoutcards account")), jsx(Div, {
    width: "100%",
    inset: "x4"
  }, jsx(VStack, {
    gap: "x2"
  }, clientNav.map(function (navSection) {
    return jsx(React.Fragment, null, jsx(Text, {
      type: "body",
      weight: "bold"
    }, navSection.section.title), jsx(VStack, {
      gap: "x1"
    }, navSection.section.links.map(function (link) {
      return jsx(Div, {
        inset: {
          left: 'x2'
        }
      }, jsx(IconLink, {
        icon: link.icon,
        title: link.title,
        onClick: link.onClick,
        size: "small"
      }));
    })), jsx(Spacer, {
      space: "x2"
    }));
  }))));
};

var Settings = function (_a) {
  var _b;

  var sections = _a.sections,
      startingActiveKey = _a.startingActiveKey;
  var initialActiveKey = (_b = sections.find(function (section) {
    return section.key === startingActiveKey;
  })) === null || _b === void 0 ? void 0 : _b.key;

  var _c = __read(useState([initialActiveKey !== null && initialActiveKey !== void 0 ? initialActiveKey : 'NONE']), 2),
      activeKey = _c[0],
      setActiveKey = _c[1];

  var activeImageSetting = useReduxState('editorChrome').activeImageSetting;
  useEffect(function () {
    var _a;

    setActiveKey([(_a = initialActiveKey !== null && initialActiveKey !== void 0 ? initialActiveKey : activeImageSetting) !== null && _a !== void 0 ? _a : 'NONE']);
  }, [activeImageSetting, initialActiveKey]);

  var onSettingSectionChange = function (section) {
    section.onClick();
    setActiveKey(activeKey[0] === section.key ? ['NONE'] : section.key ? [section.key] : ['NONE']);
  };

  return jsx(Accordion, {
    stateOverride: {
      activeIndexes: activeKey[0] ? activeKey : [-1],
      setActiveIndexes: setActiveKey
    },
    isExclusive: true,
    isHeadingBackgroundInverse: true,
    insetBody: "x_5",
    sections: sections.map(function (section) {
      return {
        heading: jsx(React.Fragment, null, jsx(Flex, null, jsx(HStack, {
          gap: "x1_5",
          justify: "flex-start"
        }, jsx(Flex, {
          alignItems: "center"
        }, jsx(Icon, {
          name: section.icon,
          size: "small",
          primaryColor: section.key === activeKey[0] ? 'primaryBrand' : 'default'
        })), jsx(Flex, {
          alignItems: "center"
        }, jsx(Text, {
          type: "footnote",
          weight: section.key === activeKey[0] ? 'semiBold' : 'regular'
        }, section.title))))),
        key: section.key,
        body: jsx(Div, {
          width: "100%"
        }, section.settings),
        onHeadingClick: function () {
          return onSettingSectionChange(section);
        }
      };
    })
  });
};

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
}

var ElementIncrementSetting = function (_a) {
  var title = _a.title,
      min = _a.min,
      max = _a.max,
      callback = _a.callback,
      initial = _a.initial,
      resetDependency = _a.resetDependency,
      _b = _a.sliderOrigin,
      sliderOrigin = _b === void 0 ? 'left' : _b;

  var _c = __read(useState(initial * 100), 2),
      value = _c[0],
      setValue = _c[1];

  var _d = __read(useState(false), 2),
      isDisabled = _d[0],
      setIsDisabled = _d[1];

  var previousValue = usePrevious(value);

  var _e = useReduxState('editor'),
      activeElement = _e.activeElement,
      panelLocation = _e.panelLocation;

  var handleNoRange = function () {
    setIsDisabled(true);
    setValue(min);
  };

  useEffect(function () {
    if (min === max) {
      handleNoRange();
      return;
    }

    setIsDisabled(false);

    if (previousValue === value) {
      return;
    }

    callback(value / 100);
  }, [value, min, max]); // eslint-disable-line

  useEffect(function () {
    var desiredValue = Math.floor(Math.round(initial * 100));

    if (desiredValue >= min && desiredValue <= max) {
      setValue(desiredValue);
    }
  }, [activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, panelLocation, resetDependency]); // eslint-disable-line

  return jsx(IncrementSetting, {
    sliderOrigin: sliderOrigin,
    isDisabled: isDisabled,
    title: {
      content: title,
      type: 'footnote',
      weight: 'bold'
    },
    min: min,
    max: max,
    value: value,
    setValue: function (value) {
      return setValue(value);
    },
    layout: "inlineBlock"
  });
};

var FontTile = function (_a) {
  var font = _a.font,
      setFont = _a.setFont,
      active = _a.active;
  return jsx(Flex, {
    flexDirection: "row",
    justifyContent: "space-between",
    outset: {
      left: 'x_5'
    },
    onClick: function () {
      return setFont(font.fontName);
    },
    cursor: "pointer"
  }, jsx(Flex, {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'default',
    position: "relative"
  }, jsx("p", {
    css: /*#__PURE__*/css({
      fontFamily: font.fontName,
      textAlign: 'center'
    }, process.env.NODE_ENV === "production" ? "" : ";label:FontTile;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvbnRUaWxlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNVyIsImZpbGUiOiJGb250VGlsZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgeyBGbGV4LCBJY29uIH0gZnJvbSAnQHNlbmRvdXRjYXJkcy9xdWFudHVtLWRlc2lnbi11aSc7XHJcbmV4cG9ydCB2YXIgRm9udFRpbGUgPSBmdW5jdGlvbiAoX2EpIHtcclxuICAgIHZhciBmb250ID0gX2EuZm9udCwgc2V0Rm9udCA9IF9hLnNldEZvbnQsIGFjdGl2ZSA9IF9hLmFjdGl2ZTtcclxuICAgIHJldHVybiAoPEZsZXggZmxleERpcmVjdGlvbj1cInJvd1wiIGp1c3RpZnlDb250ZW50PVwic3BhY2UtYmV0d2VlblwiIG91dHNldD17eyBsZWZ0OiAneF81JyB9fSBvbkNsaWNrPXtmdW5jdGlvbiAoKSB7IHJldHVybiBzZXRGb250KGZvbnQuZm9udE5hbWUpOyB9fSBjdXJzb3I9XCJwb2ludGVyXCI+XG4gICAgICA8RmxleCBqdXN0aWZ5Q29udGVudD17J2NlbnRlcid9IGFsaWduSXRlbXM9eydjZW50ZXInfSBib3JkZXJSYWRpdXM9eydkZWZhdWx0J30gcG9zaXRpb249XCJyZWxhdGl2ZVwiPlxuICAgICAgICA8cCBjc3M9e3sgZm9udEZhbWlseTogZm9udC5mb250TmFtZSwgdGV4dEFsaWduOiAnY2VudGVyJyB9fT5cbiAgICAgICAgICB7Zm9udC5kaXNwbGF5TmFtZX1cbiAgICAgICAgPC9wPlxuICAgICAgPC9GbGV4PlxuICAgICAge2FjdGl2ZSAmJiAoPEZsZXggaW5zZXQ9e3sgaG9yaXpvbnRhbDogJ3hfMjUnLCB0b3A6ICd4XzI1JywgYm90dG9tOiAneDEnIH19IG91dHNldD17eyByaWdodDogJ3hfNScgfX0gYWxpZ25JdGVtcz1cImNlbnRlclwiPlxuICAgICAgICAgIDxJY29uIG5hbWU9XCJjaGVja1wiIHByaW1hcnlDb2xvcj1cInByaW1hcnlIZWFkaW5nVGV4dFwiIHNpemU9XCJ4U21hbGxcIi8+XG4gICAgICAgIDwvRmxleD4pfVxuICAgIDwvRmxleD4pO1xyXG59O1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1Gb250VGlsZS5qc3gubWFwIl19 */")
  }, font.displayName)), active && jsx(Flex, {
    inset: {
      horizontal: 'x_25',
      top: 'x_25',
      bottom: 'x1'
    },
    outset: {
      right: 'x_5'
    },
    alignItems: "center"
  }, jsx(Icon, {
    name: "check",
    primaryColor: "primaryHeadingText",
    size: "xSmall"
  })));
};

var FontFamilyGrid = function (_a) {
  var fonts = _a.fonts,
      onFontChange = _a.onFontChange;

  var _b = __read(useState(''), 2),
      fontSearch = _b[0],
      setFontSearch = _b[1];

  var _c = __read(useState({
    index: -1,
    fontName: ''
  }), 2),
      activeFontIndex = _c[0],
      setActiveFontIndex = _c[1];

  var handleFontChange = function (font, i) {
    onFontChange(font);
    setActiveFontIndex({
      index: i,
      fontName: font
    });
  };

  var mapFontsToTiles = function (font, i) {
    var isMatch = font.displayName.toLowerCase().includes(fontSearch.toLowerCase());
    return isMatch && jsx(ListItem, {
      key: font.fontName,
      orientation: "horizontal"
    }, jsx(FontTile, {
      font: font,
      setFont: function () {
        return handleFontChange(font.fontName, i);
      },
      active: i === activeFontIndex.index
    }));
  };

  var customFonts = fonts.filter(function (font) {
    return font.isCustomFont;
  }).map(mapFontsToTiles);
  return jsx(React.Fragment, null, jsx(Input, {
    isFullWidth: true,
    type: "text",
    value: fontSearch,
    onChange: setFontSearch,
    icon: "search",
    placeholder: "Search Fonts"
  }), jsx(Spacer, {
    space: "x2"
  }), jsx(Tabs, {
    defaultActiveKey: "system",
    height: "400px"
  }, jsx(Tab, {
    title: "System",
    tabKey: "system"
  }, jsx(List, {
    orientation: "vertical",
    alignment: "left"
  }, fonts.filter(function (font) {
    return !font.isCustomFont;
  }).map(mapFontsToTiles))), jsx(Tab, {
    title: "Custom",
    tabKey: "custom"
  }, jsx(List, {
    orientation: "vertical",
    alignment: "left"
  }, customFonts), !customFonts && jsx("div", null, "Add custom fonts here"))));
};

var FontFamilySettings = function () {
  var actions = useReduxActions();
  var fonts = useContext(EditorChromeContext).fonts;
  return jsx(FontFamilyGrid, {
    fonts: fonts,
    onFontChange: actions.selectFontFamily
  });
};

var alignmentOptions = [{
  icon: 'alignLeft',
  alignment: 'LEFT'
}, {
  icon: 'alignCenter',
  alignment: 'CENTER'
}, {
  icon: 'alignRight',
  alignment: 'RIGHT'
}];

var AlignmentSettings = function () {
  var actions = useReduxActions();

  var _a = __read(useState(-1), 2),
      selectedAlignmentIndex = _a[0],
      setSelectedAlignmentIndex = _a[1];

  var onAlignmentChange = function (alignment, index) {
    actions.selectTextAlign(alignment);
    setSelectedAlignmentIndex(index);
  };

  return jsx(VStack, {
    gap: "x1"
  }, jsx(Text, {
    type: "footnote"
  }, "Alignment:"), jsx(HStack, {
    gap: "x5",
    justify: "flex-start"
  }, alignmentOptions.map(function (option, index) {
    return jsx(IconLink, {
      key: option.alignment + " " + index,
      icon: option.icon,
      onClick: function () {
        return onAlignmentChange(option.alignment, index);
      },
      activeColor: "primaryBrand",
      isActive: index === selectedAlignmentIndex
    });
  })));
};

var useOutsideClick = function (ref, shouldIgnoreClick, handleClick) {
  useEffect(function () {
    if (!ref || shouldIgnoreClick) {
      return;
    }

    var handleClickOutside = function (event) {
      if ((event === null || event === void 0 ? void 0 : event.target) instanceof Node && ref.current && !ref.current.contains(event.target)) {
        handleClick();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
};

var ColorPicker = function (_a) {
  var _b;

  var defaultColor = _a.defaultColor,
      onColorChange = _a.onColorChange,
      canRemoveColor = _a.canRemoveColor,
      isChangingBackground = _a.isChangingBackground;

  var _c = __read(useState(!isChangingBackground), 2),
      showColorPicker = _c[0],
      setShowColorPicker = _c[1];

  var strDefaultColor = defaultColor ? Color(defaultColor).hex() : '';
  var colorPalettes = useContext(EditorChromeContext).colorPalettes;

  var rgbToHex = function (r, g, b) {
    return '#' + [r, g, b].map(function (x) {
      return x.toString(16).padStart(2, '0');
    }).join('');
  };

  var convertedDefaultColor = defaultColor ? rgbToHex(defaultColor.r, defaultColor.g, defaultColor.b) : '#fff';

  var _d = __read(useState(convertedDefaultColor), 2),
      color = _d[0],
      setColor = _d[1];

  var editor = useReduxState('editor');
  var selectedPanel$1 = selectedPanel(editor);
  var colorPickerRef = useRef(null);
  useOutsideClick(colorPickerRef, !showColorPicker || !isChangingBackground, function () {
    return setShowColorPicker(false);
  });

  var handleRemoveColor = function () {
    onColorChange(null);
    setColor('#FFFFFF');
    setShowColorPicker(false);
  };

  useEffect(function () {
    if (convertedDefaultColor !== color) {
      setColor(strDefaultColor);
    }
  }, [convertedDefaultColor]); //eslint-disable-line

  return jsx(Div, {
    ref: colorPickerRef
  }, jsx(VStack, {
    gap: "x2",
    inset: {
      horizontal: 'x1'
    }
  }, isChangingBackground && jsx(SettingInput, {
    inactiveTitle: "Add...",
    onRemove: function () {
      return handleRemoveColor();
    },
    settingsType: 'color',
    value: (selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.backgroundColor) ? Color(selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.backgroundColor).hex() : '#FFFFFF',
    onClick: function () {
      return setShowColorPicker(!showColorPicker);
    }
  }), showColorPicker && jsx(QuantumColorPicker, {
    color: color,
    onChange: function (color) {
      return setColor(color);
    },
    convertedColorType: "rgb",
    convertedColorCallback: function (color) {
      return onColorChange(color);
    },
    palette: {
      title: 'Card Colors',
      isLoading: colorPalettes === null || colorPalettes === void 0 ? void 0 : colorPalettes.isLoading,
      colors: (_b = colorPalettes === null || colorPalettes === void 0 ? void 0 : colorPalettes.palette) === null || _b === void 0 ? void 0 : _b.map(function (palette) {
        return Color(palette).hex();
      })
    }
  }), canRemoveColor && jsx(Button, {
    onClick: handleRemoveColor,
    title: "Remove Color",
    outlined: true,
    size: "xSmall",
    hover: true
  })));
};

var InsertSettings = function (_a) {
  var onInsertSignature = _a.onInsertSignature,
      onInsertPlaceholder = _a.onInsertPlaceholder;

  var _b = useContext(EditorChromeContext),
      placeholders = _b.placeholders,
      signatures = _b.signatures;

  return jsx(Flex, null, jsx(Tabs, {
    defaultActiveKey: "signatures",
    height: '400px'
  }, jsx(Tab, {
    tabKey: "signatures",
    title: "Signatures"
  }, signatures ? jsx(List, {
    orientation: "vertical",
    alignment: "left"
  }, signatures.map(function (signature) {
    return jsx(ListItem, {
      inset: "x1",
      orientation: "vertical",
      onClick: function () {
        return onInsertSignature(signature.fontName);
      }
    }, jsx("span", {
      key: signature.fontName,
      css: /*#__PURE__*/css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n                        cursor: pointer;\n                        font-family: ", ";\n                        font-size: 40;\n                        padding: 16px 0;\n                      " + (process.env.NODE_ENV === "production" ? "" : ";label:InsertSettings;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n                        cursor: pointer;\n                        font-family: ", ";\n                        font-size: 40;\n                        padding: 16px 0;\n                      " + (process.env.NODE_ENV === "production" ? "" : ";label:InsertSettings;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), signature.fontName)
    }, "\xE6"));
  })) : jsx(Text, {
    type: "body"
  }, "You don't have any signatures")), jsx(Tab, {
    tabKey: "placeholder",
    title: "Placeholders"
  }, jsx(List, {
    alignment: "left",
    orientation: "vertical"
  }, placeholders === null || placeholders === void 0 ? void 0 : placeholders.map(function (placeholder) {
    return jsx(ListItem, {
      onClick: function () {
        return onInsertPlaceholder(placeholder);
      },
      inset: "x1",
      orientation: "vertical",
      key: placeholder,
      cursor: "pointer"
    }, jsx(Text, {
      color: "primaryHeading",
      type: "body"
    }, placeholder));
  })))));
};
var templateObject_1$1;

var casingOptions = [{
  icon: 'uppercaseText',
  casing: 'uppercase'
}, {
  icon: 'lowercaseText',
  casing: 'lowercase'
}, {
  icon: 'capitalizedText',
  casing: 'capitalize'
}];
var CasingSettings = function (_a) {
  var onTextCasingUpdate = _a.onTextCasingUpdate,
      originalText = _a.originalText;

  var _b = __read(useState(null), 2),
      activeCasing = _b[0],
      setActiveCasing = _b[1];

  var isUpperCase = function (words) {
    return words === words.toUpperCase();
  };

  var isLowerCase = function (words) {
    return words === words.toLowerCase();
  };

  var isCapitalized = function (words) {
    var capitalizedWords = words.split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
    return words === capitalizedWords;
  };

  useEffect(function () {
    if (isUpperCase(originalText)) {
      setActiveCasing('uppercase');
    } else if (isLowerCase(originalText)) {
      setActiveCasing('lowercase');
    } else if (isCapitalized(originalText)) {
      setActiveCasing('capitalize');
    } else {
      setActiveCasing(null);
    }
  }, [originalText]);
  return jsx(VStack, {
    gap: "x1"
  }, jsx(Text, {
    type: "footnote"
  }, "Casing:"), jsx(HStack, {
    gap: "x5",
    justify: "flex-start"
  }, casingOptions.map(function (option, index) {
    return jsx(IconLink, {
      key: option.casing + " " + index,
      icon: option.icon,
      onClick: function () {
        return onTextCasingUpdate(option.casing);
      },
      activeColor: "primaryBrand",
      isActive: activeCasing === option.casing
    });
  })));
};

var DEFAULT_FONT_SIZE = 16;

var TextSettings = function () {
  var actions = useReduxActions();
  var editor = useReduxState('editor'); // const activeElement = editor.activeElement

  var selectedElement$1 = selectedElement(editor);
  var textState$1 = textState(editor);
  var color = selectedColor(textState$1);
  var fontSize = selectedFontSize(textState$1);
  var text = selectedText(textState$1);
  return selectedElement$1 ? jsx(Flex, {
    inset: "x1",
    flexDirection: "column",
    height: "100%"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Text Settings:"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Apply the following setting to your selected text"), jsx(Div, {
    outset: {
      vertical: 'auto'
    }
  }, jsx(Settings, {
    sections: [{
      title: 'Font Family',
      onClick: function () {
        return actions.setActiveTextSetting('alignment');
      },
      icon: 'aText',
      settings: jsx(FontFamilySettings, null),
      key: 'alignment'
    }, {
      title: 'Settings',
      onClick: function () {
        return actions.setActiveTextSetting('alignment');
      },
      icon: 'fontSize',
      key: 'font_size',
      settings: jsx(VStack, {
        gap: "x2"
      }, jsx(Div, null, jsx(ElementIncrementSetting, {
        initial: fontSize ? fontSize / 100 : DEFAULT_FONT_SIZE / 100,
        title: "Size:",
        min: 8,
        max: 80,
        callback: function (value) {
          actions.selectFontSize(value * 100);
        },
        resetDependency: fontSize
      })), jsx(AlignmentSettings, null), jsx(CasingSettings, {
        originalText: text !== null && text !== void 0 ? text : '',
        onTextCasingUpdate: actions.updateTextCasing
      }))
    }, {
      title: 'Color',
      onClick: function () {
        return actions.setActiveTextSetting('casing');
      },
      icon: 'colorPalette',
      key: 'color',
      settings: jsx(Div, {
        outset: {
          vertical: 'x3'
        }
      }, jsx(ColorPicker, {
        defaultColor: color || {
          r: 51,
          b: 51,
          g: 51
        },
        onColorChange: function (color) {
          return actions.selectColor(color);
        }
      }))
    }, // TODO Discuss whether we want keep slider for rotate in layout/text settings
    // As of now is fairly problematic with moveable
    // {
    //   title: 'Rotate',
    //   onClick: () => actions.setActiveTextSetting('rotate'),
    //   icon: 'rotateRight',
    //   key: 'rotate',
    //   settings: (
    //     <Div inset={{ bottom: 'x3' }}>
    //       <ElementIncrementSetting
    //         title={'Rotation Degrees'}
    //         initial={selectedElement.rotation / 100}
    //         callback={value =>
    //           actions.updateElementRotation(
    //             activeElement?.location,
    //             value * 100,
    //           )
    //         }
    //         min={-360}
    //         max={360}
    //         sliderOrigin="center"
    //       />
    //     </Div>
    //   ),
    // },
    {
      title: 'Insert',
      onClick: function () {
        return actions.setActiveTextSetting('casing');
      },
      icon: 'signature',
      key: 'insert',
      settings: jsx(InsertSettings, {
        onInsertPlaceholder: actions.insertPlaceholder,
        onInsertSignature: actions.insertSignature
      })
    }]
  }))) : jsx("div", null, "There is no current text element selected");
};

var PanelElementSidebar = function (_a) {
  var helpIcon = _a.helpIcon,
      isPreviewMode = _a.isPreviewMode,
      panelOptions = _a.panelOptions;

  var _b = __read(useState(-1), 2),
      sidebarHoverIndex = _b[0],
      setSidebarHoverIndex = _b[1];

  var _c = useReduxState('editorChrome'),
      isElementInsertOpen = _c.isElementInsertOpen,
      elementInsertDrawerType = _c.elementInsertDrawerType;

  var actions = useReduxActions();
  var tooltipVariants = {
    hoverOn: {
      opacity: 1
    },
    hoverOff: {
      opacity: 0
    }
  };
  return jsx(Sidebar, {
    position: "left",
    zIndex: 6,
    width: "70px"
  }, jsx(Div, {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column"
  }, jsx(Section, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  }, jsx(Span, {
    inset: {
      vertical: 'x2'
    }
  }, jsx(Icon, {
    name: 'socLogo',
    size: "medium",
    primaryColor: "primaryBrand"
  })), jsx(Span, null, jsx(IconLink, {
    icon: "hamburger",
    fill: 'primaryBodyText',
    size: "small",
    onClick: function () {
      return isElementInsertOpen && elementInsertDrawerType === 'clientNav' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('clientNav');
    }
  }))), jsx(AnimatePresence, null, !isPreviewMode && jsx(Flex, {
    flexDirection: "column",
    alignItems: "center"
  }, panelOptions.map(function (option, index) {
    return jsx(Div, {
      exit: {
        opacity: 0,
        x: -70
      },
      initial: {
        opacity: 0,
        x: -70
      },
      animate: {
        opacity: 1,
        x: 0
      },
      transition: {
        duration: 0.3
      },
      "data-feature": option.dataFeature
    }, jsx(Flex, {
      key: index,
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      onHoverStart: function () {
        setSidebarHoverIndex(index + 1);
      },
      onHoverEnd: function () {
        return setSidebarHoverIndex(-1);
      }
    }, jsx(IconLink, {
      hasBackgroundColor: option.isActive,
      onClick: option.onClick,
      icon: option.icon,
      title: option.title,
      size: "small",
      isStacked: true,
      isActive: option.isActive
    }), sidebarHoverIndex === index + 1 && jsx(Flex, {
      position: "absolute",
      left: "75px",
      variants: tooltipVariants,
      animate: sidebarHoverIndex ? 'hoverOn' : 'hoverOff',
      initial: 'hoverOff',
      transition: {
        ease: 'easeIn',
        duration: 0.2
      }
    }, jsx(Tooltip, {
      direction: "left",
      title: "Add " + option.title,
      background: "dark"
    }))), jsx(Spacer, {
      space: 'x4'
    }));
  }))), jsx(Section, null, helpIcon)));
};

var ChromeSidebar = function (_a) {
  var helpIcon = _a.helpIcon,
      isPreviewMode = _a.isPreviewMode;

  var _b = useReduxState('editorChrome'),
      isElementInsertOpen = _b.isElementInsertOpen,
      elementInsertDrawerType = _b.elementInsertDrawerType;

  var actions = useReduxActions();
  var panelOptions = [{
    title: 'Image',
    icon: 'image',
    onClick: function () {
      isElementInsertOpen && elementInsertDrawerType === 'images' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('images');
    },
    isActive: elementInsertDrawerType === 'images' && isElementInsertOpen
  }, {
    title: 'Text',
    icon: 'textBox',
    onClick: function () {
      actions.setShouldReplaceSelectedImage(false);
      actions.addTextElement();
      actions.closeElementInsertDrawer();
      actions.openElementSettingsDrawer('text');
    }
  }, {
    title: 'Stickers',
    icon: 'stickers',
    onClick: function () {
      isElementInsertOpen && elementInsertDrawerType === 'stickers' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('stickers');
    },
    isActive: elementInsertDrawerType === 'stickers' && isElementInsertOpen,
    dataFeature: 'stickers'
  }, {
    title: 'Template',
    icon: 'template',
    onClick: function () {
      isElementInsertOpen && elementInsertDrawerType === 'layouts' ? actions.closeElementInsertDrawer() : actions.openElementInsertDrawer('layouts');
    },
    isActive: elementInsertDrawerType === 'layouts' && isElementInsertOpen
  }];
  return jsx(PanelElementSidebar, {
    helpIcon: helpIcon,
    panelOptions: panelOptions,
    isPreviewMode: isPreviewMode
  });
};

var CropSettings = function (_a) {
  var scale = _a.scale,
      x = _a.x,
      y = _a.y,
      onSelectImagePosition = _a.onSelectImagePosition,
      onSelectImageScale = _a.onSelectImageScale;
  return jsx(Flex, {
    flexDirection: "column",
    inset: {
      bottom: 'x3'
    }
  }, jsx(VStack, {
    gap: "x2"
  }, jsx(Div, null, jsx(ElementIncrementSetting, {
    title: 'Horizontal: X',
    initial: x,
    min: 0,
    max: 100,
    callback: function (value) {
      return onSelectImagePosition(value, undefined);
    },
    resetDependency: x
  })), jsx(Div, null, jsx(ElementIncrementSetting, {
    title: 'Vertical: Y',
    initial: y,
    min: 0,
    max: 100,
    callback: function (value) {
      return onSelectImagePosition(undefined, value);
    },
    resetDependency: y
  })), jsx(Div, null, jsx(ElementIncrementSetting, {
    title: 'Scale',
    initial: scale !== null && scale !== void 0 ? scale : 1,
    min: 50,
    max: 500,
    callback: function (value) {
      return onSelectImageScale(value);
    },
    resetDependency: scale
  }))));
};

var BackgroundImageUploader = function (_a) {
  var _b, _c, _d;

  var images = _a.images;
  var actions = useReduxActions();
  var editor = useReduxState('editor');

  var _e = useReduxState('editorChrome'),
      activeImageSetting = _e.activeImageSetting,
      hasUploadedImage = _e.hasUploadedImage;

  var selectedPanel$1 = selectedPanel(editor);
  var backgroundImage = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.elements.find(function (element) {
    var _a;

    return element.isFullPanel && ((_a = element === null || element === void 0 ? void 0 : element.image) === null || _a === void 0 ? void 0 : _a.image);
  });

  var _f = __read(useState(false), 2),
      showUploader = _f[0],
      setShowUploader = _f[1];

  var _g = __read(useState((_d = (_c = (_b = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.url) !== null && _d !== void 0 ? _d : null), 2),
      backgroundUrl = _g[0],
      setBackgroundUrl = _g[1];

  var handleRemoveBackgroundImage = useCallback(function () {
    var _a;

    if ((_a = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _a === void 0 ? void 0 : _a.image) {
      actions.selectImage(backgroundImage.image.image);
      actions.removeElement();
      setBackgroundUrl('');
      setShowUploader(false);
    }
  }, [actions, backgroundImage]);
  useEffect(function () {
    var _a, _b, _c, _d;

    setBackgroundUrl((_c = (_b = (_a = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : '');

    if ((_d = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _d === void 0 ? void 0 : _d.image) {
      actions.setActiveImageSetting('crop');
    }
  }, [backgroundImage, actions]);
  useEffect(function () {
    actions.setShouldReplaceSelectedImage(showUploader);
  }, [showUploader, actions]);
  useEffect(function () {
    if (hasUploadedImage) {
      var uploadedImage = images.results[0];

      if (uploadedImage) {
        setBackgroundUrl(uploadedImage.url);
        handleRemoveBackgroundImage();
        actions.addImageElement(uploadedImage, true);
        actions.setHasUploadedImage(false);
        actions.toggleImageUploaderWidget();
        actions.setActiveImageSetting('crop');
      }
    }
  }, [images, actions, hasUploadedImage, actions.setHasUploadedImage, handleRemoveBackgroundImage]);
  return jsx(VStack, {
    gap: "x2",
    inset: {
      horizontal: 'x1'
    }
  }, jsx(SettingInput, {
    inactiveTitle: "Add...",
    onRemove: function () {
      return handleRemoveBackgroundImage();
    },
    settingsType: "image",
    value: backgroundUrl,
    onClick: function () {
      return actions.toggleImageUploaderWidget();
    }
  }), jsx(React.Fragment, null, (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) && activeImageSetting === 'crop' && jsx(Div, null, jsx(Text, {
    type: "caption",
    outset: {
      top: 'x3',
      bottom: 'x1'
    }
  }, "Crop Background Settings"), jsx(CropSettings, {
    onSelectImagePosition: actions.selectImagePosition,
    onSelectImageScale: actions.selectImageScale,
    x: backgroundImage.image.position.x,
    y: backgroundImage.image.position.y,
    scale: backgroundImage.image.scale
  }))));
};

var PanelSettings = function (_a) {
  var _b;

  var images = _a.images,
      onUploadImages = _a.onUploadImages;
  var editor = useReduxState('editor');
  var isPanelBackgroundImage = editor.activeElement.type === 'image' && editor.editing === 'element';
  var selectedPanel$1 = selectedPanel(editor);
  var actions = useReduxActions();
  return jsx(Flex, {
    inset: "x1",
    flexDirection: "column",
    height: "100%"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Panel Settings"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Adjust the background of your panel"), jsx(Div, {
    position: "relative"
  }, jsx(Settings, {
    startingActiveKey: "background_settings",
    sections: [{
      title: 'Background Settings',
      onClick: function () {},
      icon: 'colorPalette',
      key: 'background_settings',
      settings: jsx(Div, null, jsx(ColorPicker, {
        defaultColor: (_b = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.backgroundColor) !== null && _b !== void 0 ? _b : undefined,
        onColorChange: function (color) {
          return actions.setPanelBackground(color);
        },
        isChangingBackground: true
      }), jsx(Spacer, {
        space: "x4"
      }), jsx(BackgroundImageUploader, {
        images: images,
        onUploadImages: onUploadImages
      }))
    }]
  }), isPanelBackgroundImage && jsx(React.Fragment, null)));
};

var ImageSettings = function (props) {
  var title = props.title,
      subtitle = props.subtitle,
      imageScale = props.imageScale,
      imageX = props.imageX,
      imageY = props.imageY,
      onSelectImagePosition = props.onSelectImagePosition,
      onSelectImageScale = props.onSelectImageScale,
      isLayoutElement = props.isLayoutElement;
  var activeImageSetting = useReduxState('editorChrome').activeImageSetting;
  var actions = useReduxActions();
  var nonLayoutElementSections = [// {
    //   title: 'Layout',
    //   onClick: () => setActiveImageSetting(null),
    //   icon: 'sliderHorizontal',
    //   settings: (
    //     <LayoutSettings
    //       width={elementWidth}
    //       height={elementHeight}
    //       x={elementX}
    //       y={elementY}
    //       location={location}
    //       onUpdatePosition={onUpdatePosition}
    //       onUpdateSize={onUpdateSize}
    //     />
    //   ),
    // },
    // {
    //   title: 'Rotate',
    //   icon: 'cropRotate',
    //   onClick: () => setActiveImageSetting(null),
    //   settings: (
    //     <RotateSettings
    //       location={location}
    //       rotation={elementRotation}
    //       onUpdateRotation={onUpdateRotation}
    //     />
    //   ),
    // },
  ];
  var layoutElementSections = [{
    title: 'Crop',
    key: 'crop',
    onClick: activeImageSetting === 'crop' ? function () {
      return actions.setActiveImageSetting(null);
    } : function () {
      return actions.setActiveImageSetting('crop');
    },
    icon: 'crop',
    settings: jsx(CropSettings, {
      onSelectImagePosition: onSelectImagePosition,
      onSelectImageScale: onSelectImageScale,
      x: imageX,
      y: imageY,
      scale: imageScale
    })
  }];
  return jsx(Flex, {
    inset: "x1",
    flexDirection: "column",
    height: "100%"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, title), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, subtitle), jsx(Div, {
    outset: {
      vertical: 'auto'
    }
  }, jsx(Settings, {
    sections: !isLayoutElement ? __spread(nonLayoutElementSections, layoutElementSections) : __spread(layoutElementSections)
  })));
};

var FullBleedSettings = function () {
  var _a;

  var editor = useReduxState('editor');
  var selectedFullBleed$1 = selectedFullBleed(editor);
  var backgroundElement = selectedFullBleed$1 === null || selectedFullBleed$1 === void 0 ? void 0 : selectedFullBleed$1.backgroundElement;
  var fullBleedLocation = editor.fullBleedLocation;
  var actions = useReduxActions();
  return jsx(VStack, {
    gap: "x3"
  }, ((_a = backgroundElement === null || backgroundElement === void 0 ? void 0 : backgroundElement.image) === null || _a === void 0 ? void 0 : _a.image) ? jsx(ImageSettings, {
    title: "Background Image Settings:",
    subtitle: "Apply the following settings to your background image",
    location: fullBleedLocation !== null && fullBleedLocation !== void 0 ? fullBleedLocation : 0,
    elementY: backgroundElement.y,
    elementX: backgroundElement.x,
    elementHeight: backgroundElement.height,
    elementWidth: backgroundElement.width,
    elementRotation: backgroundElement.rotation,
    imageY: backgroundElement.image.position.y,
    imageX: backgroundElement.image.position.x,
    imageScale: backgroundElement.image.scale,
    onUpdateSize: function (_location, width, height) {
      return actions.updateFullBleedBackgroundElementSize(width, height);
    },
    onUpdateRotation: function (_location, rotation) {
      return actions.updateFullBleedBackgroundElementRotation(rotation);
    },
    onUpdatePosition: function (_location, x, y) {
      return actions.updateFullBleedBackgroundElementPosition(x, y);
    },
    onSelectImageScale: actions.updateFullBleedBackgroundImageScale,
    onSelectImagePosition: actions.updateFullBleedBackgroundImagePosition,
    isLayoutElement: false
  }) : jsx(Text, {
    type: "body"
  }, "There is no background image"));
};

var ImageElementSettings = function () {
  var _a, _b, _c, _d, _e, _f, _g;

  var editor = useReduxState('editor');
  var activeElement = editor.activeElement;
  var selectedElement$1 = selectedElement(editor);
  var actions = useReduxActions();
  var scale = selectedElement$1 ? (_b = (_a = selectedElement$1.image) === null || _a === void 0 ? void 0 : _a.scale) !== null && _b !== void 0 ? _b : 1 : 0;
  var x = selectedElement$1 ? (_d = (_c = selectedElement$1.image) === null || _c === void 0 ? void 0 : _c.position.x) !== null && _d !== void 0 ? _d : 0.5 : 0;
  var y = selectedElement$1 ? (_f = (_e = selectedElement$1.image) === null || _e === void 0 ? void 0 : _e.position.y) !== null && _f !== void 0 ? _f : 0.5 : 0;
  var rotation = selectedElement$1 ? selectedElement$1.rotation : 0;
  var location = (_g = activeElement.location) !== null && _g !== void 0 ? _g : 0;
  return selectedElement$1 ? jsx(ImageSettings, {
    title: 'Image Settings',
    subtitle: 'Apply the following setting to your selected image',
    location: location,
    imageScale: scale,
    imageX: x,
    imageY: y,
    elementRotation: rotation,
    elementHeight: selectedElement$1.height,
    elementWidth: selectedElement$1.width,
    elementX: selectedElement$1.x,
    elementY: selectedElement$1.y,
    isLayoutElement: !selectedElement$1.draggable || false,
    onSelectImagePosition: actions.selectImagePosition,
    onSelectImageScale: actions.selectImageScale,
    onUpdatePosition: actions.updateElementPosition,
    onUpdateRotation: actions.updateElementRotation,
    onUpdateSize: actions.updateElementSize
  }) : jsx("div", null, "You don't have an image selected");
};

var useWindowSize = function () {
  var isClient = typeof window === 'object';
  var getSize = useCallback(function () {
    return {
      width: isClient ? window.innerWidth : 0,
      height: isClient ? window.innerHeight : 0
    };
  }, [isClient]);

  var _a = __read(useState(getSize), 2),
      windowSize = _a[0],
      setWindowSize = _a[1];

  useEffect(function () {
    if (!isClient) {
      return;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [getSize, isClient]);
  var width = windowSize.width,
      height = windowSize.height;
  return {
    width: width,
    height: height
  };
};

var TabWrapper = function (props) {
  return jsx(Div, {
    height: "calc(100vh - " + (props.heightOffset - 2) + "px)",
    overflow: "auto",
    position: "relative"
  }, props.children);
};

var BackPanels = function (_a) {
  var defaultBackPanels = _a.defaultBackPanels,
      customBackPanels = _a.customBackPanels,
      onDelete = _a.onDelete,
      onSelectBackLayout = _a.onSelectBackLayout,
      onSetDefaultBackPanel = _a.onSetDefaultBackPanel,
      defaultBackPanelId = _a.defaultBackPanelId;

  var _b = useResizeObserver(),
      ref = _b.ref,
      height = _b.height;

  var _c = useResizeObserver(),
      defaultBackPanelWrapperRef = _c.ref,
      defaultBackPanelWrapperHeight = _c.height;

  var _d = useResizeObserver(),
      customBackPanelWrapperRef = _d.ref,
      customBackPanelWrapperHeight = _d.height;

  var windowHeight = useWindowSize().height;

  var _e = __read(useState(false), 2),
      canDelete = _e[0],
      setCanDelete = _e[1];

  var heightOffset = height ? height + 96 : 0;
  /* Passing true to the InfiniteScroller initialLoad prop causes infinite re render issues. The InfiniteScroller also does not re fetch unless
     an overflow exists on the parent and user scrolls to the bottom. This can cause issues on larger monitors if client only
     fetches a handful of backpanels that do not fill up the whole drawer. The below fix measures the layout grid container and continues
     to loadMore until an overflow exists on the drawer and InfiniteScroller can handle the remaining fetches.
  */

  var shouldFetchMore = useCallback(function (defaultHeight, backpanel) {
    if (typeof heightOffset === 'number' && typeof windowHeight === 'number' && typeof defaultHeight === 'number') {
      var shouldFetchMore_1 = defaultHeight < windowHeight - heightOffset;

      if (backpanel.hasMore && shouldFetchMore_1) {
        backpanel.loadMore();
      }
    }
  }, [heightOffset, windowHeight]); // Watch for height changes in defaultBackPanels drawer

  useEffect(function () {
    shouldFetchMore(defaultBackPanelWrapperHeight, defaultBackPanels);
  }, [defaultBackPanelWrapperHeight, shouldFetchMore]); //eslint-disable-line
  // Watch for height changes in customBackPanels drawer

  useEffect(function () {
    shouldFetchMore(customBackPanelWrapperHeight, customBackPanels);
  }, [customBackPanelWrapperHeight, shouldFetchMore]); //eslint-disable-line

  return jsx(React.Fragment, null, jsx(VStack, {
    gap: "x2"
  }, jsx(Div, {
    ref: ref
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Add a back Panel"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Select from an existing back panel or create a new one")), jsx(Tabs, {
    height: "100%",
    defaultActiveKey: "new"
  }, jsx(Tab, {
    tabKey: "new",
    title: "Create New"
  }, jsx(TabWrapper, {
    heightOffset: heightOffset
  }, jsx(InfiniteScroller, {
    hasMore: defaultBackPanels.hasMore,
    isLoadingMore: defaultBackPanels.isLoadingMore,
    loader: jsx(Div, {
      inset: "x8"
    }, jsx(LoadingSpinner, {
      size: "xLarge"
    })),
    loadMore: defaultBackPanels.loadMore,
    isScrollingOnWindow: false
  }, jsx(Div, {
    ref: defaultBackPanelWrapperRef
  }, jsx(Layouts, {
    isOnBackPanel: true,
    layouts: defaultBackPanels.results,
    onSelectBackLayout: onSelectBackLayout
  }))))), jsx(Tab, {
    tabKey: "custom",
    title: "View Saved"
  }, jsx(TabWrapper, {
    heightOffset: heightOffset
  }, jsx(Div, {
    position: "absolute",
    top: '0px',
    left: "0px",
    inset: {
      left: 'x1'
    },
    display: "flex"
  }, jsx(Button, {
    size: "xSmall",
    type: "primary",
    onClick: function () {
      return setCanDelete(!canDelete);
    },
    outlined: !canDelete ? false : true
  }, !canDelete ? 'Delete' : 'Finished Deleting'), jsx(Spacer, {
    space: "x2",
    orientation: "horizontal"
  })), jsx(InfiniteScroller, {
    hasMore: customBackPanels.hasMore,
    isLoadingMore: customBackPanels.isLoadingMore,
    loader: jsx(Div, {
      inset: "x8"
    }, jsx(LoadingSpinner, {
      size: "xLarge"
    })),
    loadMore: customBackPanels.loadMore,
    isScrollingOnWindow: false
  }, jsx(Div, {
    ref: customBackPanelWrapperRef
  }, jsx(Layouts, {
    onSetDefaultBackPanel: onSetDefaultBackPanel,
    defaultBackPanelId: defaultBackPanelId,
    isOnBackPanel: true,
    layouts: customBackPanels.results,
    canDelete: canDelete,
    onDelete: onDelete,
    onSelectBackLayout: onSelectBackLayout
  }))))))));
};

var ChromeUndoRedo = function () {
  var actions = useReduxActions();

  var _a = __read(useState(-1), 2),
      undoRedoTooltip = _a[0],
      setUndoRedoTooltip = _a[1];

  var handleKeyDown = function (event) {
    var isMetaOrCtrl = event.metaKey || event.ctrlKey;
    var isShift = event.shiftKey;

    if (event.key === 'z' && isMetaOrCtrl && isShift || event.key === 'y' && isMetaOrCtrl) {
      actions.editorRedo();
    }

    if (event.key === 'z' && isMetaOrCtrl) {
      actions.editorUndo();
    }
  };

  useEffect(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });
  return jsx(Flex, {
    position: "absolute"
  }, jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setUndoRedoTooltip(1);
    },
    onHoverEnd: function () {
      return setUndoRedoTooltip(-1);
    }
  }, jsx(IconLink, {
    onClick: function () {
      return actions.editorUndo();
    },
    icon: 'undo',
    size: "small",
    fill: "primaryHeadingText"
  })), jsx(Spacer, {
    orientation: "horizontal",
    space: "x2"
  }), jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setUndoRedoTooltip(2);
    },
    onHoverEnd: function () {
      return setUndoRedoTooltip(-1);
    }
  }, jsx(IconLink, {
    onClick: function () {
      return actions.editorRedo();
    },
    icon: 'redo',
    size: "small",
    fill: "primaryHeadingText"
  })), undoRedoTooltip >= 1 && jsx(Flex, {
    position: "absolute",
    top: "-60px",
    left: undoRedoTooltip === 1 ? '-12px' : undefined,
    right: undoRedoTooltip === 2 ? '-12px' : undefined,
    animate: undoRedoTooltip ? {
      opacity: 1
    } : {
      opacity: 0
    },
    initial: 'hoverOff',
    transition: {
      ease: 'easeIn',
      duration: 0.2
    }
  }, jsx(Tooltip, {
    background: "dark",
    direction: "bottom",
    title: undoRedoTooltip === 1 ? 'Undo' : 'Redo'
  })));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "nfd03i",
  styles: "margin-right:1rem"
} : {
  name: "f16xme-ChromeBottomBar",
  styles: "margin-right:1rem;label:ChromeBottomBar;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var ChromeBottomBar = function (_a) {
  var _b, _c;

  var contextZones = _a.contextZones,
      saveActions = _a.saveActions,
      height = _a.height,
      zIndex = _a.zIndex,
      xOffset = _a.xOffset,
      isPreviewMode = _a.isPreviewMode;

  var _d = __read(useState(false), 2),
      isSaveContextExpanded = _d[0],
      setIsSaveContextExpanded = _d[1];

  var actions = useReduxActions();
  return jsx(Flex, {
    width: "100%",
    height: height,
    backgroundColor: "foreground",
    position: "fixed",
    bottom: "0px",
    justifyContent: "center",
    alignItems: "center",
    zIndex: zIndex,
    inset: {
      left: xOffset + "px"
    }
  }, jsx(Flex, {
    width: "calc(100% / 3)",
    justifyContent: "center",
    alignItems: "center"
  }, contextZones.secondary), jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    width: "calc(100% / 3)"
  }, jsx(AnimatePresence, null, !isPreviewMode && jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    exit: {
      opacity: 0,
      y: 70
    },
    initial: {
      opacity: 0,
      y: 70
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3
    }
  }, jsx(ChromeUndoRedo, null)))), jsx(Flex, {
    width: "calc(100% / 3)",
    justifyContent: "center",
    alignItems: "center",
    inset: {
      right: 'x2'
    }
  }, jsx(Div, {
    css: _ref
  }, jsx(ButtonWithMenu, {
    menuLocation: "top",
    menuOptions: contextZones.save ? __spread(contextZones.save.options, saveActions) : __spread(saveActions),
    isExpanded: isSaveContextExpanded,
    isLoading: (_b = contextZones === null || contextZones === void 0 ? void 0 : contextZones.save) === null || _b === void 0 ? void 0 : _b.isLoading,
    loadingMessage: (_c = contextZones === null || contextZones === void 0 ? void 0 : contextZones.save) === null || _c === void 0 ? void 0 : _c.loadingMessage,
    onClick: function () {
      return setIsSaveContextExpanded(!isSaveContextExpanded);
    },
    title: 'Save',
    size: "xSmall",
    fullWidth: true,
    type: "shadow",
    outlined: true
  })), jsx("div", {
    onClick: function () {
      return actions.saveAndSend();
    }
  }, contextZones === null || contextZones === void 0 ? void 0 : contextZones.primary), contextZones.externalActions));
};

var ChromePill = function () {
  var editor = useReduxState('editor');
  var editing = editor.editing,
      activeElement = editor.activeElement;
  var selectedFullBleed$1 = selectedFullBleed(editor);
  var selectedPanel$1 = selectedPanel(editor);
  var selectedElement$1 = selectedElement(editor);
  var actions = useReduxActions();
  var isLayoutElement = !(selectedElement$1 === null || selectedElement$1 === void 0 ? void 0 : selectedElement$1.draggable);
  var clearPanel = {
    title: 'Clear Panel',
    icon: 'clearPanel',
    onClick: function () {
      return actions.clearPanel();
    },
    isActive: false
  };
  var view = editing !== 'fullbleed' ? {
    title: 'Edit Full Bleed',
    icon: 'fullBleed',
    onClick: function () {
      actions.setEditing('fullbleed');
      actions.openElementSettingsDrawer('fullbleed');
    },
    isActive: false
  } : {
    title: 'Edit Panel',
    icon: 'panelMode',
    onClick: function () {
      actions.setEditing('panel');
      actions.openElementSettingsDrawer('panel');
    },
    isActive: false
  };
  var elementSettings = isLayoutElement ? [{
    title: 'Delete',
    icon: 'delete',
    onClick: function () {
      if (activeElement.type === 'image') {
        actions.removeImage();
        actions.openElementSettingsDrawer('image');
      } else {
        actions.clearText();
        actions.openElementSettingsDrawer('text');
      }
    }
  }] : [{
    title: 'Delete',
    icon: 'delete',
    onClick: function () {
      actions.removeElement();
      actions.openElementSettingsDrawer('panel');
    }
  }, {
    title: 'Duplicate',
    icon: 'copy',
    onClick: function () {
      actions.duplicateElement();
      (activeElement === null || activeElement === void 0 ? void 0 : activeElement.type) === 'image' ? actions.setActiveImageSetting(null) : actions.setActiveTextSetting(null);
    }
  }, {
    title: 'Layer Up',
    icon: 'layerUp',
    onClick: function () {
      return actions.layerUp(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location);
    },
    isActive: false
  }, {
    title: 'Layer Down',
    icon: 'layerDown',
    onClick: function () {
      return actions.layerDown(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location);
    },
    isActive: false
  }];
  var panelSettings = [{
    title: 'Add Panel Layout',
    icon: 'template',
    onClick: function () {
      return actions.openElementInsertDrawer('layouts');
    },
    isActive: false
  }, {
    title: 'Add Panel Image',
    icon: 'image',
    onClick: function () {
      actions.setShouldReplaceSelectedImage(true);
      actions.openElementInsertDrawer('images');
      actions.addImageElement(undefined, true);
      actions.openElementSettingsDrawer('panel');
    },
    isActive: false
  }, {
    title: 'Add Panel Text',
    icon: 'fullBleedText',
    onClick: function () {
      actions.setShouldReplaceSelectedImage(false);
      actions.openElementSettingsDrawer('text');
      actions.addTextElement(true);
    },
    isActive: false
  }];
  var fullBleedSettings = [{
    title: 'Add Full Bleed Image',
    icon: 'fullBleedImage',
    onClick: function () {
      return actions.openElementInsertDrawer('images');
    },
    isActive: false
  }, {
    title: 'Delete Full Bleed Image',
    icon: 'delete',
    onClick: function () {
      return actions.deleteFullBleedBackgroundImage();
    },
    isActive: false
  }];

  var getPillSettings = function (editing) {
    var _a, _b;

    var isOnInsidePanel = ((_a = selectedFullBleed$1 === null || selectedFullBleed$1 === void 0 ? void 0 : selectedFullBleed$1.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'inside';

    var shouldClearContent = function (element) {
      var _a, _b;

      return (selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.isLocked) && (!!((_a = element.image) === null || _a === void 0 ? void 0 : _a.image) || ((_b = element === null || element === void 0 ? void 0 : element.text) === null || _b === void 0 ? void 0 : _b.fragments.some(function (fragment) {
        return fragment.text;
      })));
    };

    var hasElementsToClear = (_b = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.elements) === null || _b === void 0 ? void 0 : _b.some(function (element) {
      return !element.locked && (element.draggable || !selectedPanel$1.isLocked || shouldClearContent(element));
    });
    var settings = isOnInsidePanel ? [view] : [];
    var clearPanelSettings = hasElementsToClear ? [clearPanel] : [];

    switch (editing) {
      case 'element':
        return __spread(elementSettings, settings, clearPanelSettings);

      case 'panel':
        return __spread(panelSettings, settings, clearPanelSettings);

      case 'fullbleed':
        return __spread(fullBleedSettings, settings, clearPanelSettings);
    }
  };

  return jsx(Pill, {
    items: __spread(getPillSettings(editing)),
    boxShadow: "light"
  });
};

var BetaBanner = function (_a) {
  var button = _a.button,
      banner = _a.banner,
      _b = _a.zIndex,
      zIndex = _b === void 0 ? 0 : _b,
      timeout = _a.timeout;
  var actions = useReduxActions();
  useEffect(function () {
    var timer = null;

    if (typeof timeout === 'number') {
      timer = setTimeout(function () {
        actions.closeBetaBanner();
      }, timeout);
    }

    return function () {
      return timer ? clearTimeout(timer) : undefined;
    };
  }, [actions, timeout]);
  return jsx(Div, {
    position: "absolute",
    top: "0px",
    width: "100%",
    minWidth: "816px",
    maxWidth: "1200px",
    zIndex: zIndex,
    initial: {
      y: '-110%',
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1
    },
    exit: {
      y: '-100%',
      opacity: 0,
      transition: {
        delay: 0,
        duration: 0.3
      }
    },
    left: "0px",
    right: "0px",
    outset: {
      horizontal: 'auto',
      top: 'x1'
    },
    transition: {
      duration: 0.3,
      delay: 2,
      damping: 15,
      stiffness: 100,
      type: 'spring'
    }
  }, jsx(Banner, banner, jsx(Button, {
    type: "accent",
    textColorOverride: "primaryBody",
    title: button.title,
    size: "xSmall",
    onClick: function () {
      return button.onClick();
    }
  })));
};

var PREVIEW_ZOOM_VALUES = [{
  value: '4',
  label: '210%'
}, {
  value: '3.804',
  label: '200%'
}, {
  value: '3.279',
  label: '190%'
}, {
  value: '2.827',
  label: '180%'
}, {
  value: '2.437',
  label: '170%'
}, {
  value: '2.101',
  label: '160%'
}, {
  value: '1.811',
  label: '150%'
}, {
  value: '1.561',
  label: '140%'
}, {
  value: '1.346',
  label: '130%'
}, {
  value: '1.16',
  label: '120%'
}, {
  value: '1',
  label: '100%'
}];
var EDIT_ZOOM_VALUES = [{
  value: '1.35',
  label: '3x'
}, {
  value: '1.25',
  label: '2x'
}, {
  value: '1',
  label: '1x'
}];

var EditorWrapper = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _a = props.scale,
      scale = _a === void 0 ? 1 : _a;
  var controls = useAnimation();
  useEffect(function () {
    controls.start({
      scale: scale,
      transition: {
        duration: 0.3,
        damping: 15,
        stiffness: 100,
        type: 'spring'
      }
    });
  }, [scale, controls]);
  return jsx(Div, {
    ref: ref,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: props.width,
    height: props.height,
    animate: controls,
    inset: props.isPreviewMode ? 'x7' : 'x0'
  }, props.children);
});

var CircleIconButton = function (_a) {
  var icon = _a.icon,
      onClick = _a.onClick,
      size = _a.size,
      iconSize = _a.iconSize,
      outset = _a.outset,
      offsetIcon = _a.offsetIcon;
  return jsx(Flex, {
    onClick: onClick,
    width: size || '50px',
    height: size || '50px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: {
      swatch: 'grayScale',
      shade: '_600'
    },
    borderRadius: 'circle',
    boxShadow: 'mediumLight',
    outset: outset,
    cursor: 'pointer',
    inset: (offsetIcon === null || offsetIcon === void 0 ? void 0 : offsetIcon.insetLeft) ? {
      left: offsetIcon.insetLeft
    } : (offsetIcon === null || offsetIcon === void 0 ? void 0 : offsetIcon.insetRight) ? {
      right: offsetIcon.insetRight
    } : 'x0'
  }, jsx(Icon, {
    name: icon,
    size: iconSize || 'medium',
    primaryColor: 'inverseBodyText'
  }));
};

var Variations = function (_a) {
  var variationState = _a.variationState,
      onSelectVariation = _a.onSelectVariation,
      selectedVariation = _a.selectedVariation;

  var _b = __read(useState(false), 2),
      isExpanded = _b[0],
      setIsExpanded = _b[1];

  var _c = __read(useState(selectedVariation !== null && selectedVariation !== void 0 ? selectedVariation : 0), 2),
      activeIndex = _c[0],
      setActiveIndex = _c[1];

  return jsx(Stoplight, {
    isCollapsible: true,
    isExpanded: isExpanded,
    setIsExpanded: setIsExpanded,
    type: "colors",
    activeIndex: activeIndex,
    setActiveIndex: setActiveIndex,
    orientation: 'horizontal'
  }, variationState.variations.map(function (v, i) {
    return jsx(ColorOption, {
      onClick: function () {
        if (activeIndex !== i) onSelectVariation(variationState.variations[i]);
      },
      hexColor: v.color
    });
  }));
};

var ViewModes = function (_a) {
  var onChangeView = _a.onChangeView;

  var _b = __read(useState(false), 2),
      isExpanded = _b[0],
      setIsExpanded = _b[1];

  var _c = __read(useState(0), 2),
      activeIndex = _c[0],
      setActiveIndex = _c[1];

  var _d = __read(useState(-1), 2),
      activeIndicatorTooltip = _d[0],
      setActiveIndicatorTooltip = _d[1];

  useEffect(function () {
    setActiveIndicatorTooltip(-1);
  }, []);
  return jsx(Flex, {
    position: "relative"
  }, jsx(Stoplight, {
    isCollapsible: true,
    isExpanded: isExpanded,
    setIsExpanded: setIsExpanded,
    type: "icons",
    activeIndex: activeIndex,
    setActiveIndex: setActiveIndex,
    orientation: 'horizontal'
  }, jsx(Flex, {
    onClick: function () {
      return onChangeView('fullbleed');
    },
    justifyContent: "center",
    alignItems: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(1);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(Icon, {
    name: "fullBleed",
    size: "small",
    primaryColor: !activeIndex ? 'primaryBrand' : 'default'
  })), jsx(Flex, {
    onClick: function () {
      return onChangeView('panel');
    },
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(2);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(Icon, {
    name: "viewSinglePanel",
    size: "small",
    primaryColor: activeIndex ? 'primaryBrand' : 'default'
  }))), activeIndicatorTooltip >= 1 && jsx(Flex, {
    position: "absolute",
    bottom: "46px",
    left: activeIndicatorTooltip === 1 ? '-32px' : activeIndicatorTooltip === 2 ? '-6.5px' : undefined,
    animate: activeIndicatorTooltip ? {
      opacity: 1
    } : {
      opacity: 0
    },
    initial: 'hoverOff',
    transition: {
      ease: 'easeIn',
      duration: 0.2
    }
  }, jsx(Tooltip, {
    background: "dark",
    direction: "bottom",
    title: activeIndicatorTooltip === 1 ? 'Fullbleed View' : 'Single Panel View'
  })));
};

var ChromeControls = function (_a) {
  var _b, _c;

  var onNextPanel = _a.onNextPanel,
      onPreviousPanel = _a.onPreviousPanel,
      onSelectVariation = _a.onSelectVariation,
      onChangeView = _a.onChangeView,
      zoomItems = _a.zoomItems,
      setActiveZoomIndex = _a.setActiveZoomIndex,
      activeZoomIndex = _a.activeZoomIndex,
      isPreviewMode = _a.isPreviewMode;

  var _d = useReduxState('editor'),
      editing = _d.editing,
      card = _d.card; // TODO remove this and logical render after preview chrome gets designed


  var shouldHidePreviewToggle = true;
  var actions = useReduxActions();
  var hasColorVariations = ((_b = card === null || card === void 0 ? void 0 : card.variationState) === null || _b === void 0 ? void 0 : _b.variations) && card.variationState.variations.length > 1;

  var selectedVariation = (_c = card === null || card === void 0 ? void 0 : card.variationState) === null || _c === void 0 ? void 0 : _c.variations.findIndex(function (v) {
    var _a;

    return v.id === ((_a = card.variationState) === null || _a === void 0 ? void 0 : _a.selectedVariationID);
  });
  return jsx(Flex, {
    justifyContent: "space-between"
  }, editing !== 'fullbleed' && jsx(CircleIconButton, {
    icon: 'leftChevron',
    onClick: onPreviousPanel,
    outset: {
      right: 'x8'
    },
    offsetIcon: {
      insetRight: 'x_5'
    }
  }), jsx(HStack, {
    justify: "center",
    gap: "x1"
  }, !shouldHidePreviewToggle , jsx(ViewModes, {
    onChangeView: onChangeView
  }), jsx(Zoom, {
    items: zoomItems,
    onChange: setActiveZoomIndex,
    selectedOptionIndex: activeZoomIndex,
    background: "foreground"
  }), hasColorVariations && (card === null || card === void 0 ? void 0 : card.variationState) && !isPreviewMode && jsx(Div, null, jsx(Variations, {
    selectedVariation: selectedVariation,
    variationState: card.variationState,
    onSelectVariation: function (id) {
      return onSelectVariation === null || onSelectVariation === void 0 ? void 0 : onSelectVariation(id);
    }
  }))), editing !== 'fullbleed' && jsx(CircleIconButton, {
    icon: 'rightChevron',
    onClick: onNextPanel,
    outset: {
      left: 'x8'
    },
    offsetIcon: {
      insetLeft: 'x_5'
    }
  }));
};

var PreviewMode = function (props) {
  var _a = __read(useState(PREVIEW_ZOOM_VALUES.length - 1), 2),
      activeZoomIndex = _a[0],
      setActiveZoomIndex = _a[1];

  var activeElement = useReduxState('editor').activeElement;

  var findZoomValueIndex = function (scale) {
    var exactIndex = PREVIEW_ZOOM_VALUES.findIndex(function (zoomVal) {
      return parseFloat(zoomVal.value) === scale;
    });
    var index = PREVIEW_ZOOM_VALUES.findIndex(function (zoomVal) {
      return parseFloat(zoomVal.value) > scale - 0.5 && parseFloat(zoomVal.value) < scale + 0.5;
    });
    return exactIndex === -1 ? index : exactIndex;
  };

  var memoizedReset = React.useCallback(function (cb) {
    if (activeZoomIndex === PREVIEW_ZOOM_VALUES.length - 1) {
      cb();
    }
  }, [activeZoomIndex]);
  var editorWrapperRef = useRef(null);
  var zoomPanPinchRef = useRef(null);
  return jsx(ChromeContentGrid, null, jsx(ChromeContentZone, null, jsx(Text, {
    type: "title",
    content: "Preview Mode"
  })), jsx(ChromeContentZone, null, jsx(TransformWrapper, {
    disabled: typeof (activeElement === null || activeElement === void 0 ? void 0 : activeElement.location) === 'number',
    wheel: {
      disabled: false
    },
    onZoom: function (_a) {
      var state = _a.state;
      return setActiveZoomIndex(findZoomValueIndex(state.scale));
    },
    initialPositionX: 0,
    initialPositionY: 0,
    maxScale: 4,
    minScale: 1,
    ref: zoomPanPinchRef
  }, function (_a) {
    var resetTransform = _a.resetTransform;
    memoizedReset(resetTransform);
    return jsx(TransformComponent, null, jsx(EditorWrapper, {
      width: "50vw",
      height: "50vh",
      ref: editorWrapperRef,
      isPreviewMode: true
    }, props.children));
  })), jsx(ChromeContentZone, null, jsx(ChromeControls, {
    isPreviewMode: true,
    onNextPanel: props.handleNextPanel,
    onPreviousPanel: props.handlePreviousPanel,
    onChangeView: props.onChangeView,
    zoomItems: PREVIEW_ZOOM_VALUES,
    setActiveZoomIndex: function (index) {
      var _a;

      if (zoomPanPinchRef.current) {
        setActiveZoomIndex(index);
        (_a = zoomPanPinchRef.current) === null || _a === void 0 ? void 0 : _a.centerView(parseFloat("" + PREVIEW_ZOOM_VALUES[index].value), 300, 'easeInOutQuad');
      }
    },
    activeZoomIndex: activeZoomIndex
  })));
};

var LocationTip = function (_a) {
  var location = _a.location;
  return jsx(Div, {
    backgroundColor: {
      swatch: 'primaryBrand',
      shade: '_100'
    },
    borderRadius: "default",
    inset: {
      horizontal: 'x2',
      vertical: 'x1'
    },
    display: "inline-flex"
  }, jsx(Span, {
    display: "inline-flex"
  }, jsx(Text, {
    type: "caption",
    content: "Location:",
    weight: "bold",
    color: "inverseBody"
  }), jsx(Spacer, {
    space: "x_5",
    orientation: "horizontal"
  }), jsx(Text, {
    type: "caption",
    content: location,
    color: "inverseBody"
  })));
};

var ChromeContentGrid = function (_a) {
  var children = _a.children,
      shouldOverflowY = _a.shouldOverflowY;
  return jsx("div", {
    css: /*#__PURE__*/css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n        display: grid;\n        grid-template-rows: 120px 1fr 168px;\n        height: 100%;\n        column-gap: 16px;\n        overflow-y: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentGrid;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n        display: grid;\n        grid-template-rows: 120px 1fr 168px;\n        height: 100%;\n        column-gap: 16px;\n        overflow-y: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentGrid;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), shouldOverflowY ? 'scroll' : undefined)
  }, children);
};
var ChromeContentZone = function (props) {
  var _a = props.align,
      align = _a === void 0 ? 'center' : _a,
      _b = props.justify,
      justify = _b === void 0 ? 'center' : _b,
      _c = props.rowSpan,
      rowSpan = _c === void 0 ? 1 : _c,
      _d = props.columnSpan,
      columnSpan = _d === void 0 ? 1 : _d,
      zIndex = props.zIndex;
  return jsx("div", {
    css: /*#__PURE__*/css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        display: grid;\n        grid-column: ", ";\n        grid-row: ", ";\n        justify-items: ", ";\n        align-items: ", ";\n        z-index: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentZone;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n        display: grid;\n        grid-column: ", ";\n        grid-row: ", ";\n        justify-items: ", ";\n        align-items: ", ";\n        z-index: ", ";\n      " + (process.env.NODE_ENV === "production" ? "" : ";label:ChromeContentZone;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), typeof columnSpan === 'number' ? "span " + columnSpan : columnSpan, typeof rowSpan === 'number' ? "span " + rowSpan : rowSpan, justify, align, zIndex)
  }, props.children);
};
var ChromeContent = function (_a) {
  var _b, _c;

  var children = _a.children,
      height = _a.height,
      _d = _a.xOffset,
      xOffset = _d === void 0 ? 0 : _d,
      onPreviousPanel = _a.onPreviousPanel,
      onNextPanel = _a.onNextPanel,
      onChangeView = _a.onChangeView;

  var _e = __read(useState(EDIT_ZOOM_VALUES.length - 1), 2),
      activeZoomIndex = _e[0],
      setActiveZoomIndex = _e[1];

  var _f = useReduxState('editorChrome'),
      showBetaBanner = _f.showBetaBanner,
      interactionMode = _f.interactionMode;

  var _g = useReduxState('editor'),
      card = _g.card,
      fullBleedLocation = _g.fullBleedLocation,
      panelLocation = _g.panelLocation;

  var panelName = typeof fullBleedLocation === 'number' && typeof panelLocation === 'number' && ((_c = (_b = card === null || card === void 0 ? void 0 : card.fullBleeds[fullBleedLocation]) === null || _b === void 0 ? void 0 : _b.panels[panelLocation]) === null || _c === void 0 ? void 0 : _c.name);
  var actions = useReduxActions();

  var handleSelectVariation = function (variation) {
    actions.selectVariation(variation.id);
  };

  return jsx(Section, {
    backgroundColor: "background",
    width: "calc(100vw - " + xOffset + "px)",
    height: height,
    outset: {
      left: xOffset + "px"
    },
    minWidth: "880px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, jsx(AnimatePresence, null, showBetaBanner && jsx(BetaBanner, {
    timeout: 30000,
    zIndex: 6,
    button: {
      title: 'Dismiss',
      onClick: actions.closeBetaBanner
    },
    banner: {
      status: 'danger',
      icon: 'exclamation',
      message: 'Warning: For the best experience, please deactive browser plugins or OS settings that automatically alter text inputs, as the beta release of the new editor does not currently support them.'
    }
  })), interactionMode === 'edit' ? jsx(ChromeContentGrid, {
    shouldOverflowY: true
  }, jsx(ChromeContentZone, {
    columnSpan: 1
  }, jsx(Div, {
    outset: {
      top: 'x2'
    }
  }, jsx(ChromePill, null))), jsx(ChromeContentZone, null, jsx(EditorWrapper, {
    width: "50vw",
    height: "50vh",
    scale: parseFloat(EDIT_ZOOM_VALUES[activeZoomIndex].value)
  }, children)), jsx(ChromeContentZone, {
    columnSpan: 1,
    justify: "center",
    align: "center",
    zIndex: 6
  }, typeof panelName === 'string' && interactionMode === 'edit' && jsx(LocationTip, {
    location: panelName
  }), jsx(ChromeControls, {
    activeZoomIndex: activeZoomIndex,
    setActiveZoomIndex: setActiveZoomIndex,
    onNextPanel: onNextPanel,
    onPreviousPanel: onPreviousPanel,
    onChangeView: onChangeView,
    onSelectVariation: handleSelectVariation,
    zoomItems: EDIT_ZOOM_VALUES,
    isPreviewMode: false
  }))) : jsx(PreviewMode, {
    handleNextPanel: onNextPanel,
    handlePreviousPanel: onPreviousPanel,
    onChangeView: onChangeView
  }, children));
};
var templateObject_1$2, templateObject_2;

var ImageFragment = gql(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  fragment ImageFragment on ImageType {\n    height\n    width\n    url\n    smallThumbnail: url(width: 64, height: 64)\n    mediumThumbnail: url(width: 128, height: 128)\n    largeThumbnail: url(height: 256, width: 256)\n    uploadedAt\n  }\n"], ["\n  fragment ImageFragment on ImageType {\n    height\n    width\n    url\n    smallThumbnail: url(width: 64, height: 64)\n    mediumThumbnail: url(width: 128, height: 128)\n    largeThumbnail: url(height: 256, width: 256)\n    uploadedAt\n  }\n"])));
var FeatureFragment = gql(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  fragment FeatureFragment on FeatureType {\n    id\n    title\n    description\n    elementLocationId\n    arrowLocation\n    isDismissable\n    image {\n      ...ImageFragment\n    }\n  }\n  ", "\n"], ["\n  fragment FeatureFragment on FeatureType {\n    id\n    title\n    description\n    elementLocationId\n    arrowLocation\n    isDismissable\n    image {\n      ...ImageFragment\n    }\n  }\n  ", "\n"])), ImageFragment);
var NoteFragment = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  fragment NoteFragment on ReleaseNoteSectionType {\n    releaseType\n    notes\n  }\n"], ["\n  fragment NoteFragment on ReleaseNoteSectionType {\n    releaseType\n    notes\n  }\n"])));
var StickerFragment = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  fragment StickerFragment on StickerType {\n    image {\n      ...ImageFragment\n    }\n    id\n    title\n    dateCreated\n  }\n  ", "\n"], ["\n  fragment StickerFragment on StickerType {\n    image {\n      ...ImageFragment\n    }\n    id\n    title\n    dateCreated\n  }\n  ", "\n"])), ImageFragment);
var templateObject_1$3, templateObject_2$1, templateObject_3, templateObject_4;

var GET_RELEASE = gql(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  query getRelease($version: String!) {\n    getRelease(version: $version) {\n      id\n      versionNumber\n      releaseTitle\n      description\n      datePublished\n      releaseDate\n      featureList {\n        ...FeatureFragment\n      }\n      noteSections {\n        ...NoteFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"], ["\n  query getRelease($version: String!) {\n    getRelease(version: $version) {\n      id\n      versionNumber\n      releaseTitle\n      description\n      datePublished\n      releaseDate\n      featureList {\n        ...FeatureFragment\n      }\n      noteSections {\n        ...NoteFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"])), FeatureFragment, NoteFragment);
var GET_STICKERS = gql(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  query getStickers($offset: Int!, $limit: Int!) {\n    getStickers(offset: $offset, limit: $limit) {\n      hasMore\n      totalCount\n      results {\n        ...StickerFragment\n      }\n    }\n  }\n  ", "\n"], ["\n  query getStickers($offset: Int!, $limit: Int!) {\n    getStickers(offset: $offset, limit: $limit) {\n      hasMore\n      totalCount\n      results {\n        ...StickerFragment\n      }\n    }\n  }\n  ", "\n"])), StickerFragment);
var templateObject_1$4, templateObject_2$2;

var QUERIES = /*#__PURE__*/Object.freeze({
	__proto__: null,
	GET_RELEASE: GET_RELEASE,
	GET_STICKERS: GET_STICKERS
});

var useQuery = function (queryName, options) {
  var _a = __read(useState(null), 2),
      data = _a[0],
      setData = _a[1];

  var _b = __read(useState(false), 2),
      isLoading = _b[0],
      setIsLoading = _b[1];

  var _c = __read(useState(null), 2),
      error = _c[0],
      setError = _c[1];

  var getQueryResult = useCallback(function () {
    var _a, _b, _c;

    return __awaiter(this, void 0, void 0, function () {
      var queryBody, response, data_1, error_1;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            _d.trys.push([0, 3, 4, 5]);

            setIsLoading(true);
            queryBody = (_a = QUERIES[queryName].loc) === null || _a === void 0 ? void 0 : _a.source.body;
            return [4
            /*yield*/
            , fetch((_b = process.env.API_ENDPOINT) !== null && _b !== void 0 ? _b : 'https://cardeditor-backend.herokuapp.com/api/', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                query: queryBody,
                variables: options.variables
              })
            })];

          case 1:
            response = _d.sent();
            return [4
            /*yield*/
            , response.json()];

          case 2:
            data_1 = _d.sent();

            if (data_1.errors) {
              setError(data_1.errors);
            } else {
              setData(data_1.data);
              (_c = options.onCompleted) === null || _c === void 0 ? void 0 : _c.call(options, data_1.data);
            }

            return [3
            /*break*/
            , 5];

          case 3:
            error_1 = _d.sent();
            setError(error_1);
            return [3
            /*break*/
            , 5];

          case 4:
            setIsLoading(false);
            return [7
            /*endfinally*/
            ];

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  }, []); //eslint-disable-line

  useEffect(function () {
    getQueryResult();
  }, []); //eslint-disable-line

  return {
    data: data,
    isLoading: isLoading,
    error: error
  };
};

var resolveMedia = function (path) {
  if (process.env.API_ENDPOINT) {
    return process.env.API_ENDPOINT + "/media/" + path;
  }

  return "https://soceditor-assets.s3.amazonaws.com/media/public/" + path;
};

/** An enumeration. */
var FeatureArrowLocation;

(function (FeatureArrowLocation) {
  /** Top Left */
  FeatureArrowLocation["TopLeft"] = "TOP_LEFT";
  /** Top Middle */

  FeatureArrowLocation["TopMiddle"] = "TOP_MIDDLE";
  /** Top Right */

  FeatureArrowLocation["TopRight"] = "TOP_RIGHT";
  /** Left Top */

  FeatureArrowLocation["LeftTop"] = "LEFT_TOP";
  /** Left Middle */

  FeatureArrowLocation["LeftMiddle"] = "LEFT_MIDDLE";
  /** Left Bottom */

  FeatureArrowLocation["LeftBottom"] = "LEFT_BOTTOM";
  /** Bottom Right */

  FeatureArrowLocation["BottomRight"] = "BOTTOM_RIGHT";
  /** Bottom Middle */

  FeatureArrowLocation["BottomMiddle"] = "BOTTOM_MIDDLE";
  /** Bottom Left */

  FeatureArrowLocation["BottomLeft"] = "BOTTOM_LEFT";
  /** Right Top */

  FeatureArrowLocation["RightTop"] = "RIGHT_TOP";
  /** Right Middle */

  FeatureArrowLocation["RightMiddle"] = "RIGHT_MIDDLE";
  /** Right Bottom */

  FeatureArrowLocation["RightBottom"] = "RIGHT_BOTTOM";
})(FeatureArrowLocation || (FeatureArrowLocation = {}));
/** An enumeration. */


var ReleaseNoteSectionReleaseType;

(function (ReleaseNoteSectionReleaseType) {
  /** new */
  ReleaseNoteSectionReleaseType["New"] = "NEW";
  /** fix */

  ReleaseNoteSectionReleaseType["Fix"] = "FIX";
  /** note */

  ReleaseNoteSectionReleaseType["Note"] = "NOTE";
})(ReleaseNoteSectionReleaseType || (ReleaseNoteSectionReleaseType = {}));

var Release = function (props) {
  var _a, _b, _c;

  var actions = useReduxActions();
  var featureQueue = props.data.featureQueue;
  var featureRef = useRef(null);
  var currentFeature = featureQueue.size() > 0 ? featureQueue.peek() : null;

  var _d = __read(useState(window.innerWidth - 268), 2),
      xPosition = _d[0],
      setXPosition = _d[1];

  var _e = __read(useState(window.innerHeight - 414), 2),
      yPosition = _e[0],
      setYPosition = _e[1];

  var hideFeatureAnnouncement = {
    opacity: 0,
    zIndex: -1
  };

  var calcFeatureAnnouncementPosition = function (arrowLocation, featureElement, featureAnnouncement) {
    if (arrowLocation && featureAnnouncement) {
      var margin_1 = 16;

      var getTop = function () {
        return featureElement.getBoundingClientRect().top - featureAnnouncement.offsetHeight - margin_1;
      };

      var getRight = function () {
        return featureElement.getBoundingClientRect().right + margin_1;
      };

      var getBottom = function () {
        return featureElement.getBoundingClientRect().bottom + margin_1;
      };

      var getLeft = function () {
        return featureElement.getBoundingClientRect().left - featureAnnouncement.offsetWidth - margin_1;
      };

      var getHorizontalMiddle = function () {
        return featureElement.getBoundingClientRect().top + featureElement.offsetHeight / 2 - featureAnnouncement.offsetHeight / 2;
      };

      var getVerticalMiddle = function () {
        return featureElement.getBoundingClientRect().left + featureElement.offsetWidth / 2 - featureAnnouncement.offsetWidth / 2;
      };

      switch (arrowLocation) {
        case 'TOP_LEFT':
          {
            return {
              x: getLeft(),
              y: getTop()
            };
          }

        case 'TOP_MIDDLE':
          {
            return {
              x: getVerticalMiddle(),
              y: getTop()
            };
          }

        case 'TOP_RIGHT':
          {
            return {
              x: getRight(),
              y: getTop()
            };
          }

        case 'LEFT_TOP':
          {
            return {
              x: getLeft(),
              y: getTop()
            };
          }

        case 'LEFT_MIDDLE':
          {
            return {
              x: getLeft(),
              y: getHorizontalMiddle()
            };
          }

        case 'LEFT_BOTTOM':
          {
            return {
              x: getLeft(),
              y: getBottom()
            };
          }

        case 'BOTTOM_RIGHT':
          {
            return {
              x: getRight(),
              y: getBottom()
            };
          }

        case 'BOTTOM_MIDDLE':
          {
            return {
              x: getVerticalMiddle(),
              y: getBottom()
            };
          }

        case 'BOTTOM_LEFT':
          {
            return {
              x: getLeft(),
              y: getBottom()
            };
          }

        case 'RIGHT_TOP':
          {
            return {
              x: getRight(),
              y: getTop()
            };
          }

        case 'RIGHT_MIDDLE':
          {
            return {
              x: getRight(),
              y: getHorizontalMiddle()
            };
          }

        case 'RIGHT_BOTTOM':
          {
            return {
              x: getRight(),
              y: getBottom()
            };
          }

        default:
          return {
            x: window.innerWidth - featureAnnouncement.offsetWidth - 8,
            y: window.innerHeight - featureAnnouncement.offsetHeight - 64
          };
      }
    } else {
      return {
        x: window.innerWidth - 268,
        y: window.innerHeight - 414
      };
    }
  };

  useEffect(function () {
    if (currentFeature === null || currentFeature === void 0 ? void 0 : currentFeature.elementLocationId) {
      var featureElement = document.querySelector("[data-feature='" + (currentFeature === null || currentFeature === void 0 ? void 0 : currentFeature.elementLocationId) + "']");

      if (featureElement && featureRef.current && !props.isOpen) {
        var position = calcFeatureAnnouncementPosition(currentFeature.arrowLocation, featureElement, featureRef.current);
        setYPosition(position.y);
        setXPosition(position.x);
      }
    }

    return function () {};
  }, [currentFeature, featureRef, props.isOpen]);

  var convertReleaseNoteType = function (type) {
    switch (type) {
      case ReleaseNoteSectionReleaseType.Fix:
        return 'fix';

      case ReleaseNoteSectionReleaseType.Note:
        return 'note';

      case ReleaseNoteSectionReleaseType.New:
        return 'new';
    }
  };

  return jsx(React.Fragment, null, jsx(ReleaseNoteDialog, {
    title: props.data.releaseTitle,
    versionNumber: props.data.versionNumber,
    description: props.data.description,
    onClose: function () {
      return actions.setReleaseOpenState(false);
    },
    button: {
      title: 'Dismiss',
      type: 'success'
    },
    noteSections: props.data.noteSections.map(function (section) {
      return {
        releaseType: convertReleaseNoteType(section.releaseType),
        notes: section.notes
      };
    }),
    releaseDate: (_a = props.data.releaseDate) !== null && _a !== void 0 ? _a : '',
    isOpen: props.isOpen
  }), currentFeature && jsx(Div, {
    position: "absolute",
    top: yPosition + "px",
    left: xPosition + "px",
    zIndex: 1000,
    ref: featureRef,
    style: props.isOpen ? hideFeatureAnnouncement : {}
  }, jsx(FeatureAnnouncement, {
    maxWidth: "260px",
    title: currentFeature.title,
    description: currentFeature.description,
    imageURL: resolveMedia((_c = (_b = currentFeature.image) === null || _b === void 0 ? void 0 : _b.mediumThumbnail) !== null && _c !== void 0 ? _c : ''),
    onClose: function () {
      return actions.popReleaseFeature();
    },
    button: {
      type: 'success',
      title: 'Dismiss'
    }
  })));
};

/**
 * Fetches data from editor-backend. DataType is the shape of the data to be returned, VariableType is the
 * shape of the variables to be passed into the Query. These types are pulled from codegen and can be found in
 * src/graphql/generate/types. In development must have REACT_APP_EDITOR_BACKEND_ENDPOINT environment variable
 * set to graphql endpoint
 *
 * Example usage:
 *
 * const [ getStickers ] = useLazyQuery()
 *
 * <Button onClick={() => getStickers({variables: {offset: 0, limit: 10}})}>Load More Stickers</Button>
 *
 * @param queryName - Name of the Query to be made
 */

var useLazyQuery = function (queryName) {
  var _a = __read(useState(null), 2),
      data = _a[0],
      setData = _a[1];

  var _b = __read(useState(false), 2),
      isLoading = _b[0],
      setIsLoading = _b[1];

  var _c = __read(useState(null), 2),
      error = _c[0],
      setError = _c[1];

  var getQueryResult = useCallback(function (options) {
    var _a, _b, _c;

    return __awaiter(this, void 0, void 0, function () {
      var queryBody, response, data_1, error_1;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            _d.trys.push([0, 3, 4, 5]);

            setIsLoading(true);
            queryBody = (_a = QUERIES[queryName].loc) === null || _a === void 0 ? void 0 : _a.source.body;
            return [4
            /*yield*/
            , fetch((_b = process.env.API_ENDPOINT) !== null && _b !== void 0 ? _b : 'https://cardeditor-backend.herokuapp.com/api/', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                query: queryBody,
                variables: options === null || options === void 0 ? void 0 : options.variables
              })
            })];

          case 1:
            response = _d.sent();
            return [4
            /*yield*/
            , response.json()];

          case 2:
            data_1 = _d.sent();

            if (data_1.errors) {
              setError(data_1.errors);
            } else {
              setData(data_1.data);
              (_c = options === null || options === void 0 ? void 0 : options.onCompleted) === null || _c === void 0 ? void 0 : _c.call(options, data_1.data);
            }

            return [3
            /*break*/
            , 5];

          case 3:
            error_1 = _d.sent();
            setError(error_1);
            return [3
            /*break*/
            , 5];

          case 4:
            setIsLoading(false);
            return [7
            /*endfinally*/
            ];

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  }, []); //eslint-disable-line

  return [getQueryResult, {
    data: data,
    isLoading: isLoading,
    error: error
  }];
};

var StickerThumbnail = function (_a) {
  var _b = _a.backgrounColor,
      backgrounColor = _b === void 0 ? 'background' : _b,
      url = _a.url,
      _c = _a.width,
      width = _c === void 0 ? '110px' : _c,
      _d = _a.height,
      height = _d === void 0 ? '110px' : _d,
      onClick = _a.onClick;
  return jsx(Flex, {
    width: width,
    height: height,
    backgroundColor: backgrounColor,
    borderRadius: "default",
    justifyContent: "center",
    alignItems: "center",
    inset: "x3",
    onClick: onClick,
    cursor: "pointer"
  }, jsx(Image$1, {
    width: '100%',
    height: '100%',
    isActive: true,
    image: {
      url: url
    },
    borderRadius: "none"
  }));
};

var Stickers = function (_a) {
  var _b, _c, _d, _e;

  var preFetchedStickers = _a.preFetchedStickers,
      totalStickerCount = _a.totalStickerCount;

  var _f = __read(useState(0), 2),
      offset = _f[0],
      setOffset = _f[1];

  var preFetchedStickersLength = (_b = preFetchedStickers === null || preFetchedStickers === void 0 ? void 0 : preFetchedStickers.length) !== null && _b !== void 0 ? _b : 0;

  var _g = __read(useState({
    hasMore: preFetchedStickersLength < totalStickerCount,
    results: preFetchedStickers,
    totalCount: totalStickerCount
  }), 2),
      stickers = _g[0],
      setStickers = _g[1];

  var actions = useReduxActions();

  var _h = __read(useLazyQuery('GET_STICKERS'), 1),
      getStickers = _h[0];

  var getQueryOptions = function (offset) {
    return {
      variables: {
        offset: offset,
        limit: preFetchedStickersLength
      },
      onCompleted: function (data) {
        var _a;

        if ((_a = data.getStickers) === null || _a === void 0 ? void 0 : _a.results) {
          setStickers(__assign(__assign({}, stickers), {
            hasMore: data.getStickers.hasMore,
            results: __spread(stickers === null || stickers === void 0 ? void 0 : stickers.results, data.getStickers.results),
            totalCount: data.getStickers.totalCount
          }));
        }
      }
    };
  };

  var loadMore = function () {
    var newOffset = offset + preFetchedStickersLength;
    setOffset(newOffset);
    getStickers(getQueryOptions(newOffset));
  };

  return jsx(InsertDrawerContent, {
    loadMore: loadMore,
    hasMore: !!(stickers === null || stickers === void 0 ? void 0 : stickers.hasMore),
    dataLength: (_d = (_c = stickers === null || stickers === void 0 ? void 0 : stickers.results) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0,
    endMessage: "All Stickers Loaded",
    description: "Insert fun Stickers onto your card",
    heading: "Add a Sticker",
    grid: {
      columnSize: 110,
      rowSize: 110
    },
    drawerSummaryTitle: "All Stickers",
    totalDataCount: (_e = stickers === null || stickers === void 0 ? void 0 : stickers.totalCount) !== null && _e !== void 0 ? _e : undefined
  }, (stickers === null || stickers === void 0 ? void 0 : stickers.results) && (stickers === null || stickers === void 0 ? void 0 : stickers.results.map(function (sticker) {
    var _a, _b;

    var mediumThumbnail = (_b = (_a = sticker.image) === null || _a === void 0 ? void 0 : _a.mediumThumbnail) !== null && _b !== void 0 ? _b : '';
    return jsx(GridItem, {
      gridColSpan: 1,
      gridRowSpan: 1,
      key: sticker.id
    }, sticker.image && jsx(StickerThumbnail, {
      onClick: function () {
        var _a, _b;

        actions.addImageElement({
          id: '',
          stickerUrl: resolveMedia((_b = (_a = sticker.image) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : ''),
          isSticker: true,
          width: 700,
          height: 500,
          url: '',
          thumbnailUrl: ''
        }, undefined);
        actions.closeElementSettingsDrawer();
        actions.setShouldReplaceSelectedImage(false);
      },
      url: resolveMedia(mediumThumbnail)
    }));
  })));
};

function usePrefetch(queryName, variables) {
  var _a = __read(useState(null), 2),
      results = _a[0],
      setResults = _a[1];

  useQuery(queryName, {
    variables: variables,
    onCompleted: function (data) {
      if (data) setResults(data);
    }
  });
  return results;
}

var EditorChrome = function (_a) {
  var children = _a.children,
      layouts = _a.layouts,
      images = _a.images,
      onUploadImages = _a.onUploadImages,
      fonts = _a.fonts,
      signatures = _a.signatures,
      placeholders = _a.placeholders,
      helpIcon = _a.helpIcon,
      contextZones = _a.contextZones,
      theme = _a.theme,
      handleNextPanel = _a.handleNextPanel,
      handlePreviousPanel = _a.handlePreviousPanel,
      handleChangeView = _a.handleChangeView,
      customBackPanels = _a.customBackPanels,
      onSaveBackPanel = _a.onSaveBackPanel,
      onCreateBackPanel = _a.onCreateBackPanel,
      defaultBackPanels = _a.defaultBackPanels,
      onDeleteBackPanel = _a.onDeleteBackPanel,
      onSelectBackLayout = _a.onSelectBackLayout,
      onDeleteImage = _a.onDeleteImage,
      onClientAssetConversion = _a.onClientAssetConversion,
      onSetDefaultBackPanel = _a.onSetDefaultBackPanel,
      defaultBackPanelId = _a.defaultBackPanelId,
      colorPalettes = _a.colorPalettes;

  var _b = useReduxState('editor'),
      editing = _b.editing,
      card = _b.card,
      fullBleedLocation = _b.fullBleedLocation,
      layoutToLoad = _b.layoutToLoad,
      activeFullBleedLocation = _b.fullBleedLocation;

  var _c = useReduxState('editorChrome'),
      isElementInsertOpen = _c.isElementInsertOpen,
      isElementSettingsOpen = _c.isElementSettingsOpen,
      elementInsertDrawerType = _c.elementInsertDrawerType,
      elementSettingsDrawerType = _c.elementSettingsDrawerType,
      interactionMode = _c.interactionMode,
      release = _c.release,
      isImageUploaderWidgetActive = _c.isImageUploaderWidgetActive;

  var canShowWidget = isElementSettingsOpen && elementSettingsDrawerType === 'panel';
  var isPreviewMode = interactionMode === 'preview';
  var actions = useReduxActions();
  var isOnBackPanel = (card === null || card === void 0 ? void 0 : card.fullBleeds[fullBleedLocation].name.toLowerCase()) === 'back';
  var bottomBarHeight = 60;
  var sideBarWidth = 70;
  var isFrontPanelLocked = (card === null || card === void 0 ? void 0 : card.fullBleeds[0].panels[0].isLocked) !== undefined && (card === null || card === void 0 ? void 0 : card.fullBleeds[0].panels[0].isLocked);
  useQuery('GET_RELEASE', {
    variables: {
      version: '0.6.0'
    },
    onCompleted: function (data) {
      var releaseData = data.getRelease;

      if (releaseData && !release.hasSeen) {
        actions.setReleaseData(releaseData);
      }
    }
  });
  var stickers = usePrefetch('GET_STICKERS', {
    offset: 0,
    limit: 10
  });

  var renderElementInsertDrawerContent = function (insertType) {
    var _a, _b, _c, _d;

    switch (insertType) {
      case 'images':
        return jsx(Images, {
          images: images,
          onUploadImages: onUploadImages,
          loaderComponent: jsx(LoadingSpinner, {
            size: "medium"
          }),
          onDelete: onDeleteImage
        });

      case 'layouts':
        return isOnBackPanel ? jsx(BackPanels, {
          onSetDefaultBackPanel: onSetDefaultBackPanel,
          defaultBackPanelId: defaultBackPanelId,
          defaultBackPanels: defaultBackPanels,
          customBackPanels: customBackPanels,
          onDelete: onDeleteBackPanel,
          onSelectBackLayout: onSelectBackLayout
        }) : jsx(Layouts, {
          title: "Add a Design Layout",
          subtitle: "Choose pre-designed layout below to add a nice design to your card",
          layouts: layouts
        });

      case 'clientNav':
        return (contextZones === null || contextZones === void 0 ? void 0 : contextZones.clientNavigation) && jsx(ClientNavigation, {
          clientNav: contextZones.clientNavigation
        });

      case 'stickers':
        return jsx(Stickers, {
          totalStickerCount: (_b = (_a = stickers === null || stickers === void 0 ? void 0 : stickers.getStickers) === null || _a === void 0 ? void 0 : _a.totalCount) !== null && _b !== void 0 ? _b : 0,
          onClientAssetConversion: onClientAssetConversion,
          preFetchedStickers: (_d = (_c = stickers === null || stickers === void 0 ? void 0 : stickers.getStickers) === null || _c === void 0 ? void 0 : _c.results) !== null && _d !== void 0 ? _d : []
        });

      default:
        return jsx(React.Fragment, null);
    }
  };

  var renderSettingsDrawerContent = function (settingType) {
    switch (settingType) {
      case 'image':
        return jsx(ImageElementSettings, null);

      case 'text':
        return jsx(TextSettings, null);

      case 'panel':
        return jsx(PanelSettings, {
          images: images,
          onUploadImages: onUploadImages
        });

      case 'fullbleed':
        return jsx(FullBleedSettings, null);

      default:
        return jsx(React.Fragment, null);
    }
  };

  React.useEffect(function () {
    if (editing === 'panel') {
      if (activeFullBleedLocation !== 0 || activeFullBleedLocation === 0 && !isFrontPanelLocked) actions.openElementSettingsDrawer('panel');else if (activeFullBleedLocation === 0 && isFrontPanelLocked) actions.closeElementSettingsDrawer();
    }
  }, [editing, card === null || card === void 0 ? void 0 : card.fullBleeds[0].panels[0].isLocked]); // eslint-disable-line

  var currentPanel = card === null || card === void 0 ? void 0 : card.fullBleeds.filter(function (fullBleed) {
    return fullBleed.name.toLowerCase() === 'back';
  }).filter(function (fullBleed) {
    return fullBleed.panels.filter(function (panel) {
      return panel.name.toLowerCase() === 'back';
    });
  })[0].panels[0];
  var backPanelSaveActions = [{
    title: 'Save new back panel',
    onClick: function () {
      return currentPanel && layoutToLoad && onCreateBackPanel(currentPanel, layoutToLoad);
    }
  }, {
    title: 'Save existing back panel',
    onClick: function () {
      return currentPanel && layoutToLoad && onSaveBackPanel(currentPanel, layoutToLoad);
    }
  }];
  var saveActions = isOnBackPanel ? __spread(backPanelSaveActions) : [];
  var editor = useReduxState('editor');
  var selectedPanel$1 = selectedPanel(editor);

  var handleAddImage = function (image) {
    var _a;

    var backgroundImage = selectedPanel$1 === null || selectedPanel$1 === void 0 ? void 0 : selectedPanel$1.elements.find(function (element) {
      var _a;

      return (element === null || element === void 0 ? void 0 : element.isFullPanel) && ((_a = element === null || element === void 0 ? void 0 : element.image) === null || _a === void 0 ? void 0 : _a.image);
    });

    if ((_a = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.image) === null || _a === void 0 ? void 0 : _a.image) {
      actions.selectImage(backgroundImage.image.image);
      actions.removeElement();
    }

    actions.addImageElement(image, true);
    actions.setActiveImageSetting('crop');
    actions.setShouldReplaceSelectedImage(false);
  };

  var userImages = images.results.map(function (image) {
    return {
      url: image.url,
      isHorizontal: image.width > image.height,
      onClick: function () {
        handleAddImage(image);
        actions.toggleImageUploaderWidget();
      }
    };
  });
  var rightDrawerOpenValue = 315;
  var windowWidth = useWindowSize().width;
  var widgetWidth = 264;
  var widgetOffsetPadding = 50;
  var imageUploadWidgetOffset = windowWidth - rightDrawerOpenValue - widgetWidth - widgetOffsetPadding;
  return jsx(QuantumThemeWrapper, {
    theme: theme
  }, jsx(EditorChromeProvider, {
    value: {
      layouts: layouts,
      images: images,
      fonts: fonts,
      signatures: signatures,
      placeholders: placeholders,
      defaultBackPanels: defaultBackPanels,
      customBackPanels: customBackPanels,
      colorPalettes: colorPalettes
    }
  }, release.data && jsx(Release, {
    isOpen: release.isOpen,
    data: release.data
  }), jsx(Flex, {
    position: "absolute",
    left: 0,
    overflow: "hidden",
    zIndex: 0
  }, jsx(Drawer, {
    isTabHidden: true,
    zIndex: 5,
    location: "left",
    offset: 60,
    openValue: 298,
    isOpen: isElementInsertOpen,
    onClick: function () {
      return actions.closeElementInsertDrawer();
    },
    overflow: "hidden",
    tabMode: "dark"
  }, jsx(Flex, {
    width: "100%",
    height: "100%",
    alignItems: "center",
    flexDirection: "column",
    inset: "x1",
    overflowY: "auto"
  }, renderElementInsertDrawerContent(elementInsertDrawerType))), jsx(ChromeContent, {
    onNextPanel: handleNextPanel,
    onPreviousPanel: handlePreviousPanel,
    onChangeView: handleChangeView,
    height: "calc(100vh - " + bottomBarHeight + "px)",
    xOffset: sideBarWidth
  }, children), jsx(Drawer, {
    tabMode: "dark",
    isTabHidden: isPreviewMode,
    zIndex: 8,
    location: "right",
    openValue: rightDrawerOpenValue,
    isOpen: isElementSettingsOpen,
    onClick: function () {
      return isElementSettingsOpen ? actions.closeElementSettingsDrawer() : typeof elementSettingsDrawerType === 'string' && actions.openElementSettingsDrawer(elementSettingsDrawerType);
    },
    overflow: "auto",
    shoudHideScroll: true
  }, renderSettingsDrawerContent(elementSettingsDrawerType))), jsx(ChromeBottomBar, {
    saveActions: saveActions,
    contextZones: contextZones,
    height: bottomBarHeight + "px",
    zIndex: 5,
    xOffset: sideBarWidth,
    isPreviewMode: isPreviewMode
  }), jsx(ChromeSidebar, {
    helpIcon: helpIcon,
    isPreviewMode: isPreviewMode
  }), jsx(ImageUploadWidget, {
    title: "Background Image",
    onClose: function () {
      return actions.toggleImageUploaderWidget();
    },
    onFinished: function () {
      return actions.toggleImageUploaderWidget();
    },
    isOpen: isImageUploaderWidgetActive && canShowWidget,
    onUpload: function (files, fileList) {
      if (files.rejected.length > 0) {
        // TODO: Show user error if upload error?
        return;
      }

      if (fileList && fileList.length > 0 && files.accepted.length > 0) {
        actions.setShouldReplaceSelectedImage(true);
        onUploadImages(fileList);
        actions.setHasUploadedImage(true);
      }
    },
    userImages: userImages,
    x: imageUploadWidgetOffset,
    y: 267,
    hasMore: images.hasMore,
    loadMore: images.loadMore,
    dataLength: images.results.length,
    endMessage: "All Images Loaded",
    width: widgetWidth
  })));
};

var EditorContext = /*#__PURE__*/createContext({
  panelView: 'fullbleed',
  currentIndex: 0,
  editorId: 0
});
var EditorProvider = EditorContext.Provider;
var EditorConsumer = EditorContext.Consumer;

var imageIsCached = function (src) {
  var mutableImage = new Image();
  mutableImage.src = src;
  return mutableImage.complete;
};

var IndicatorModeControl = function (_a) {
  var onActiveElementDrag = _a.onActiveElementDrag,
      onActiveElementDelete = _a.onActiveElementDelete,
      onActiveElementReplace = _a.onActiveElementReplace,
      elementType = _a.elementType,
      shouldReplaceSelectedImage = _a.shouldReplaceSelectedImage;

  var _b = __read(useState(-1), 2),
      activeIndicatorTooltip = _b[0],
      setActiveIndicatorTooltip = _b[1];

  var actions = useReduxActions();

  var _c = useReduxState('editorChrome'),
      activeImageSetting = _c.activeImageSetting,
      isTextCursorActive = _c.isTextCursorActive;

  useEffect(function () {
    setActiveIndicatorTooltip(-1);
  }, [shouldReplaceSelectedImage]);
  return jsx(Flex, {
    width: '100%',
    position: 'absolute',
    bottom: '-32px',
    zIndex: 10,
    justifyContent: "center"
  }, jsx(Flex, {
    width: "fit-content",
    position: "absolute",
    borderRadius: "circle",
    backgroundColor: "foreground",
    inset: "x1",
    boxShadow: "mediumLight"
  }, jsx(HStack, {
    gap: 'x3',
    justify: 'center',
    shouldWrap: false
  }, jsx(Span, {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(1);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'delete',
    size: 'xSmall',
    isActive: false,
    onMouseEvent: function (e) {
      e.stopPropagation();
      onActiveElementDelete();
    }
  })), elementType === 'text' && jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(2);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'textBox',
    size: 'xSmall',
    isActive: isTextCursorActive,
    onMouseEvent: function (e) {
      e.stopPropagation();
      actions.setIsTextCursorActive(true);
    }
  })), elementType === 'image' && jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(2);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'replaceImage',
    size: 'xSmall',
    isActive: shouldReplaceSelectedImage,
    onMouseEvent: function (e) {
      e.stopPropagation();
      onActiveElementReplace(true);
      actions.setActiveImageSetting(null);
    }
  })), elementType === 'image' && jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(3);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'crop',
    size: 'xSmall',
    isActive: activeImageSetting === 'crop',
    onMouseEvent: function (e) {
      e.stopPropagation();
      actions.setActiveImageSetting('crop');
      actions.setShouldReplaceSelectedImage(false);
    }
  })), jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(elementType === 'text' ? 3 : 4);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'drag',
    size: 'xSmall',
    hasBackgroundColor: false,
    isActive: activeImageSetting === null && !isTextCursorActive && !shouldReplaceSelectedImage,
    onMouseEvent: function (e) {
      e.stopPropagation();
      actions.setIsTextCursorActive(false);
      onActiveElementDrag();
      actions.setShouldReplaceSelectedImage(false);
    }
  }))), activeIndicatorTooltip >= 1 && jsx(Flex, {
    position: "absolute",
    bottom: "-44px",
    left: activeIndicatorTooltip === 1 ? '-8px' : activeIndicatorTooltip === 2 ? '28px' : undefined,
    right: activeIndicatorTooltip === 4 ? '-4px' : activeIndicatorTooltip === 3 ? '36px' : undefined,
    animate: activeIndicatorTooltip ? {
      opacity: 1
    } : {
      opacity: 0
    },
    initial: 'hoverOff',
    transition: {
      ease: 'easeIn',
      duration: 0.2
    }
  }, jsx(Tooltip, {
    background: "dark",
    direction: "top",
    title: activeIndicatorTooltip === 1 ? 'Delete' : activeIndicatorTooltip === 2 ? elementType === 'text' ? 'Edit Text' : 'Replace' : activeIndicatorTooltip === 3 ? elementType === 'text' ? 'Move' : 'Crop' : activeIndicatorTooltip === 4 && elementType === 'image' ? 'Move' : ''
  }))));
};

var MoveableWrapper = function (_a) {
  var parentHeight = _a.parentHeight,
      parentWidth = _a.parentWidth,
      parentId = _a.parentId,
      children = _a.children,
      position = _a.position,
      rotation = _a.rotation,
      size = _a.size,
      isSelected = _a.isSelected,
      isEditable = _a.isEditable,
      isPhotoDropTemplate = _a.isPhotoDropTemplate,
      isFullPanelElement = _a.isFullPanelElement,
      onUpdatePosition = _a.onUpdatePosition,
      onUpdateRotation = _a.onUpdateRotation,
      onUpdateSize = _a.onUpdateSize,
      onActiveElementDelete = _a.onActiveElementDelete,
      onActiveElementDrag = _a.onActiveElementDrag,
      onActiveElementReplace = _a.onActiveElementReplace,
      elementType = _a.elementType,
      shouldReplaceSelectedImage = _a.shouldReplaceSelectedImage,
      elementLocation = _a.elementLocation,
      isPreviewMode = _a.isPreviewMode,
      isDraggable = _a.isDraggable;

  var getParent = function () {
    return parentWidth && parentHeight ? {
      width: parentWidth,
      height: parentHeight
    } : {
      width: 0,
      height: 0
    };
  };

  var isTextCursorActive = useReduxState('editorChrome').isTextCursorActive;

  var xToPixels = function (x) {
    return getParent().width * x;
  };

  var yToPixels = function (y) {
    return getParent().height * y;
  };

  var widthToPixels = function (widthPct) {
    return getParent().width * widthPct;
  };

  var heightToPixels = function (heighPct) {
    return getParent().height * heighPct;
  };

  var widthToPercent = function (width) {
    return width / getParent().width;
  };

  var heightToPercent = function (height) {
    return height / getParent().height;
  };

  var xToPercentage = function (x) {
    var fixedX = parseInt(x.toFixed(8));
    var fixedParentWidth = parseInt(getParent().width.toFixed(8));
    var xWithoutNegatives = fixedX < 0 ? 0 : fixedX;
    var xPercentage = xWithoutNegatives / fixedParentWidth;
    return xPercentage;
  };

  var yToPercentage = function (y) {
    var fixedY = parseInt(y.toFixed(8));
    var fixedParentHeight = parseInt(getParent().height.toFixed(8));
    var yWithoutNegatives = fixedY < 0 ? 0 : fixedY;
    var yPercentage = yWithoutNegatives / fixedParentHeight;
    return yPercentage;
  };

  var _b = __read(useState(null), 2),
      target = _b[0],
      setTarget = _b[1];

  var moveableRef = React.useRef(null); // TODO Update rect when window resizes

  var _c = __read(React.useState({
    translate: [0, 0],
    rotate: rotation
  }), 2),
      frame = _c[0],
      setFrame = _c[1];

  useEffect(function () {
    setTarget(document.querySelector(".target-" + parentId + " "));
  }, [parentId]);
  var height = heightToPixels(size.height);
  var width = widthToPixels(size.width);
  var x = xToPixels(position.x) - frame.translate[0];
  var y = yToPixels(position.y) - frame.translate[1];
  useEffect(function () {
    var _a, _b; // Updates the moveable instance when a position change happens
    // Bugs still occuring with the sliders, state gets out of sync


    (_a = moveableRef.current) === null || _a === void 0 ? void 0 : _a.updateRect();
    (_b = moveableRef.current) === null || _b === void 0 ? void 0 : _b.updateTarget();
  }, [position.x, position.y]);
  useEffect(function () {
    var _a, _b;

    if (target && elementType === 'text') {
      if (typeof target !== 'string') {
        var moveableTarget = target;
        moveableTarget.style.height = height + "px";
        (_a = moveableRef.current) === null || _a === void 0 ? void 0 : _a.updateRect();
        (_b = moveableRef.current) === null || _b === void 0 ? void 0 : _b.updateTarget();
      }
    }
  }, [height]); //eslint-disable-line

  useEffect(function () {
    var _a, _b;

    if (target) {
      if (typeof target !== 'string') {
        var moveableTarget = target;
        moveableTarget.style.height = height + "px";
        moveableTarget.style.width = width + "px";
        (_a = moveableRef.current) === null || _a === void 0 ? void 0 : _a.updateRect();
        (_b = moveableRef.current) === null || _b === void 0 ? void 0 : _b.updateTarget();
      }
    }
  }, [height, width]); //eslint-disable-line

  useEffect(function () {
    var _a, _b;

    if (target) {
      if (typeof target !== 'string') {
        var moveableTarget = target;
        setFrame(__assign(__assign({}, frame), {
          rotate: rotation
        }));
        moveableTarget.style.transform = "translate(" + frame.translate[0] + "px, " + frame.translate[1] + "px) rotate(" + rotation + "deg)";
        (_a = moveableRef.current) === null || _a === void 0 ? void 0 : _a.updateRect();
        (_b = moveableRef.current) === null || _b === void 0 ? void 0 : _b.updateTarget();
      }
    }
  }, [rotation]); //eslint-disable-line

  return jsx(React.Fragment, null, target && isSelected && isEditable && !isPreviewMode && jsx(Moveable, {
    ref: moveableRef,
    snappable: true,
    draggable: (!isTextCursorActive || !isFullPanelElement) && !shouldReplaceSelectedImage,
    resizable: !isFullPanelElement && !shouldReplaceSelectedImage,
    rotatable: size.width > 0.98 || size.height > 0.98 || shouldReplaceSelectedImage ? false : true ,
    origin: false,
    keepRatio: false // Keep ratio for images?
    ,
    throttleResize: 1,
    edge: false,
    bounds: {
      left: 0,
      top: 0,
      right: parentWidth,
      bottom: parentHeight
    },
    target: target,
    zoom: 1,
    onDragStart: function (_a) {
      var set = _a.set;
      set(frame.translate);
    },
    onDrag: function (_a) {
      var beforeTranslate = _a.beforeTranslate,
          target = _a.target;
      frame.translate = beforeTranslate;
      target.style.transform = "translate(" + beforeTranslate[0] + "px, " + beforeTranslate[1] + "px) rotate(" + frame.rotate + "deg)";
    },
    onDragEnd: function (_a) {
      var currentTarget = _a.currentTarget;
      var leftTopCornerLeftPosition = currentTarget.getRect().pos1[0];
      var leftTopCornerTopPosition = currentTarget.getRect().pos1[1];
      onUpdatePosition(xToPercentage(leftTopCornerLeftPosition), yToPercentage(leftTopCornerTopPosition));
    },
    onResizeStart: function (_a) {
      var setOrigin = _a.setOrigin,
          dragStart = _a.dragStart;
      setOrigin(['%', '%']);
      dragStart && dragStart.set(frame.translate);
    },
    onResize: function (_a) {
      var target = _a.target,
          drag = _a.drag,
          width = _a.width,
          height = _a.height;
      frame.translate = drag.beforeTranslate;
      target.style.width = width + "px";
      target.style.height = height + "px";
      target.style.transform = "translate(" + drag.beforeTranslate[0] + "px, " + drag.beforeTranslate[1] + "px) rotate(" + frame.rotate + "deg)";
    },
    onResizeEnd: function (_a) {
      var currentTarget = _a.currentTarget;
      var leftTopCornerLeftPosition = currentTarget.getRect().pos1[0];
      var leftTopCornerTopPosition = currentTarget.getRect().pos1[1];
      var width = currentTarget.state.width;
      var height = currentTarget.state.height;
      onUpdatePosition(xToPercentage(leftTopCornerLeftPosition), yToPercentage(leftTopCornerTopPosition));
      onUpdateSize(widthToPercent(width), heightToPercent(height));
    },
    throttleRotate: 0,
    rotationPosition: 'right-top',
    onRotateStart: function (_a) {
      var set = _a.set;
      set(frame.rotate);
    },
    onRotate: function (_a) {
      var beforeRotate = _a.beforeRotate,
          target = _a.target;
      frame.rotate = beforeRotate;
      target.style.transform = "translate(" + frame.translate[0] + "px, " + frame.translate[1] + "px) rotate(" + beforeRotate + "deg)";
    },
    onRotateEnd: function () {
      onUpdateRotation(elementLocation, frame.rotate);
    }
  }), jsx(Div, {
    position: "absolute",
    top: y + "px",
    left: x + "px",
    width: width + "px",
    height: height + "px",
    className: "target-" + parentId,
    id: "moveable-wrapper",
    zIndex: position.z,
    transformOrigin: "top left",
    css: /*#__PURE__*/css(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n          transform: ", ";\n          pointer-events: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:MoveableWrapper;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n          transform: ", ";\n          pointer-events: ", ";\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:MoveableWrapper;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), "rotate(" + frame.rotate + "deg)", isPhotoDropTemplate ? 'none' : 'auto')
  }, children, isSelected && isDraggable && !isPreviewMode && !isFullPanelElement && jsx(IndicatorModeControl, {
    onActiveElementDelete: onActiveElementDelete,
    onActiveElementReplace: onActiveElementReplace,
    onActiveElementDrag: onActiveElementDrag,
    elementType: elementType,
    shouldReplaceSelectedImage: shouldReplaceSelectedImage
  })));
};
var templateObject_1$5;

var styles$1 = {
  elementContainer: function (props, activeColor, inactiveColor) {
    return /*#__PURE__*/css(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    height: 100%;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    overflow: auto;\n    outline: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBlbGVtZW50Q29udGFpbmVyOiBmdW5jdGlvbiAocHJvcHMsIGFjdGl2ZUNvbG9yLCBpbmFjdGl2ZUNvbG9yKSB7IHJldHVybiBjc3ModGVtcGxhdGVPYmplY3RfMSB8fCAodGVtcGxhdGVPYmplY3RfMSA9IF9fbWFrZVRlbXBsYXRlT2JqZWN0KFtcIlxcbiAgICBoZWlnaHQ6IDEwMCU7XFxuICAgIHdpZHRoOiAxMDAlO1xcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XFxuICAgIGRpc3BsYXk6IGZsZXg7XFxuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XFxuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XFxuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xcbiAgICBvdmVyZmxvdzogYXV0bztcXG4gICAgb3V0bGluZTogXCIsIFwiO1xcbiAgXCJdLCBbXCJcXG4gICAgaGVpZ2h0OiAxMDAlO1xcbiAgICB3aWR0aDogMTAwJTtcXG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xcbiAgICBkaXNwbGF5OiBmbGV4O1xcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcXG4gICAgb3ZlcmZsb3c6IGF1dG87XFxuICAgIG91dGxpbmU6IFwiLFxyXG4gICAgICAgIFwiO1xcbiAgXCJdKSksIHByb3BzLnBhbmVsTG9jYXRpb24gIT09IG51bGwgJiZcclxuICAgICAgICBwcm9wcy5zaG93Qm9yZGVyICYmXHJcbiAgICAgICAgcHJvcHMuZWxlbWVudC5pc1NlbGVjdGVkXHJcbiAgICAgICAgPyBcIjFweCBkYXNoZWQgXCIgKyBhY3RpdmVDb2xvclxyXG4gICAgICAgIDogcHJvcHMucGFuZWxMb2NhdGlvbiAhPT0gbnVsbCAmJlxyXG4gICAgICAgICAgICBwcm9wcy5zaG93Qm9yZGVyICYmXHJcbiAgICAgICAgICAgICFwcm9wcy5lbGVtZW50LmRyYWdnYWJsZVxyXG4gICAgICAgICAgICA/IFwiMXB4IGRhc2hlZCBcIiArIGluYWN0aXZlQ29sb3JcclxuICAgICAgICAgICAgOiAnbm9uZScpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")], ["\n    height: 100%;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    overflow: auto;\n    outline: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBlbGVtZW50Q29udGFpbmVyOiBmdW5jdGlvbiAocHJvcHMsIGFjdGl2ZUNvbG9yLCBpbmFjdGl2ZUNvbG9yKSB7IHJldHVybiBjc3ModGVtcGxhdGVPYmplY3RfMSB8fCAodGVtcGxhdGVPYmplY3RfMSA9IF9fbWFrZVRlbXBsYXRlT2JqZWN0KFtcIlxcbiAgICBoZWlnaHQ6IDEwMCU7XFxuICAgIHdpZHRoOiAxMDAlO1xcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XFxuICAgIGRpc3BsYXk6IGZsZXg7XFxuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XFxuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XFxuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xcbiAgICBvdmVyZmxvdzogYXV0bztcXG4gICAgb3V0bGluZTogXCIsIFwiO1xcbiAgXCJdLCBbXCJcXG4gICAgaGVpZ2h0OiAxMDAlO1xcbiAgICB3aWR0aDogMTAwJTtcXG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xcbiAgICBkaXNwbGF5OiBmbGV4O1xcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcXG4gICAgb3ZlcmZsb3c6IGF1dG87XFxuICAgIG91dGxpbmU6IFwiLFxyXG4gICAgICAgIFwiO1xcbiAgXCJdKSksIHByb3BzLnBhbmVsTG9jYXRpb24gIT09IG51bGwgJiZcclxuICAgICAgICBwcm9wcy5zaG93Qm9yZGVyICYmXHJcbiAgICAgICAgcHJvcHMuZWxlbWVudC5pc1NlbGVjdGVkXHJcbiAgICAgICAgPyBcIjFweCBkYXNoZWQgXCIgKyBhY3RpdmVDb2xvclxyXG4gICAgICAgIDogcHJvcHMucGFuZWxMb2NhdGlvbiAhPT0gbnVsbCAmJlxyXG4gICAgICAgICAgICBwcm9wcy5zaG93Qm9yZGVyICYmXHJcbiAgICAgICAgICAgICFwcm9wcy5lbGVtZW50LmRyYWdnYWJsZVxyXG4gICAgICAgICAgICA/IFwiMXB4IGRhc2hlZCBcIiArIGluYWN0aXZlQ29sb3JcclxuICAgICAgICAgICAgOiAnbm9uZScpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")])), props.panelLocation !== null && props.showBorder && props.element.isSelected ? "1px dashed " + activeColor : props.panelLocation !== null && props.showBorder && !props.element.draggable ? "1px dashed " + inactiveColor : 'none');
  }
};
var templateObject_1$6;

var noSettingsEnabled = function (activeSetting) {
  return activeSetting === null;
};

var Element = function (props) {
  var _a;

  var elementId = props.elementId,
      originalHeight = props.height,
      originalWidth = props.width,
      originalX = props.x,
      originalY = props.y,
      originalZ = props.z,
      panelSize = props.panelSize,
      children = props.children,
      element = props.element,
      _b = props.isFullBleedBackground,
      isFullBleedBackground = _b === void 0 ? false : _b,
      isFullPanelElement = props.isFullPanelElement,
      panelLocation = props.panelLocation,
      onEdit = props.onEdit,
      originalRotation = props.rotation,
      isPreviewMode = props.isPreviewMode;

  var _c = useReduxState('editor'),
      canSelectElements = _c.canSelectElements,
      editing = _c.editing;

  var _d = useReduxState('editorChrome'),
      activeImageSetting = _d.activeImageSetting,
      activeTextSetting = _d.activeTextSetting,
      elementSettingsDrawerType = _d.elementSettingsDrawerType,
      shouldReplaceSelectedImage = _d.shouldReplaceSelectedImage;

  var actions = useReduxActions();
  var width = originalWidth <= 1 ? originalWidth : 1;
  var height = originalHeight <= 1 ? originalHeight : 1;
  var x = originalX >= 0 ? originalX : 0;
  var y = originalY >= 0 ? originalY : 0;
  var z = originalZ && originalZ >= 0 ? originalZ : 0; // TODO remove optional type and make z required

  var rotation = originalRotation || 0;
  var activeSetting = elementSettingsDrawerType === 'image' || isFullBleedBackground ? activeImageSetting : activeTextSetting;

  var _e = useColorSwatch(),
      success = _e.success,
      grayScale = _e.grayScale;

  var isElementLocked = function (isFullBleedBackground) {
    if (activeElement.type === 'text') {
      return element.movingProhibited || !element.draggable || !element.isSelected;
    }

    if (isFullBleedBackground) {
      return element.locked || editing !== 'fullbleed' || !noSettingsEnabled(activeSetting);
    }

    return element.movingProhibited || !element.draggable || !element.isSelected || !noSettingsEnabled(activeSetting) || element.isSelected && shouldReplaceSelectedImage;
  };

  var canElementBeSelected = function (isFullBleedBackground) {
    if (isFullBleedBackground) {
      return canSelectElements && editing === 'fullbleed';
    }

    return canSelectElements && !element.isSelected && panelLocation !== null && !element.locked;
  };

  var canElementBeEdited = function (isFullBleedBackground) {
    if (isFullBleedBackground) {
      return canSelectElements && editing === 'fullbleed';
    }

    return element.isSelected && canSelectElements && panelLocation !== null && !element.editingProhibited;
  };

  var activeElement = {
    location: element.location,
    type: !!element.image ? 'image' : !!element.text ? 'text' : null
  };

  var handleUpdatePosition = function (x, y) {
    if (isFullBleedBackground) {
      actions.enableSelectingElements();
      actions.updateFullBleedBackgroundElementPosition(x, y);
    } else {
      actions.enableSelectingElements();
      actions.updateElementPosition(element.location, x, y);
    }
  };

  var handleUpdateSize = function (width, height) {
    if (isFullBleedBackground) {
      actions.enableSelectingElements();
      actions.updateFullBleedBackgroundElementSize(width, height);
    } else {
      actions.enableSelectingElements();
      actions.updateElementSize(element.location, width, height);
    }
  };

  var handleElementOnClick = function (event, isFullBleedBackground) {
    event.stopPropagation();

    if (isFullBleedBackground) {
      onEdit();
      return;
    }

    if (canElementBeEdited(isFullBleedBackground)) {
      onEdit();
    }
  };

  var handleSelectElement = function (activeElement, panelLocation) {
    if (!element.draggable) {
      actions.setShouldReplaceSelectedImage(true);
      actions.setActiveImageSetting(null);
      actions.selectElement(element.editingProhibited && activeElement.location ? {
        location: activeElement.location - 1,
        type: 'image'
      } : activeElement, panelLocation);
    } else {
      actions.setShouldReplaceSelectedImage(false);
      actions.setActiveImageSetting(null);
      actions.selectElement(activeElement, panelLocation);
    }
  };

  return jsx(React.Fragment, null, jsx(MoveableWrapper, {
    isFullPanelElement: isFullPanelElement,
    isEditable: !isElementLocked(isFullBleedBackground),
    isPreviewMode: isPreviewMode,
    isPhotoDropTemplate: element.locked,
    isSelected: editing === 'fullbleed' ? true : element.isSelected,
    size: {
      width: width,
      height: height
    },
    position: {
      x: x,
      y: y,
      z: z
    },
    parentWidth: panelSize.width,
    parentHeight: panelSize.height,
    parentId: "" + activeElement.location + panelLocation,
    elementLocation: (activeElement === null || activeElement === void 0 ? void 0 : activeElement.location) || 0,
    onUpdatePosition: handleUpdatePosition,
    onUpdateRotation: actions.updateElementRotation,
    onUpdateSize: handleUpdateSize,
    rotation: rotation,
    onActiveElementDelete: function () {
      actions.removeElement();
      actions.closeElementSettingsDrawer();
    },
    onActiveElementReplace: function (shouldReplaceSelectedImage) {
      actions.openElementInsertDrawer('images');
      actions.setShouldReplaceSelectedImage(shouldReplaceSelectedImage);
    },
    onActiveElementDrag: function () {
      activeElement.type === 'image' ? actions.setActiveImageSetting(null) : actions.setActiveTextSetting(null);
    },
    onActiveElementCrop: function () {
      return actions.setActiveImageSetting('crop');
    },
    elementType: activeElement.type,
    shouldReplaceSelectedImage: shouldReplaceSelectedImage,
    isDraggable: (_a = element.draggable) !== null && _a !== void 0 ? _a : false
  }, jsx("div", {
    onClick: function (event) {
      if (isPreviewMode) {
        return;
      }

      handleElementOnClick(event, isFullBleedBackground);
    },
    id: elementId,
    className: 'elementContainer',
    css: styles$1.elementContainer(props, success.base, grayScale.base),
    onMouseDown: function () {
      if (isPreviewMode) {
        return;
      }

      if (canElementBeSelected(isFullBleedBackground)) {
        if (isFullBleedBackground) {
          return;
        }

        handleSelectElement(activeElement, panelLocation);
      }
    }
  }, children)));
};

var connect = connect$1;

var EmptyImage = function (_a) {
  var title = _a.title,
      type = _a.type;
  return jsx(VStack, {
    gap: "x1_5"
  }, jsx(IconLink, {
    onClick: function () {},
    size: type === 'element' ? 'xSmall' : 'medium',
    activeColor: "primaryHeadingText",
    icon: "image",
    isStacked: true,
    isActive: true,
    hasBackgroundColor: true
  }), jsx(Text, {
    type: type === 'element' ? 'footnote' : 'body',
    alignment: "center"
  }, title));
};

var ImageElement =
/** @class */
function (_super) {
  __extends(ImageElement, _super);

  function ImageElement(props) {
    var _this = _super.call(this, props) || this;

    _this.isUserImage = function (photoUrl) {
      return photoUrl && photoUrl.indexOf('user_images') > -1;
    };

    _this.photoUrl = function (element) {
      var image = element.image && element.image.image;

      if (!image || !image.url) {
        return '';
      }

      return image.url;
    };

    var image = props.element.image;
    _this.state = {
      isLoaded: !!(image && image.image && imageIsCached(image.image.url))
    };
    return _this;
  }

  ImageElement.prototype.componentDidUpdate = function (prevProps) {
    var element = prevProps.element;
    var image = element.image;
    var next = this.props.element.image;

    if (image && image.image && next && next.image && !imageIsCached(next.image.url) && image.image.url !== next.image.url // image.filter !== next.filter
    ) {
        this.setState({
          isLoaded: false
        });
      }
  };

  ImageElement.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        element = _a.element,
        panelLocation = _a.panelLocation,
        elementId = _a.elementId,
        _b = _a.isFullBleedBackground,
        isFullBleedBackground = _b === void 0 ? false : _b,
        panelSize = _a.panelSize,
        selectImagePosition = _a.selectImagePosition,
        isPanelLocked = _a.isPanelLocked,
        activeImageSetting = _a.activeImageSetting,
        elementSettingsDrawerType = _a.elementSettingsDrawerType,
        openElementSettingsDrawer = _a.openElementSettingsDrawer,
        openElementInsertDrawer = _a.openElementInsertDrawer,
        setActiveImageSetting = _a.setActiveImageSetting,
        updateFullBleedBackgroundImagePosition = _a.updateFullBleedBackgroundImagePosition,
        isFullPanelElement = _a.isFullPanelElement,
        isPreviewMode = _a.isPreviewMode;
    var isLoaded = this.state.isLoaded;
    var x = element.x,
        y = element.y,
        z = element.z,
        rotation = element.rotation,
        height = element.height,
        width = element.width,
        isSelected = element.isSelected;
    var image = element.image;
    var url = this.photoUrl(element);
    var showLoadingSpinner = !this.state.isLoaded && image && image.image;
    return jsx(Element, {
      x: x,
      y: y,
      z: z,
      rotation: rotation,
      height: height,
      width: width,
      elementId: elementId,
      element: element,
      panelLocation: panelLocation,
      panelIsLocked: isPanelLocked,
      isFullPanelElement: isFullPanelElement,
      showBorder: !!(image && !image.image && !isPreviewMode) || !!image && image.scale < 1 || isSelected,
      panelSize: panelSize,
      nonDraggableSelector: '.nonDraggable',
      isPreviewMode: isPreviewMode,
      onEdit: function () {
        var _a;

        if (isPreviewMode) {
          return;
        }

        if (!(activeImageSetting === 'crop')) openElementSettingsDrawer(isFullBleedBackground ? 'fullbleed' : isFullPanelElement ? 'panel' : 'image');

        if (!element.draggable) {
          openElementInsertDrawer('images');
          ((_a = element.image) === null || _a === void 0 ? void 0 : _a.image) && setActiveImageSetting('crop');
        }
      },
      isFullBleedBackground: isFullBleedBackground
    }, image && image.image ? jsx(AvatarEditor, {
      image: url,
      width: element.points.width,
      height: element.points.height,
      border: 0,
      scale: image.scale || 1,
      position: image.position,
      onPositionChange: activeImageSetting === 'crop' ? isFullBleedBackground ? function (position) {
        return updateFullBleedBackgroundImagePosition(position.x, position.y);
      } : function (position) {
        return selectImagePosition(position.x, position.y);
      } : function () {
        return null;
      },
      onImageReady: function () {
        return _this.setState({
          isLoaded: true
        });
      },
      style: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: isLoaded || !image.image ? 1 : 0,
        transition: 'opacity 500ms',
        zIndex: elementSettingsDrawerType === 'panel' ? 102 : 1
      }
    }) : !isFullBleedBackground && !isPreviewMode && jsx(EmptyImage, {
      title: "Add an Image",
      type: "element"
    }), showLoadingSpinner && jsx("div", {
      className: "center"
    }, jsx(LoadingSpinner, {
      size: "medium"
    })));
  };

  return ImageElement;
}(React.Component);

var ImageElement$1 = connect(function (state) {
  return {
    activeImageSetting: state.editorChrome.activeImageSetting,
    elementSettingsDrawerType: state.editorChrome.elementSettingsDrawerType
  };
}, {
  selectImagePosition: selectImagePosition,
  updateFullBleedBackgroundImagePosition: updateFullBleedBackgroundImagePosition,
  openElementSettingsDrawer: openElementSettingsDrawer,
  openElementInsertDrawer: openElementInsertDrawer,
  setActiveImageSetting: setActiveImageSetting
})(ImageElement);

var selectionIndex = function (node, offset, isStart, selectionUpperBound) {
  if (node.nodeName === '#text') {
    var spanIndex = parseInt(node.parentElement && node.parentElement.dataset.index || '1', 10);

    if (offset === 0) {
      return spanIndex;
    } else if (offset === (node.textContent && node.textContent.length)) {
      return spanIndex + 1;
    } else {
      return isStart ? spanIndex : spanIndex + 1;
    }
  } else if (node.nodeName === 'P' && node instanceof HTMLElement) {
    return parseInt(node.dataset.index || '1', 10) + offset + 1;
  } else {
    return isStart ? 1 : selectionUpperBound;
  }
};
var setCaretPositionOrHighlightText = function (selectionUpperBound, selection, selectText) {
  var windowSelection = window.getSelection();

  if (windowSelection) {
    var range = windowSelection.getRangeAt(0);
    var start = selectionIndex(range.startContainer, range.startOffset, true, selectionUpperBound);
    var end = selectionIndex(range.endContainer, range.endOffset, false, selectionUpperBound);

    if (!selection || selection.start.index !== start || selection.end.index !== end) {
      selectText(start, end);
    }
  }
};

var DEFAULT_OPTIONS = {
  config: {
    childList: true,
    characterData: true
  }
};

var useMutationObservable = function (targetEl, cb, options) {
  if (options === void 0) {
    options = DEFAULT_OPTIONS;
  }

  var _a = __read(useState(null), 2),
      observer = _a[0],
      setObserver = _a[1];

  useEffect(function () {
    var obs = new MutationObserver(cb);
    setObserver(obs);
  }, [cb, options, setObserver]);
  useEffect(function () {
    if (!observer) return;
    var config = options.config;
    if (targetEl) observer.observe(targetEl, config);
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [observer, targetEl, options]);
};

var styles$2 = {
  paragraph: function (paragraph, scale, isUsingOldFlattener) {
    return /*#__PURE__*/css(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-align: ", ";\n    margin: 0px;\n    min-height: ", "px;\n    line-height: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n    font-family: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-align: ", ";\n    margin: 0px;\n    min-height: ", "px;\n    line-height: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), paragraph.fontFamily, paragraph.fontSize, rgbString(paragraph.color), paragraph.textAlign.toLowerCase(), paragraph.fontSize * scale || 12, isUsingOldFlattener ? 1.4 : 1);
  },
  span: function (fragment, scale, isTextCursorActive, isPreviewMode) {
    var _a;

    return /*#__PURE__*/css(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-decoration: ", ";\n    cursor: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n    font-family: ", ";\n    font-size: ", "px;\n    color: ", ";\n    text-decoration: ", ";\n    cursor: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), (_a = fragment.signatureFontFamily) !== null && _a !== void 0 ? _a : fragment.fontFamily, fragment.fontSize * scale, rgbString(fragment.color), fragment.text && fragment.text.length > 1 ? 'underline' : 'none', isTextCursorActive && !isPreviewMode ? 'text' : 'inherit');
  }
};
var templateObject_1$7, templateObject_2$3;

var TextEditorParagraph = function (props) {
  var paragraph = props.paragraph,
      scale = props.scale,
      externalChangesDetected = props.externalChangesDetected,
      isTextCursorActive = props.isTextCursorActive,
      isPreviewMode = props.isPreviewMode,
      isUsingOldFlattener = props.isUsingOldFlattener;

  var _a = __read(useState(false), 2),
      isChangeExternal = _a[0],
      setIsChangeExternal = _a[1];

  var mutableRef = useRef();
  var ref = mutableRef.current;

  var _b = __read(useState(false), 2),
      hasDomChanges = _b[0],
      setHasDomChanges = _b[1];

  var onListMutation = useCallback(function () {
    setHasDomChanges(true);
  }, []);
  useMutationObservable(ref, onListMutation);
  useEffect(function () {
    // Checks if there were changes made to the DOM by an external plugin / source
    if ((ref === null || ref === void 0 ? void 0 : ref.innerText) !== paragraph.fragments.map(function (elem) {
      return elem.text;
    }).join('')) {
      setIsChangeExternal(true);
    } else {
      setHasDomChanges(false);
    }
  }, [hasDomChanges, externalChangesDetected]);

  if (isChangeExternal) {
    // This conditional render is to clear the current paragraph dom elements that were messed up by the external changes and react can no longer rely on them
    // by triggering and another component we force the cleanup of the messed up content and the recreate it as they should be on the next render.
    externalChangesDetected(true);
    setTimeout(function () {
      setHasDomChanges(false);
      setIsChangeExternal(false);
      externalChangesDetected(false);
    }, 1);
    return jsx("div", null);
  }

  return jsx("p", {
    key: paragraph.index,
    "data-index": paragraph.index,
    css: styles$2.paragraph(paragraph, scale, isUsingOldFlattener),
    ref: function (ref) {
      return mutableRef.current = ref !== null && ref !== void 0 ? ref : undefined;
    }
  }, paragraph.fragments.map(function (fragment) {
    return jsx("span", {
      key: fragment.index,
      "data-index": fragment.index,
      css: styles$2.span(fragment, scale, isTextCursorActive, isPreviewMode)
    }, fragment.text ? fragment.text : signatureCharacter);
  }));
};

var TextBlock = function (_a) {
  var paragraphs = _a.paragraphs,
      scale = _a.scale,
      isPreviewMode = _a.isPreviewMode,
      externalChangesDetected = _a.externalChangesDetected,
      isUsingOldFlattener = _a.isUsingOldFlattener;
  var isTextCursorActive = useReduxState('editorChrome').isTextCursorActive;
  var renderParagraphs = React.useCallback(function () {
    return paragraphs.map(function (paragraph) {
      return jsx(TextEditorParagraph, {
        paragraph: paragraph,
        scale: scale,
        externalChangesDetected: externalChangesDetected,
        isTextCursorActive: isTextCursorActive,
        isPreviewMode: isPreviewMode,
        isUsingOldFlattener: isUsingOldFlattener
      });
    });
  }, [paragraphs, scale, isTextCursorActive, isPreviewMode, externalChangesDetected]);
  return jsx(React.Fragment, null, renderParagraphs());
};

var fragmentsFormat = 'application/vnd.sendoutcards.textfragments+json';
var textManagementKeys = new Set(['Backspace', 'Delete', 'Enter']);

var TextEditor = function (props) {
  // Hooks
  var _a = useResizeObserver(),
      ref = _a.ref,
      height = _a.height;

  var textEditorRef = useRef(null);
  var previousHeight = usePrevious(height); // State

  var _b = useReduxState('editor'),
      activeElement = _b.activeElement,
      textSelection = _b.textSelection;

  var isTextCursorActive = useReduxState('editorChrome').isTextCursorActive;
  var actions = useReduxActions(); // Props

  var _c = props.elementText,
      paragraphs = _c.paragraphs,
      selectionUpperBound = _c.selectionUpperBound,
      selection = _c.selection,
      selectText = props.selectText,
      scale = props.scale,
      panelSize = props.panelSize,
      elementProperties = props.elementProperties,
      openElementSettingsDrawer = props.openElementSettingsDrawer,
      isPreviewMode = props.isPreviewMode,
      isUsingOldFlattener = props.isUsingOldFlattener;

  var _d = __read(useState(true), 2),
      shouldEditContent = _d[0],
      setShouldEditContent = _d[1];
  /******************************** Helpers  ******************************************/


  var getHeightPercentage = function (height) {
    return height / panelSize.height;
  };

  var hasHeightReachedElementBounds = function (height) {
    return getHeightPercentage(height) >= elementProperties.height;
  };

  var hasHeightReachedPanelBounds = function () {
    return elementProperties.height + elementProperties.y >= 1;
  };

  var handleUpdateElementSize = function (height) {
    actions.updateElementSize((activeElement === null || activeElement === void 0 ? void 0 : activeElement.location) || 0, elementProperties.width, height);
  };

  useEffect(function () {
    if (hasHeightReachedPanelBounds()) {
      return;
    }

    if (previousHeight && height && height !== previousHeight) {
      if (hasHeightReachedElementBounds(height)) {
        var delta = getHeightPercentage(height) - getHeightPercentage(previousHeight);
        var newHeight = delta + elementProperties.height + elementProperties.y >= 1 ? 1 - elementProperties.y : getHeightPercentage(height);
        handleUpdateElementSize(newHeight);
      }
    }
  }, [height]); //eslint-disable-line

  useEffect(function () {
    var selection = props.elementText.selection;

    if (!selection || !ref) {
      return;
    }

    if (textEditorRef.current) {
      var startNode = textEditorRef.current.childNodes[selection.start.paragraph];
      var endNode = textEditorRef.current.childNodes[selection.end.paragraph];

      if (!startNode || !endNode) {
        return;
      }

      var range = document.createRange();
      range.setStart(startNode, Math.max(0, Math.min(selection.start.offset, startNode.childNodes.length)));
      range.setEnd(endNode, Math.max(0, Math.min(selection.end.offset, endNode.childNodes.length)));
      var windowSelection = window.getSelection();

      if (windowSelection) {
        windowSelection.removeAllRanges();
        windowSelection.addRange(range);
      }
    }
  });
  React.useEffect(function () {
    actions.setIsTextCursorActive(true);
  }, []); //eslint-disable-line

  var externalChangesDetected = function (preventTextEdition) {
    setShouldEditContent(!preventTextEdition);
  };
  /******************************** Events  ******************************************/


  var handleOnCopy = function (event) {
    if (!selection) {
      return;
    }

    event.preventDefault();
    event.clipboardData.setData('text', selection.text);
    event.clipboardData.setData(fragmentsFormat, JSON.stringify(selection.fragments));
  };

  var handleOnClick = function (event) {
    event.stopPropagation();
    openElementSettingsDrawer();
  };

  var handleOnCut = function (event) {
    handleOnCopy(event);
    actions.deleteFragments();
  };

  var handleOnPaste = function (event) {
    event.preventDefault();
    var fragments = event.clipboardData.getData(fragmentsFormat);
    var text = event.clipboardData.getData('text');

    if (fragments) {
      actions.insertFragments(JSON.parse(fragments));
    } else if (text) {
      actions.insertText(text);
    }
  };

  var handleOnKeyDown = function (event) {
    if (textManagementKeys.has(event.key)) setCaretPositionOrHighlightText(selectionUpperBound, selection, selectText);

    if (event.key === 'Backspace') {
      event.preventDefault();
      actions.deleteFragments();
    } else if (event.key === 'Delete') {
      event.preventDefault();
      actions.deleteForwardFragments();
    } else if (event.key === 'Enter') {
      event.preventDefault();
      actions.insertNewLine();
    }
  };

  var handleOnKeyPress = function (event) {
    setCaretPositionOrHighlightText(selectionUpperBound, selection, selectText);

    if (event.nativeEvent.metaKey || event.nativeEvent.ctrlKey) {
      return;
    }

    event.preventDefault();
    actions.insertCharacter(event.nativeEvent.key);
  };

  var handleMouseUpListener = function () {
    handleOnMouseUp(true);
  };

  var handleOnMouseUp = function (shouldDeleteEvent) {
    if (shouldDeleteEvent) {
      window.removeEventListener('mouseup', handleMouseUpListener);
    }

    setCaretPositionOrHighlightText(selectionUpperBound, selection, selectText);
  };

  return jsx("div", {
    onMouseDown: function () {
      if ((textSelection === null || textSelection === void 0 ? void 0 : textSelection.start) === (textSelection === null || textSelection === void 0 ? void 0 : textSelection.end)) {
        window.addEventListener('mouseup', handleMouseUpListener);
      }
    },
    id: 'text_editor',
    ref: useMergeRefs([textEditorRef, ref]),
    autoCapitalize: "off",
    autoCorrect: "off",
    style: {
      whiteSpace: 'pre-wrap',
      outline: '0px',
      width: '100%'
    },
    onClick: handleOnClick,
    onCut: handleOnCut,
    onCopy: handleOnCopy,
    onPaste: handleOnPaste,
    onKeyDown: handleOnKeyDown,
    onKeyPress: handleOnKeyPress,
    onMouseUp: function () {
      return handleOnMouseUp();
    },
    contentEditable: isTextCursorActive && !isPreviewMode && shouldEditContent,
    suppressContentEditableWarning: true
  }, jsx(TextBlock, {
    scale: scale,
    paragraphs: paragraphs,
    isPreviewMode: isPreviewMode,
    externalChangesDetected: externalChangesDetected,
    isUsingOldFlattener: isUsingOldFlattener
  }));
};

var TextEditor$1 = /*#__PURE__*/React.memo(TextEditor);

var styles$3 = {
  contents: function (isTextCursorActive, isActive, isPreviewMode) {
    return /*#__PURE__*/css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    cursor: ", ";\n    background-color: ", ";\n    backdrop-filter: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHOEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBjb250ZW50czogZnVuY3Rpb24gKGlzVGV4dEN1cnNvckFjdGl2ZSwgaXNBY3RpdmUsIGlzUHJldmlld01vZGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgIGhlaWdodDogMTAwJTtcXG4gICAgd2lkdGg6IDEwMCU7XFxuICAgIG92ZXJmbG93OiBhdXRvO1xcbiAgICBkaXNwbGF5OiBmbGV4O1xcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcXG4gICAgY3Vyc29yOiBcIiwgXCI7XFxuICAgIGJhY2tncm91bmQtY29sb3I6IFwiLCBcIjtcXG4gICAgYmFja2Ryb3AtZmlsdGVyOiBcIiwgXCI7XFxuICBcIl0sIFtcIlxcbiAgICBoZWlnaHQ6IDEwMCU7XFxuICAgIHdpZHRoOiAxMDAlO1xcbiAgICBvdmVyZmxvdzogYXV0bztcXG4gICAgZGlzcGxheTogZmxleDtcXG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcXG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XFxuICAgIGN1cnNvcjogXCIsIFwiO1xcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiBcIiwgXCI7XFxuICAgIGJhY2tkcm9wLWZpbHRlcjogXCIsIFwiO1xcbiAgXCJdKSksIGlzVGV4dEN1cnNvckFjdGl2ZSAmJiAhaXNQcmV2aWV3TW9kZSA/ICd0ZXh0JyA6ICdpbmhlcml0JywgaXNBY3RpdmUgPyAncmdiYSgyNTUsIDI1NSwgMjU1LCAwLjE1KScgOiAndHJhbnNwYXJlbnQnLCBpc0FjdGl2ZSAmJiAnYmx1cig1cHgpJyk7IH0sXHJcbn07XHJcbnZhciB0ZW1wbGF0ZU9iamVjdF8xO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZXMuanMubWFwIl19 */")], ["\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    cursor: ", ";\n    background-color: ", ";\n    backdrop-filter: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHOEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBjb250ZW50czogZnVuY3Rpb24gKGlzVGV4dEN1cnNvckFjdGl2ZSwgaXNBY3RpdmUsIGlzUHJldmlld01vZGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgIGhlaWdodDogMTAwJTtcXG4gICAgd2lkdGg6IDEwMCU7XFxuICAgIG92ZXJmbG93OiBhdXRvO1xcbiAgICBkaXNwbGF5OiBmbGV4O1xcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcXG4gICAgY3Vyc29yOiBcIiwgXCI7XFxuICAgIGJhY2tncm91bmQtY29sb3I6IFwiLCBcIjtcXG4gICAgYmFja2Ryb3AtZmlsdGVyOiBcIiwgXCI7XFxuICBcIl0sIFtcIlxcbiAgICBoZWlnaHQ6IDEwMCU7XFxuICAgIHdpZHRoOiAxMDAlO1xcbiAgICBvdmVyZmxvdzogYXV0bztcXG4gICAgZGlzcGxheTogZmxleDtcXG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcXG4gICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XFxuICAgIGN1cnNvcjogXCIsIFwiO1xcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiBcIiwgXCI7XFxuICAgIGJhY2tkcm9wLWZpbHRlcjogXCIsIFwiO1xcbiAgXCJdKSksIGlzVGV4dEN1cnNvckFjdGl2ZSAmJiAhaXNQcmV2aWV3TW9kZSA/ICd0ZXh0JyA6ICdpbmhlcml0JywgaXNBY3RpdmUgPyAncmdiYSgyNTUsIDI1NSwgMjU1LCAwLjE1KScgOiAndHJhbnNwYXJlbnQnLCBpc0FjdGl2ZSAmJiAnYmx1cig1cHgpJyk7IH0sXHJcbn07XHJcbnZhciB0ZW1wbGF0ZU9iamVjdF8xO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZXMuanMubWFwIl19 */")])), isTextCursorActive && !isPreviewMode ? 'text' : 'inherit', isActive ? 'rgba(255, 255, 255, 0.15)' : 'transparent', isActive && 'blur(5px)');
  }
};
var templateObject_1$8;

var TextElement = function (props) {
  var element = props.element,
      elementId = props.elementId,
      panelLocation = props.panelLocation,
      panelSize = props.panelSize,
      scaledPanelWidth = props.scaledPanelWidth,
      isPanelLocked = props.isPanelLocked,
      isFullPanelElement = props.isFullPanelElement,
      isPreviewMode = props.isPreviewMode,
      isUsingOldFlattener = props.isUsingOldFlattener;
  var actions = useReduxActions();
  var isTextCursorActive = useReduxState('editorChrome').isTextCursorActive;
  var activeElement = useReduxState('editor').activeElement;
  var isActive = activeElement.location === element.location;
  var x = element.x,
      y = element.y,
      z = element.z,
      rotation = element.rotation,
      height = element.height,
      width = element.width;

  var selectText = function (start, end) {
    actions.selectElement({
      location: element.location,
      type: 'text'
    }, panelLocation, start, end);
  };

  var selectTextElement = function () {
    if (element.text) {
      selectText(element.text.selectionUpperBound);
    }
  };

  var hasNoTextInElement = !!(element.text && element.text.paragraphs.length === 1 && element.text.paragraphs[0].fragments.length === 0);
  var flattenerScaleRatio = isUsingOldFlattener ? 1.395 : 1;
  var textScale = panelSize.width / scaledPanelWidth * flattenerScaleRatio;
  return jsx(Element, {
    x: x,
    y: y,
    z: z,
    rotation: rotation,
    height: height,
    width: width,
    elementId: elementId,
    showBorder: element.isSelected || hasNoTextInElement,
    panelSize: panelSize,
    panelIsLocked: isPanelLocked,
    element: element,
    panelLocation: panelLocation,
    onEdit: function () {
      selectTextElement();
      actions.openElementSettingsDrawer(panelLocation === null ? 'panel' : 'text');
      actions.closeElementInsertDrawer();
    },
    isFullPanelElement: isFullPanelElement,
    isPreviewMode: isPreviewMode
  }, jsx("div", {
    css: styles$3.contents(isTextCursorActive, isActive, isPreviewMode)
  }, jsx(React.Fragment, null, element.text && jsx(TextEditor$1, {
    elementProperties: {
      width: width,
      height: height,
      x: x,
      y: y,
      z: z
    },
    elementText: element.text,
    selectText: selectText,
    scale: textScale,
    panelSize: panelSize,
    isPreviewMode: isPreviewMode,
    openElementSettingsDrawer: function () {
      return actions.openElementSettingsDrawer(panelLocation === null ? 'panel' : 'text');
    },
    isUsingOldFlattener: isUsingOldFlattener
  }))));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var styles$4 = {
  fullbleedPanel: process.env.NODE_ENV === "production" ? {
    name: "1cjuka5",
    styles: "background:transparent;box-shadow:0 8px 22px 0 rgba(0, 0, 0, 0.175);width:100%;height:100%;cursor:default;z-index:4"
  } : {
    name: "16bxou2-fullbleedPanel",
    styles: "background:transparent;box-shadow:0 8px 22px 0 rgba(0, 0, 0, 0.175);width:100%;height:100%;cursor:default;z-index:4;label:fullbleedPanel;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
  },
  panelContainer: function (props, panelView, isPreview) {
    return /*#__PURE__*/css(__assign(__assign({}, styles$4.fullbleedPanel), {
      display: 'flex',
      justifyContent: 'center',
      width: panelView === 'fullbleed' ? props.panel.width * 100 + "%" : '100%',
      height: panelView === 'fullbleed' ? props.panel.height * 100 + "%" : '100%',
      position: 'relative',
      zIndex: props.isActivePanel && !isPreview ? 100 : 3,
      '&::after': props.isActivePanel && !isPreview ? {
        content: '""',
        position: 'absolute',
        top: -3,
        left: -3,
        width: 'calc(100% + 6px)',
        height: 'calc(100% + 6px)',
        background: 'blue'
      } : {}
    }), process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  },
  panelContents: function (isEditingFullBleed, isPreviewMode) {
    return /*#__PURE__*/css({
      cursor: isEditingFullBleed || isPreviewMode ? 'grab' : 'pointer',
      position: 'relative',
      height: '100%',
      width: '100%',
      // backgroundColor: '#ffffff',
      // border: `2px solid ${isSelected ? activeColor : 'transparent'}`, TODO Active Panel Border causing issues
      zIndex: 3
    }, process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  }
};

/**
 * Description:
 * This hook allows us to convert image assets from soc-editor-backend (or any other source) to a new URL that
 * is hosted in soc-backend. This is necessary because in order to print images they have to exists in the hosted
 * source that soc-backend uses. Currently (05/05/2022) the mutation that is used is in soc-frontend is called getOrCreateImageForStickerUrl.
 *
 * How it Works:
 * 1. The onClientAssetConversion (getOrCreateImageForStickerUrl in soc-frontend) gets called, it takes the URL (url hosted in soc-editor-backend).
 * 2. The callback then returns a new Image object and assigns the newly created URL to the url & thumbnailUrl fields, the original (soc-editor-backend) url gets assigned to stickerUrl
 *    - E.G:
 *          {
 *            id: New ID
 *            url: New URL
 *            thumbnail: New URL
 *            stickerUrl: Original URL that gets passed as onClientAssetConversion parameter
 *          }
 * 3. Once we have the new Image object we fire the updateClientAsset action that will update the current image element with the new image object
 *
 * @param url
 * @param onClientAssetConversion
 */

var useClientAsset = function (url, onClientAssetConversion) {
  var actions = useReduxActions();
  var getAsset = useCallback(function () {
    return __awaiter(this, void 0, void 0, function () {
      var image;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , onClientAssetConversion(url)];

          case 1:
            image = _a.sent();
            actions.updateClientAsset(image);
            return [2
            /*return*/
            ];
        }
      });
    });
  }, []); //eslint-disable-line

  useEffect(function () {
    getAsset();
  }, []); //eslint-disable-line
};

var StickerElement = function (_a) {
  var _b, _c, _d;

  var element = _a.element,
      id = _a.id,
      panelLocation = _a.panelLocation,
      isPreviewMode = _a.isPreviewMode,
      isPanelLocked = _a.isPanelLocked,
      panelSize = _a.panelSize,
      onClientAssetConversion = _a.onClientAssetConversion;
  var x = element.x,
      y = element.y,
      z = element.z,
      rotation = element.rotation,
      height = element.height,
      width = element.width;

  var _e = __read(useState(false), 2),
      isLoaded = _e[0],
      setIsLoaded = _e[1];

  var sticker = element.image;
  var actions = useReduxActions();
  var elementSettingsDrawerType = useReduxState('editorChrome').elementSettingsDrawerType;
  var showLoadingSpinner = !isLoaded && !!(sticker === null || sticker === void 0 ? void 0 : sticker.image);
  useClientAsset((_c = (_b = sticker === null || sticker === void 0 ? void 0 : sticker.image) === null || _b === void 0 ? void 0 : _b.stickerUrl) !== null && _c !== void 0 ? _c : '', onClientAssetConversion);
  return jsx(Element, {
    x: x,
    y: y,
    z: z,
    rotation: rotation,
    height: height,
    width: width,
    elementId: id,
    element: element,
    panelLocation: panelLocation,
    panelIsLocked: isPanelLocked,
    isFullPanelElement: false,
    showBorder: false,
    panelSize: panelSize,
    nonDraggableSelector: '.nonDraggable',
    isPreviewMode: isPreviewMode,
    onEdit: function () {
      if (isPreviewMode) {
        return;
      }

      actions.closeElementSettingsDrawer();
      actions.setShouldReplaceSelectedImage(false);
    },
    isFullBleedBackground: false
  }, sticker && ((_d = sticker.image) === null || _d === void 0 ? void 0 : _d.url) && jsx(AvatarEditor, {
    image: sticker.image.url,
    width: element.points.width,
    height: element.points.height,
    border: 0,
    scale: sticker.scale || 1,
    position: sticker.position,
    onImageReady: function () {
      return setIsLoaded(true);
    },
    style: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      opacity: isLoaded || !sticker.image ? 1 : 0,
      transition: 'opacity 500ms',
      zIndex: elementSettingsDrawerType === 'panel' ? 102 : 1
    }
  }), showLoadingSpinner && jsx(LoadingSpinner, {
    size: "medium"
  }));
};

var getElementId = function (editorId, panelIndex, elementIndex) {
  return "editor_" + editorId + "_panel_" + panelIndex + "_element_" + elementIndex;
};

var Panel = function (props) {
  var panel = props.panel,
      panelIndex = props.panelIndex,
      scaledPanelWidth = props.scaledPanelWidth,
      onSelectPanel = props.onSelectPanel,
      // isPanelLabelHidden,
  isPreviewMode = props.isPreviewMode,
      isUsingOldFlattener = props.isUsingOldFlattener,
      onClientAssetConversion = props.onClientAssetConversion;

  var _a = useReduxState('editor'),
      editing = _a.editing,
      fullBleedLocation = _a.fullBleedLocation;

  var actions = useReduxActions();
  var isEditingFullBleed = editing === 'fullbleed';

  var handleSelectPanel = function (event, location) {
    var target = event.target;

    if (target.id !== 'panel-content') {
      return;
    }

    if (isEditingFullBleed) {
      return;
    }

    onSelectPanel(location, fullBleedLocation); // Editor Chrome Actions

    if (fullBleedLocation !== 0 || !panel.isLocked) actions.openElementSettingsDrawer('panel');else {
      actions.closeElementSettingsDrawer();
      actions.closeElementInsertDrawer();
    }
  };

  var _b = useContext(EditorContext),
      panelView = _b.panelView,
      editorId = _b.editorId;

  return jsx("div", {
    id: "editor_" + editorId + "_panel_" + panelIndex,
    css: styles$4.panelContainer(props, panelView, isPreviewMode),
    onMouseDown: function (event) {
      if (isPreviewMode) {
        return;
      }

      handleSelectPanel(event, panel.location);
    }
  }, jsx(ReactResizeDetector, {
    handleHeight: true,
    handleWidth: true,
    render: function (_a) {
      var width = _a.width,
          height = _a.height;
      return jsx("div", {
        id: "panel-content",
        css: [styles$4.panelContents(isEditingFullBleed, isPreviewMode), {
          backgroundColor: panel.backgroundColor ? rgbString(panel.backgroundColor) : undefined
        }, process.env.NODE_ENV === "production" ? "" : ";label:Panel;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
      }, panel.elements.length > 0 ? panel.elements.map(function (element, index) {
        var _a, _b, _c, _d;

        return jsx(React.Fragment, {
          key: index
        }, element.text ? jsx(TextElement, {
          elementId: getElementId(editorId, panelIndex, element.location),
          element: element,
          panelLocation: panel.location,
          panelSize: {
            width: width,
            height: height
          },
          scaledPanelWidth: scaledPanelWidth,
          isPreviewMode: isPreviewMode,
          isFullPanelElement: (_a = element.isFullPanel) !== null && _a !== void 0 ? _a : false,
          isPanelLocked: panel.isLocked,
          isUsingOldFlattener: isUsingOldFlattener
        }) : ((_c = (_b = element.image) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.isSticker) ? jsx(StickerElement, {
          id: getElementId(editorId, panelIndex, element.location),
          element: element,
          panelLocation: panel.location,
          isPanelLocked: panel.isLocked,
          panelSize: {
            width: width,
            height: height
          },
          isPreviewMode: isPreviewMode,
          onClientAssetConversion: onClientAssetConversion
        }) : element.image && jsx(ImageElement$1, {
          elementId: getElementId(editorId, panelIndex, element.location),
          element: element,
          panelLocation: panel.location,
          isPanelLocked: panel.isLocked,
          panelSize: {
            width: width,
            height: height
          },
          isPreviewMode: isPreviewMode,
          isFullPanelElement: (_d = element.isFullPanel) !== null && _d !== void 0 ? _d : false
        }));
      }) : jsx(React.Fragment, null));
    }
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var styles$5 = {
  fullbleedContainer: process.env.NODE_ENV === "production" ? {
    name: "1nxtnvz",
    styles: "position:relative;box-shadow:0px 2px 4px 0px rgba(0,0,0,0.08);background:#FFF"
  } : {
    name: "urvcuy-fullbleedContainer",
    styles: "position:relative;box-shadow:0px 2px 4px 0px rgba(0,0,0,0.08);background:#FFF;label:fullbleedContainer;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHd0IiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBmdWxsYmxlZWRDb250YWluZXI6IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDJweCA0cHggMHB4IHJnYmEoMCwwLDAsMC4wOCknLFxyXG4gICAgICAgIGJhY2tncm91bmQ6ICcjRkZGJyxcclxuICAgIH0pLFxyXG4gICAgZnVsbGJsZWVkUGFuZWxzOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcclxuICAgIH0pLFxyXG4gICAgYmFja2dyb3VuZEVsZW1lbnQ6IGZ1bmN0aW9uICh3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSwgW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSkpLCB3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
  },
  fullbleedPanels: process.env.NODE_ENV === "production" ? {
    name: "36um8q",
    styles: "position:relative;display:flex;width:100%;height:100%;overflow:hidden"
  } : {
    name: "11qz17z-fullbleedPanels",
    styles: "position:relative;display:flex;width:100%;height:100%;overflow:hidden;label:fullbleedPanels;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRcUIiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBmdWxsYmxlZWRDb250YWluZXI6IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDJweCA0cHggMHB4IHJnYmEoMCwwLDAsMC4wOCknLFxyXG4gICAgICAgIGJhY2tncm91bmQ6ICcjRkZGJyxcclxuICAgIH0pLFxyXG4gICAgZnVsbGJsZWVkUGFuZWxzOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcclxuICAgIH0pLFxyXG4gICAgYmFja2dyb3VuZEVsZW1lbnQ6IGZ1bmN0aW9uICh3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSwgW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSkpLCB3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
  },
  backgroundElement: function (width, height, translate) {
    return /*#__PURE__*/css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n    #backgroundImage {\n      width: ", ";\n      height: ", ";\n      transform: ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFlb0UiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBmdWxsYmxlZWRDb250YWluZXI6IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDJweCA0cHggMHB4IHJnYmEoMCwwLDAsMC4wOCknLFxyXG4gICAgICAgIGJhY2tncm91bmQ6ICcjRkZGJyxcclxuICAgIH0pLFxyXG4gICAgZnVsbGJsZWVkUGFuZWxzOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcclxuICAgIH0pLFxyXG4gICAgYmFja2dyb3VuZEVsZW1lbnQ6IGZ1bmN0aW9uICh3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSwgW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSkpLCB3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")], ["\n    #backgroundImage {\n      width: ", ";\n      height: ", ";\n      transform: ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFlb0UiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBmdWxsYmxlZWRDb250YWluZXI6IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDJweCA0cHggMHB4IHJnYmEoMCwwLDAsMC4wOCknLFxyXG4gICAgICAgIGJhY2tncm91bmQ6ICcjRkZGJyxcclxuICAgIH0pLFxyXG4gICAgZnVsbGJsZWVkUGFuZWxzOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcclxuICAgIH0pLFxyXG4gICAgYmFja2dyb3VuZEVsZW1lbnQ6IGZ1bmN0aW9uICh3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpIHsgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSwgW1wiXFxuICAgICNiYWNrZ3JvdW5kSW1hZ2Uge1xcbiAgICAgIHdpZHRoOiBcIiwgXCI7XFxuICAgICAgaGVpZ2h0OiBcIiwgXCI7XFxuICAgICAgdHJhbnNmb3JtOiBcIiwgXCI7XFxuICAgIH1cXG4gIFwiXSkpLCB3aWR0aCwgaGVpZ2h0LCB0cmFuc2xhdGUpOyB9LFxyXG59O1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */")])), width, height, translate);
  }
};
var templateObject_1$9;

var FullBleed = function (_a) {
  var activePanel = _a.activePanel,
      isHorizontal = _a.isHorizontal,
      onSelectPanel = _a.onSelectPanel,
      fullBleed = _a.fullBleed,
      hidePanelLabel = _a.hidePanelLabel,
      isPreviewMode = _a.isPreviewMode,
      panelsTotal = _a.panelsTotal,
      isUsingOldFlattener = _a.isUsingOldFlattener,
      onClientAssetConversion = _a.onClientAssetConversion;
  var fbHeight = fullBleed.height,
      fbWidth = fullBleed.width,
      panels = fullBleed.panels,
      backgroundElement = fullBleed.backgroundElement;
  var editing = useReduxState('editor').editing;
  var actions = useReduxActions();
  var panelView = useContext(EditorContext).panelView;
  var width = panelView === 'fullbleed' ? fbWidth : panels[0].width * fbWidth;
  var height = panelView === 'fullbleed' ? fbHeight : panels[0].height * fbHeight;
  return jsx(ReactResizeDetector, {
    handleHeight: true,
    handleWidth: true
  }, function (_a) {
    var _b;

    var parentWidth = _a.width,
        parentHeight = _a.height;
    var heightMax = {
      height: parentHeight || 0,
      width: parentHeight / height * width || 0
    };
    var widthMax = {
      width: parentWidth || 0,
      height: parentWidth / width * height || 0
    };
    var isHeightWithinBounds = heightMax.height <= parentHeight && heightMax.width <= parentWidth;
    var isWidthWithinBounds = widthMax.height <= parentHeight && widthMax.width <= parentWidth;
    var heightArea = heightMax.height * heightMax.width;
    var widthArea = widthMax.height * widthMax.width;
    var hasReachedLimitHeight = isHeightWithinBounds && isWidthWithinBounds ? heightArea > widthArea : isHeightWithinBounds;

    var getPercentageFromPanelCount = function () {
      return panelsTotal === 3 ? '300%' : panelsTotal === 2 ? '200%' : '100%';
    };

    var calcElementWidth = function () {
      return isHorizontal || panelView === 'fullbleed' ? '100%' : getPercentageFromPanelCount();
    };

    var calcElementHeight = function () {
      return !isHorizontal || panelView === 'fullbleed' ? '100%' : getPercentageFromPanelCount();
    };

    var getBackgroundDisplayTransform = function () {
      if (panelView === 'fullbleed') return 'translateX(0)';

      if (panelsTotal === 3 && activePanel === 2) {
        return isHorizontal ? "translateY(-" + 100 * (2 / 3) + "%)" : "translateX(-" + 100 * (2 / 3) + "%)";
      } else if (panelsTotal === 3 && activePanel === 1) {
        return isHorizontal ? "translateY(-" + 100 * (1 / 3) + "%)" : "translateX(-" + 100 * (1 / 3) + "%)";
      } else if (panelsTotal === 2 && activePanel === 1) {
        return isHorizontal ? "translateY(-50%)" : "translateX(-50%)";
      }

      return isHorizontal ? "translateY(0)" : "translateX(0)";
    };

    return jsx("div", {
      id: 'fullbleed',
      css: [styles$5.fullbleedContainer, __assign({}, hasReachedLimitHeight ? heightMax : widthMax), process.env.NODE_ENV === "production" ? "" : ";label:FullBleed;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
    }, jsx("div", {
      css: [styles$5.fullbleedPanels, {
        flexDirection: isHorizontal ? 'row' : 'column'
      }, process.env.NODE_ENV === "production" ? "" : ";label:FullBleed;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
    }, editing === 'fullbleed' && !((_b = backgroundElement === null || backgroundElement === void 0 ? void 0 : backgroundElement.image) === null || _b === void 0 ? void 0 : _b.image) && !isPreviewMode && jsx(Flex, {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      onClick: function () {
        return actions.openElementInsertDrawer('images');
      },
      cursor: "pointer"
    }, jsx(EmptyImage, {
      type: "fullbleed",
      title: "Add full background image"
    })), (backgroundElement === null || backgroundElement === void 0 ? void 0 : backgroundElement.image) && jsx(Div, {
      css: styles$5.backgroundElement(calcElementWidth(), calcElementHeight(), getBackgroundDisplayTransform())
    }, jsx(ImageElement$1, {
      isFullPanelElement: false,
      elementId: 'backgroundImage',
      element: backgroundElement,
      panelLocation: null,
      isFullBleedBackground: true,
      panelSize: hasReachedLimitHeight ? heightMax : widthMax,
      isPreviewMode: isPreviewMode,
      isPanelLocked: false
    })), editing !== 'fullbleed' && panels.map(function (panel) {
      return jsx(Panel, {
        isPanelLabelHidden: hidePanelLabel,
        key: panel.location,
        panel: panel,
        panelIndex: panel.location,
        scaledPanelWidth: fullBleed.width * panel.width,
        onSelectPanel: onSelectPanel,
        isActivePanel: activePanel === panel.location,
        isPreviewMode: isPreviewMode,
        isUsingOldFlattener: isUsingOldFlattener,
        onClientAssetConversion: onClientAssetConversion
      });
    })));
  });
};

var useDebouncedEffect = function (effect, deps, delay) {
  if (delay === void 0) {
    delay = 250;
  }

  useEffect(function () {
    var handler = setTimeout(function () {
      return effect();
    }, delay);
    return function () {
      return clearTimeout(handler);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, __spread(deps || [], [delay]));
};

var Editor = function (_a) {
  var card = _a.card,
      onSave = _a.onSave,
      panelView = _a.panelView,
      currentIndex = _a.currentIndex,
      isUsingOldFlattener = _a.isUsingOldFlattener,
      onClientAssetConversion = _a.onClientAssetConversion;
  var editor = useReduxState('editor');
  var interactionMode = useReduxState('editorChrome').interactionMode;
  var isPreviewMode = interactionMode === 'preview';
  var activeFullBleedLocation = editor.fullBleedLocation,
      activePanelLocation = editor.panelLocation,
      reduxCard = editor.card;
  var isHorizontal = !!editor.card && editor.card.orientation === 'LANDSCAPE';
  var fullBleeds = computedFullBleeds(editor);
  var panels = editor.card && computedSingleFullBleeds(editor);
  var panelLocations = editor.card ? getPanelLocations(editor) : [];
  var actions = useReduxActions();
  var id = Date.now();

  var _b = __read(useState(reduxCard), 2),
      savedCard = _b[0],
      setSavedCard = _b[1];

  var selectedFullBleed = panelView === 'fullbleed' && fullBleeds ? fullBleeds[activeFullBleedLocation] : panels ? panels[currentIndex] : null;
  var context = {
    currentIndex: currentIndex,
    panelView: panelView,
    editorId: id
  };
  var hasHorizontalAspectRatio = selectedFullBleed ? isHorizontalFullBleed(panelView, activeFullBleedLocation, card.fullBleeds.length, selectedFullBleed.panels.length, isHorizontal) : false;

  var handleSelectPanel = function () {
    if (panelView === 'fullbleed') {
      actions.selectFullBleed(currentIndex);
    } else {
      if (panelLocations && !!panelLocations.length) {
        var _a = panelLocations[currentIndex],
            fullbleed = _a.fullbleed,
            panel = _a.panel;
        actions.selectSinglePanel(fullbleed, panel);
      }
    } // EditorChrome Actions


    if (activeFullBleedLocation !== 0 && !card.fullBleeds[0].panels[0].isLocked) actions.openElementSettingsDrawer('panel');
  };

  useDebouncedEffect(function () {
    if (reduxCard) {
      if (!equal(savedCard, reduxCard)) {
        setSavedCard(reduxCard);
        onSave(reduxCard);
      }
    }
  }, [reduxCard, isPreviewMode]); //eslint-disable-line

  useDebouncedEffect(function () {
    if (card) {
      actions.loadedCard(card);
      if (!isPreviewMode) handleSelectPanel();
    }

    return function () {
      actions.resetState();
    };
  }, [card, isPreviewMode]); //eslint-disable-line

  return reduxCard && selectedFullBleed ? jsx(EditorProvider, {
    value: context
  }, jsx(FullBleed, {
    activePanel: activePanelLocation,
    fullBleed: selectedFullBleed,
    isHorizontal: hasHorizontalAspectRatio,
    onSelectPanel: actions.selectPanel,
    isPreviewMode: isPreviewMode,
    panelsTotal: card.fullBleeds[activeFullBleedLocation].panels.length,
    isUsingOldFlattener: isUsingOldFlattener,
    onClientAssetConversion: onClientAssetConversion
  })) : jsx(React.Fragment, null);
};

var useUserSnapEffect = function () {
  var _a;

  var usersnapButton = document.getElementsByName('us-entrypoint-button')[0];

  if (usersnapButton) {
    return;
  }

  var mutableScript = document.createElement('script');
  mutableScript.type = 'text/javascript';
  mutableScript.async = true;
  mutableScript.src = '//api.usersnap.com/load/e00dd5b1-8ec8-4ab5-b5c6-ca140a3a1268.js';
  var x = document.getElementsByTagName('script')[0];
  (_a = x.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(mutableScript, x);
};

var App = function (props) {
  var _a, _b, _c;

  var layouts = props.layouts,
      images = props.images,
      fonts = props.fonts,
      signatures = props.signatures,
      placeholders = props.placeholders,
      onUploadImages = props.onUploadImages,
      onSave = props.onSave,
      card = props.card,
      onSelectLayout = props.onSelectLayout,
      contextZones = props.contextZones,
      theme = props.theme,
      customBackPanels = props.customBackPanels,
      defaultBackPanels = props.defaultBackPanels,
      onDeleteBackPanel = props.onDeleteBackPanel,
      onDeleteImage = props.onDeleteImage,
      onCreateBackPanel = props.onCreateBackPanel,
      onSaveBackPanel = props.onSaveBackPanel,
      onSelectBackLayout = props.onSelectBackLayout,
      userInfo = props.userInfo,
      onClientAssetConversion = props.onClientAssetConversion,
      defaultBackPanel = props.defaultBackPanel,
      isUsingOldFlattener = props.isUsingOldFlattener,
      colorPalettes = props.colorPalettes;
  LogRocket.init('0xqcnb/editor-20');
  LogRocket.identify((_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) !== null && _a !== void 0 ? _a : 'none', {
    name: (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) !== null && _b !== void 0 ? _b : '',
    email: (_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) !== null && _c !== void 0 ? _c : ''
  });

  var _d = __read(React.useState('fullbleed'), 2),
      panelView = _d[0],
      setPanelView = _d[1];

  var _e = __read(React.useState(0), 2),
      currentIndex = _e[0],
      setCurrentIndex = _e[1];

  var _f = __read(React.useState(0), 2),
      currentPanelIndex = _f[0],
      setCurrentPanelIndex = _f[1];

  var lastFullBleed = card.fullBleeds.length - 1;
  var actions = useReduxActions();
  var isFrontPanelLocked = card.fullBleeds[0].panels[0].isLocked;
  useUserSnapEffect();
  var release = useReduxState('editorChrome').release;
  var editor = useReduxState('editor');
  var panelLocations = editor.card ? getPanelLocations(editor) : [];
  var lastPanel = panelLocations.length - 1;

  var handleSettingsDrawer = function (currentIndex) {
    if (!isFrontPanelLocked) return;
    if (currentIndex === 0) actions.openElementSettingsDrawer('panel');else actions.closeElementSettingsDrawer();
  };

  var getCurrentPanelIndex = function () {
    var _a;

    var currentPanelLocation = (_a = editor.panelLocation) !== null && _a !== void 0 ? _a : 0;
    return card.fullBleeds.slice(0, editor.fullBleedLocation).reduce(function (sum, fullBleed) {
      return sum + fullBleed.panels.length;
    }, 0) + currentPanelLocation;
  };

  var handlePreviousPanel = function () {
    var prevFullBleed = currentIndex - 1;
    var prevPanel = currentPanelIndex - 1;
    handleSettingsDrawer(currentIndex);

    if (panelView === 'fullbleed') {
      setCurrentIndex(prevFullBleed >= 0 ? prevFullBleed : lastFullBleed);
      actions.selectFullBleed(prevFullBleed >= 0 ? prevFullBleed : lastFullBleed);
    } else {
      var selectedPanelIndex = prevPanel >= 0 ? prevPanel : lastPanel;
      var _a = panelLocations[selectedPanelIndex],
          fullbleed = _a.fullbleed,
          panel = _a.panel;
      actions.selectSinglePanel(fullbleed, panel);
      setCurrentPanelIndex(selectedPanelIndex);
    }

    actions.setIsTextCursorActive(false);
  };

  var handleNextPanel = function () {
    var next = currentIndex + 1;
    var nextPanel = currentPanelIndex + 1;
    handleSettingsDrawer(currentIndex);

    if (panelView === 'fullbleed') {
      setCurrentIndex(next > lastFullBleed ? 0 : next);
      actions.selectFullBleed(next > lastFullBleed ? 0 : next);
    } else {
      var selectedPanelIndex = nextPanel > lastPanel ? 0 : nextPanel;
      var _a = panelLocations[selectedPanelIndex],
          fullbleed = _a.fullbleed,
          panel = _a.panel;
      actions.selectSinglePanel(fullbleed, panel);
      setCurrentPanelIndex(selectedPanelIndex);
    }

    actions.setIsTextCursorActive(false);
  };

  var handleChangeView = function (viewMode) {
    setPanelView(viewMode);
    viewMode === 'panel' ? setCurrentPanelIndex(getCurrentPanelIndex()) : setCurrentIndex(editor.fullBleedLocation);
  };

  var _g = __read(defaultBackPanel, 2),
      backPanelId = _g[0],
      setBackPanelId = _g[1];

  return jsx(React.Fragment, null, jsx(Global, {
    styles: [fonts.map(function (font) {
      return /*#__PURE__*/css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), font.fontName, font.ttfFile);
    }), signatures === null || signatures === void 0 ? void 0 : signatures.map(function (signature) {
      return /*#__PURE__*/css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), signature.fontName, signature.ttfFile);
    }), process.env.NODE_ENV === "production" ? "" : ";label:App;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFwcC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUZjIiwiZmlsZSI6IkFwcC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBfX21ha2VUZW1wbGF0ZU9iamVjdCwgX19yZWFkIH0gZnJvbSBcInRzbGliXCI7XHJcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XHJcbmltcG9ydCB7IEdsb2JhbCwgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5pbXBvcnQgRWRpdG9yQ2hyb21lIGZyb20gXCIuLi9jb250YWluZXJzL0VkaXRvckNocm9tZS9FZGl0b3JDaHJvbWVcIjtcclxuaW1wb3J0IHsgRGl2LCBJY29uIH0gZnJvbSAnQHNlbmRvdXRjYXJkcy9xdWFudHVtLWRlc2lnbi11aSc7XHJcbmltcG9ydCBFZGl0b3IgZnJvbSBcIi4uL2NvbnRhaW5lcnMvRWRpdG9yL0VkaXRvclwiO1xyXG5pbXBvcnQgdXNlUmVkdXhBY3Rpb25zIGZyb20gXCIuLi9ob29rcy91c2VSZWR1eEFjdGlvbnNcIjtcclxuaW1wb3J0IHVzZVVzZXJTbmFwRWZmZWN0IGZyb20gXCIuLi9ob29rcy91c2VVc2VyU25hcEVmZmVjdFwiO1xyXG5pbXBvcnQgTG9nUm9ja2V0IGZyb20gJ2xvZ3JvY2tldCc7XHJcbmltcG9ydCB1c2VSZWR1eFN0YXRlIGZyb20gXCIuLi9ob29rcy91c2VSZWR1eFN0YXRlXCI7XHJcbmltcG9ydCB7IGdldFBhbmVsTG9jYXRpb25zIH0gZnJvbSBcIi4uL3NlbGVjdG9ycy9lZGl0b3JTZWxlY3RvcnNcIjtcclxudmFyIEFwcCA9IGZ1bmN0aW9uIChwcm9wcykge1xyXG4gICAgdmFyIF9hLCBfYiwgX2M7XHJcbiAgICB2YXIgbGF5b3V0cyA9IHByb3BzLmxheW91dHMsIGltYWdlcyA9IHByb3BzLmltYWdlcywgZm9udHMgPSBwcm9wcy5mb250cywgc2lnbmF0dXJlcyA9IHByb3BzLnNpZ25hdHVyZXMsIHBsYWNlaG9sZGVycyA9IHByb3BzLnBsYWNlaG9sZGVycywgb25VcGxvYWRJbWFnZXMgPSBwcm9wcy5vblVwbG9hZEltYWdlcywgb25TYXZlID0gcHJvcHMub25TYXZlLCBjYXJkID0gcHJvcHMuY2FyZCwgb25TZWxlY3RMYXlvdXQgPSBwcm9wcy5vblNlbGVjdExheW91dCwgY29udGV4dFpvbmVzID0gcHJvcHMuY29udGV4dFpvbmVzLCB0aGVtZSA9IHByb3BzLnRoZW1lLCBjdXN0b21CYWNrUGFuZWxzID0gcHJvcHMuY3VzdG9tQmFja1BhbmVscywgZGVmYXVsdEJhY2tQYW5lbHMgPSBwcm9wcy5kZWZhdWx0QmFja1BhbmVscywgb25EZWxldGVCYWNrUGFuZWwgPSBwcm9wcy5vbkRlbGV0ZUJhY2tQYW5lbCwgb25EZWxldGVJbWFnZSA9IHByb3BzLm9uRGVsZXRlSW1hZ2UsIG9uQ3JlYXRlQmFja1BhbmVsID0gcHJvcHMub25DcmVhdGVCYWNrUGFuZWwsIG9uU2F2ZUJhY2tQYW5lbCA9IHByb3BzLm9uU2F2ZUJhY2tQYW5lbCwgb25TZWxlY3RCYWNrTGF5b3V0ID0gcHJvcHMub25TZWxlY3RCYWNrTGF5b3V0LCB1c2VySW5mbyA9IHByb3BzLnVzZXJJbmZvLCBvbkNsaWVudEFzc2V0Q29udmVyc2lvbiA9IHByb3BzLm9uQ2xpZW50QXNzZXRDb252ZXJzaW9uLCBkZWZhdWx0QmFja1BhbmVsID0gcHJvcHMuZGVmYXVsdEJhY2tQYW5lbCwgaXNVc2luZ09sZEZsYXR0ZW5lciA9IHByb3BzLmlzVXNpbmdPbGRGbGF0dGVuZXIsIGNvbG9yUGFsZXR0ZXMgPSBwcm9wcy5jb2xvclBhbGV0dGVzO1xyXG4gICAgTG9nUm9ja2V0LmluaXQoJzB4cWNuYi9lZGl0b3ItMjAnKTtcclxuICAgIExvZ1JvY2tldC5pZGVudGlmeSgoX2EgPSB1c2VySW5mbyA9PT0gbnVsbCB8fCB1c2VySW5mbyA9PT0gdm9pZCAwID8gdm9pZCAwIDogdXNlckluZm8uaWQpICE9PSBudWxsICYmIF9hICE9PSB2b2lkIDAgPyBfYSA6ICdub25lJywge1xyXG4gICAgICAgIG5hbWU6IChfYiA9IHVzZXJJbmZvID09PSBudWxsIHx8IHVzZXJJbmZvID09PSB2b2lkIDAgPyB2b2lkIDAgOiB1c2VySW5mby5uYW1lKSAhPT0gbnVsbCAmJiBfYiAhPT0gdm9pZCAwID8gX2IgOiAnJyxcclxuICAgICAgICBlbWFpbDogKF9jID0gdXNlckluZm8gPT09IG51bGwgfHwgdXNlckluZm8gPT09IHZvaWQgMCA/IHZvaWQgMCA6IHVzZXJJbmZvLmVtYWlsKSAhPT0gbnVsbCAmJiBfYyAhPT0gdm9pZCAwID8gX2MgOiAnJyxcclxuICAgIH0pO1xyXG4gICAgdmFyIF9kID0gX19yZWFkKFJlYWN0LnVzZVN0YXRlKCdmdWxsYmxlZWQnKSwgMiksIHBhbmVsVmlldyA9IF9kWzBdLCBzZXRQYW5lbFZpZXcgPSBfZFsxXTtcclxuICAgIHZhciBfZSA9IF9fcmVhZChSZWFjdC51c2VTdGF0ZSgwKSwgMiksIGN1cnJlbnRJbmRleCA9IF9lWzBdLCBzZXRDdXJyZW50SW5kZXggPSBfZVsxXTtcclxuICAgIHZhciBfZiA9IF9fcmVhZChSZWFjdC51c2VTdGF0ZSgwKSwgMiksIGN1cnJlbnRQYW5lbEluZGV4ID0gX2ZbMF0sIHNldEN1cnJlbnRQYW5lbEluZGV4ID0gX2ZbMV07XHJcbiAgICB2YXIgbGFzdEZ1bGxCbGVlZCA9IGNhcmQuZnVsbEJsZWVkcy5sZW5ndGggLSAxO1xyXG4gICAgdmFyIGFjdGlvbnMgPSB1c2VSZWR1eEFjdGlvbnMoKTtcclxuICAgIHZhciBpc0Zyb250UGFuZWxMb2NrZWQgPSBjYXJkLmZ1bGxCbGVlZHNbMF0ucGFuZWxzWzBdLmlzTG9ja2VkO1xyXG4gICAgdXNlVXNlclNuYXBFZmZlY3QoKTtcclxuICAgIHZhciByZWxlYXNlID0gdXNlUmVkdXhTdGF0ZSgnZWRpdG9yQ2hyb21lJykucmVsZWFzZTtcclxuICAgIHZhciBlZGl0b3IgPSB1c2VSZWR1eFN0YXRlKCdlZGl0b3InKTtcclxuICAgIHZhciBwYW5lbExvY2F0aW9ucyA9IGVkaXRvci5jYXJkID8gZ2V0UGFuZWxMb2NhdGlvbnMoZWRpdG9yKSA6IFtdO1xyXG4gICAgdmFyIGxhc3RQYW5lbCA9IHBhbmVsTG9jYXRpb25zLmxlbmd0aCAtIDE7XHJcbiAgICB2YXIgaGFuZGxlU2V0dGluZ3NEcmF3ZXIgPSBmdW5jdGlvbiAoY3VycmVudEluZGV4KSB7XHJcbiAgICAgICAgaWYgKCFpc0Zyb250UGFuZWxMb2NrZWQpXHJcbiAgICAgICAgICAgIHJldHVybjtcclxuICAgICAgICBpZiAoY3VycmVudEluZGV4ID09PSAwKVxyXG4gICAgICAgICAgICBhY3Rpb25zLm9wZW5FbGVtZW50U2V0dGluZ3NEcmF3ZXIoJ3BhbmVsJyk7XHJcbiAgICAgICAgZWxzZVxyXG4gICAgICAgICAgICBhY3Rpb25zLmNsb3NlRWxlbWVudFNldHRpbmdzRHJhd2VyKCk7XHJcbiAgICB9O1xyXG4gICAgdmFyIGdldEN1cnJlbnRQYW5lbEluZGV4ID0gZnVuY3Rpb24gKCkge1xyXG4gICAgICAgIHZhciBfYTtcclxuICAgICAgICB2YXIgY3VycmVudFBhbmVsTG9jYXRpb24gPSAoX2EgPSBlZGl0b3IucGFuZWxMb2NhdGlvbikgIT09IG51bGwgJiYgX2EgIT09IHZvaWQgMCA/IF9hIDogMDtcclxuICAgICAgICByZXR1cm4gKGNhcmQuZnVsbEJsZWVkc1xyXG4gICAgICAgICAgICAuc2xpY2UoMCwgZWRpdG9yLmZ1bGxCbGVlZExvY2F0aW9uKVxyXG4gICAgICAgICAgICAucmVkdWNlKGZ1bmN0aW9uIChzdW0sIGZ1bGxCbGVlZCkge1xyXG4gICAgICAgICAgICByZXR1cm4gc3VtICsgZnVsbEJsZWVkLnBhbmVscy5sZW5ndGg7XHJcbiAgICAgICAgfSwgMCkgKyBjdXJyZW50UGFuZWxMb2NhdGlvbik7XHJcbiAgICB9O1xyXG4gICAgdmFyIGhhbmRsZVByZXZpb3VzUGFuZWwgPSBmdW5jdGlvbiAoKSB7XHJcbiAgICAgICAgdmFyIHByZXZGdWxsQmxlZWQgPSBjdXJyZW50SW5kZXggLSAxO1xyXG4gICAgICAgIHZhciBwcmV2UGFuZWwgPSBjdXJyZW50UGFuZWxJbmRleCAtIDE7XHJcbiAgICAgICAgaGFuZGxlU2V0dGluZ3NEcmF3ZXIoY3VycmVudEluZGV4KTtcclxuICAgICAgICBpZiAocGFuZWxWaWV3ID09PSAnZnVsbGJsZWVkJykge1xyXG4gICAgICAgICAgICBzZXRDdXJyZW50SW5kZXgocHJldkZ1bGxCbGVlZCA+PSAwID8gcHJldkZ1bGxCbGVlZCA6IGxhc3RGdWxsQmxlZWQpO1xyXG4gICAgICAgICAgICBhY3Rpb25zLnNlbGVjdEZ1bGxCbGVlZChwcmV2RnVsbEJsZWVkID49IDAgPyBwcmV2RnVsbEJsZWVkIDogbGFzdEZ1bGxCbGVlZCk7XHJcbiAgICAgICAgfVxyXG4gICAgICAgIGVsc2Uge1xyXG4gICAgICAgICAgICB2YXIgc2VsZWN0ZWRQYW5lbEluZGV4ID0gcHJldlBhbmVsID49IDAgPyBwcmV2UGFuZWwgOiBsYXN0UGFuZWw7XHJcbiAgICAgICAgICAgIHZhciBfYSA9IHBhbmVsTG9jYXRpb25zW3NlbGVjdGVkUGFuZWxJbmRleF0sIGZ1bGxibGVlZCA9IF9hLmZ1bGxibGVlZCwgcGFuZWwgPSBfYS5wYW5lbDtcclxuICAgICAgICAgICAgYWN0aW9ucy5zZWxlY3RTaW5nbGVQYW5lbChmdWxsYmxlZWQsIHBhbmVsKTtcclxuICAgICAgICAgICAgc2V0Q3VycmVudFBhbmVsSW5kZXgoc2VsZWN0ZWRQYW5lbEluZGV4KTtcclxuICAgICAgICB9XHJcbiAgICAgICAgYWN0aW9ucy5zZXRJc1RleHRDdXJzb3JBY3RpdmUoZmFsc2UpO1xyXG4gICAgfTtcclxuICAgIHZhciBoYW5kbGVOZXh0UGFuZWwgPSBmdW5jdGlvbiAoKSB7XHJcbiAgICAgICAgdmFyIG5leHQgPSBjdXJyZW50SW5kZXggKyAxO1xyXG4gICAgICAgIHZhciBuZXh0UGFuZWwgPSBjdXJyZW50UGFuZWxJbmRleCArIDE7XHJcbiAgICAgICAgaGFuZGxlU2V0dGluZ3NEcmF3ZXIoY3VycmVudEluZGV4KTtcclxuICAgICAgICBpZiAocGFuZWxWaWV3ID09PSAnZnVsbGJsZWVkJykge1xyXG4gICAgICAgICAgICBzZXRDdXJyZW50SW5kZXgobmV4dCA+IGxhc3RGdWxsQmxlZWQgPyAwIDogbmV4dCk7XHJcbiAgICAgICAgICAgIGFjdGlvbnMuc2VsZWN0RnVsbEJsZWVkKG5leHQgPiBsYXN0RnVsbEJsZWVkID8gMCA6IG5leHQpO1xyXG4gICAgICAgIH1cclxuICAgICAgICBlbHNlIHtcclxuICAgICAgICAgICAgdmFyIHNlbGVjdGVkUGFuZWxJbmRleCA9IG5leHRQYW5lbCA+IGxhc3RQYW5lbCA/IDAgOiBuZXh0UGFuZWw7XHJcbiAgICAgICAgICAgIHZhciBfYSA9IHBhbmVsTG9jYXRpb25zW3NlbGVjdGVkUGFuZWxJbmRleF0sIGZ1bGxibGVlZCA9IF9hLmZ1bGxibGVlZCwgcGFuZWwgPSBfYS5wYW5lbDtcclxuICAgICAgICAgICAgYWN0aW9ucy5zZWxlY3RTaW5nbGVQYW5lbChmdWxsYmxlZWQsIHBhbmVsKTtcclxuICAgICAgICAgICAgc2V0Q3VycmVudFBhbmVsSW5kZXgoc2VsZWN0ZWRQYW5lbEluZGV4KTtcclxuICAgICAgICB9XHJcbiAgICAgICAgYWN0aW9ucy5zZXRJc1RleHRDdXJzb3JBY3RpdmUoZmFsc2UpO1xyXG4gICAgfTtcclxuICAgIHZhciBoYW5kbGVDaGFuZ2VWaWV3ID0gZnVuY3Rpb24gKHZpZXdNb2RlKSB7XHJcbiAgICAgICAgc2V0UGFuZWxWaWV3KHZpZXdNb2RlKTtcclxuICAgICAgICB2aWV3TW9kZSA9PT0gJ3BhbmVsJ1xyXG4gICAgICAgICAgICA/IHNldEN1cnJlbnRQYW5lbEluZGV4KGdldEN1cnJlbnRQYW5lbEluZGV4KCkpXHJcbiAgICAgICAgICAgIDogc2V0Q3VycmVudEluZGV4KGVkaXRvci5mdWxsQmxlZWRMb2NhdGlvbik7XHJcbiAgICB9O1xyXG4gICAgdmFyIF9nID0gX19yZWFkKGRlZmF1bHRCYWNrUGFuZWwsIDIpLCBiYWNrUGFuZWxJZCA9IF9nWzBdLCBzZXRCYWNrUGFuZWxJZCA9IF9nWzFdO1xyXG4gICAgcmV0dXJuICg8PlxuICAgICAgPEdsb2JhbCBzdHlsZXM9e1tcclxuICAgICAgICBmb250cy5tYXAoZnVuY3Rpb24gKGZvbnQpIHtcclxuICAgICAgICAgICAgcmV0dXJuIGNzcyh0ZW1wbGF0ZU9iamVjdF8xIHx8ICh0ZW1wbGF0ZU9iamVjdF8xID0gX19tYWtlVGVtcGxhdGVPYmplY3QoW1wiXFxuICAgICAgICAgICAgICBAZm9udC1mYWNlIHtcXG4gICAgICAgICAgICAgICAgZm9udC1mYW1pbHk6ICdcIiwgXCInO1xcbiAgICAgICAgICAgICAgICBzcmM6IHVybCgnXCIsIFwiJykgZm9ybWF0KCd0cnVldHlwZScpO1xcbiAgICAgICAgICAgICAgfVxcbiAgICAgICAgICAgIFwiXSwgW1wiXFxuICAgICAgICAgICAgICBAZm9udC1mYWNlIHtcXG4gICAgICAgICAgICAgICAgZm9udC1mYW1pbHk6ICdcIiwgXCInO1xcbiAgICAgICAgICAgICAgICBzcmM6IHVybCgnXCIsIFwiJykgZm9ybWF0KCd0cnVldHlwZScpO1xcbiAgICAgICAgICAgICAgfVxcbiAgICAgICAgICAgIFwiXSkpLCBmb250LmZvbnROYW1lLCBmb250LnR0ZkZpbGUpO1xyXG4gICAgICAgIH0pLFxyXG4gICAgICAgIHNpZ25hdHVyZXMgPT09IG51bGwgfHwgc2lnbmF0dXJlcyA9PT0gdm9pZCAwID8gdm9pZCAwIDogc2lnbmF0dXJlcy5tYXAoZnVuY3Rpb24gKHNpZ25hdHVyZSkge1xyXG4gICAgICAgICAgICByZXR1cm4gY3NzKHRlbXBsYXRlT2JqZWN0XzIgfHwgKHRlbXBsYXRlT2JqZWN0XzIgPSBfX21ha2VUZW1wbGF0ZU9iamVjdChbXCJcXG4gICAgICAgICAgICAgIEBmb250LWZhY2Uge1xcbiAgICAgICAgICAgICAgICBmb250LWZhbWlseTogJ1wiLCBcIic7XFxuICAgICAgICAgICAgICAgIHNyYzogdXJsKCdcIiwgXCInKSBmb3JtYXQoJ3RydWV0eXBlJyk7XFxuICAgICAgICAgICAgICB9XFxuICAgICAgICAgICAgXCJdLCBbXCJcXG4gICAgICAgICAgICAgIEBmb250LWZhY2Uge1xcbiAgICAgICAgICAgICAgICBmb250LWZhbWlseTogJ1wiLCBcIic7XFxuICAgICAgICAgICAgICAgIHNyYzogdXJsKCdcIiwgXCInKSBmb3JtYXQoJ3RydWV0eXBlJyk7XFxuICAgICAgICAgICAgICB9XFxuICAgICAgICAgICAgXCJdKSksIHNpZ25hdHVyZS5mb250TmFtZSwgc2lnbmF0dXJlLnR0ZkZpbGUpO1xyXG4gICAgICAgIH0pLFxyXG4gICAgXX0vPlxuICAgICAgPEVkaXRvckNocm9tZSB0aGVtZT17dGhlbWV9IGNvbnRleHRab25lcz17Y29udGV4dFpvbmVzfSBkZWZhdWx0QmFja1BhbmVscz17ZGVmYXVsdEJhY2tQYW5lbHN9IGN1c3RvbUJhY2tQYW5lbHM9e2N1c3RvbUJhY2tQYW5lbHN9IGxheW91dHM9e2xheW91dHN9IGltYWdlcz17aW1hZ2VzfSBmb250cz17Zm9udHN9IHNpZ25hdHVyZXM9e3NpZ25hdHVyZXN9IHBsYWNlaG9sZGVycz17cGxhY2Vob2xkZXJzfSBoYW5kbGVDaGFuZ2VWaWV3PXtoYW5kbGVDaGFuZ2VWaWV3fSBvblVwbG9hZEltYWdlcz17b25VcGxvYWRJbWFnZXN9IGhhbmRsZU5leHRQYW5lbD17aGFuZGxlTmV4dFBhbmVsfSBoYW5kbGVQcmV2aW91c1BhbmVsPXtoYW5kbGVQcmV2aW91c1BhbmVsfSBvbkRlbGV0ZUJhY2tQYW5lbD17b25EZWxldGVCYWNrUGFuZWx9IG9uU2F2ZUJhY2tQYW5lbD17b25TYXZlQmFja1BhbmVsfSBvbkNyZWF0ZUJhY2tQYW5lbD17b25DcmVhdGVCYWNrUGFuZWx9IG9uU2VsZWN0QmFja0xheW91dD17b25TZWxlY3RCYWNrTGF5b3V0fSBvbkRlbGV0ZUltYWdlPXtvbkRlbGV0ZUltYWdlfSBvbkNsaWVudEFzc2V0Q29udmVyc2lvbj17b25DbGllbnRBc3NldENvbnZlcnNpb259IG9uU2V0RGVmYXVsdEJhY2tQYW5lbD17ZGVmYXVsdEJhY2tQYW5lbCA/IHNldEJhY2tQYW5lbElkIDogdW5kZWZpbmVkfSBkZWZhdWx0QmFja1BhbmVsSWQ9e2RlZmF1bHRCYWNrUGFuZWwgPyBiYWNrUGFuZWxJZCA6IHVuZGVmaW5lZH0gY29sb3JQYWxldHRlcz17Y29sb3JQYWxldHRlc30gXHJcbiAgICAvLyBoYW5kbGVQcmV2aWV3PXtoYW5kbGVQcmV2aWV3fVxyXG4gICAgc2NhbGU9ezEwMH0gaGVscEljb249ezxEaXYgb25DbGljaz17ZnVuY3Rpb24gKCkgeyByZXR1cm4gYWN0aW9ucy5zZXRSZWxlYXNlT3BlblN0YXRlKCFyZWxlYXNlLmlzT3Blbik7IH19IGRpc3BsYXk9XCJmbGV4XCIganVzdGlmeUNvbnRlbnQ9XCJjZW50ZXJcIiBhbGlnbkl0ZW1zPVwiY2VudGVyXCIgaW5zZXQ9e3sgYm90dG9tOiAneDInIH19IGN1cnNvcj1cInBvaW50ZXJcIj5cbiAgICAgICAgICAgIDxJY29uIG5hbWU9XCJpbmZvcm1hdGlvblwiIHByaW1hcnlDb2xvcj1cInByaW1hcnlCcmFuZFwiIHNpemU9XCJtZWRpdW1cIi8+XG4gICAgICAgICAgPC9EaXY+fT5cbiAgICAgICAgPEVkaXRvciB7Li4ucHJvcHN9IG9uU2F2ZT17b25TYXZlfSBvblNlbGVjdExheW91dD17b25TZWxlY3RMYXlvdXR9IG9uVXBsb2FkSW1hZ2VzPXtvblVwbG9hZEltYWdlc30gY2FyZD17Y2FyZH0gcGFuZWxWaWV3PXtwYW5lbFZpZXd9IGN1cnJlbnRJbmRleD17cGFuZWxWaWV3ID09PSAnZnVsbGJsZWVkJyA/IGN1cnJlbnRJbmRleCA6IGN1cnJlbnRQYW5lbEluZGV4fSBpc1VzaW5nT2xkRmxhdHRlbmVyPXtpc1VzaW5nT2xkRmxhdHRlbmVyfSBvbkNsaWVudEFzc2V0Q29udmVyc2lvbj17b25DbGllbnRBc3NldENvbnZlcnNpb259Lz5cbiAgICAgIDwvRWRpdG9yQ2hyb21lPlxuICAgIDwvPik7XHJcbn07XHJcbmV4cG9ydCBkZWZhdWx0IEFwcDtcclxudmFyIHRlbXBsYXRlT2JqZWN0XzEsIHRlbXBsYXRlT2JqZWN0XzI7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUFwcC5qc3gubWFwIl19 */"]
  }), jsx(EditorChrome, {
    theme: theme,
    contextZones: contextZones,
    defaultBackPanels: defaultBackPanels,
    customBackPanels: customBackPanels,
    layouts: layouts,
    images: images,
    fonts: fonts,
    signatures: signatures,
    placeholders: placeholders,
    handleChangeView: handleChangeView,
    onUploadImages: onUploadImages,
    handleNextPanel: handleNextPanel,
    handlePreviousPanel: handlePreviousPanel,
    onDeleteBackPanel: onDeleteBackPanel,
    onSaveBackPanel: onSaveBackPanel,
    onCreateBackPanel: onCreateBackPanel,
    onSelectBackLayout: onSelectBackLayout,
    onDeleteImage: onDeleteImage,
    onClientAssetConversion: onClientAssetConversion,
    onSetDefaultBackPanel: defaultBackPanel ? setBackPanelId : undefined,
    defaultBackPanelId: defaultBackPanel ? backPanelId : undefined,
    colorPalettes: colorPalettes // handlePreview={handlePreview}
    ,
    scale: 100,
    helpIcon: jsx(Div, {
      onClick: function () {
        return actions.setReleaseOpenState(!release.isOpen);
      },
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      inset: {
        bottom: 'x2'
      },
      cursor: "pointer"
    }, jsx(Icon, {
      name: "information",
      primaryColor: "primaryBrand",
      size: "medium"
    }))
  }, jsx(Editor, _extends({}, props, {
    onSave: onSave,
    onSelectLayout: onSelectLayout,
    onUploadImages: onUploadImages,
    card: card,
    panelView: panelView,
    currentIndex: panelView === 'fullbleed' ? currentIndex : currentPanelIndex,
    isUsingOldFlattener: isUsingOldFlattener,
    onClientAssetConversion: onClientAssetConversion
  }))));
};
var templateObject_1$a, templateObject_2$4;

var GlobalEditor = function (props) {
  return jsx(App, props);
};

var updateCard$1 = function (state, transform) {
  return __assign(__assign({}, state), {
    card: state.card ? transform(state.card) : null
  });
};
var updateFullBleed = function (state, transform) {
  return updateCard$1(state, function (card) {
    return __assign(__assign({}, card), {
      fullBleeds: card.fullBleeds.map(function (fullBleed, location) {
        return location === state.fullBleedLocation ? transform(fullBleed) : fullBleed;
      })
    });
  });
};
var updatePanel = function (state, transform) {
  return updateFullBleed(state, function (fullBleed) {
    return __assign(__assign({}, fullBleed), {
      panels: fullBleed.panels.map(function (panel, location) {
        return location === state.panelLocation ? transform(panel) : panel;
      })
    });
  });
};
var updateElement = function (state, transform) {
  return updatePanel(state, function (panel) {
    return __assign(__assign({}, panel), {
      elements: panel.elements.map(function (element, location) {
        return location === state.activeElement.location ? transform(element, panel) : element;
      })
    });
  });
};
var updateElementImage = function (state, transform) {
  return updateElement(state, function (element) {
    return __assign(__assign({}, element), {
      movingProhibited: element.movingProhibited,
      image: element.image ? transform(element.image) : null
    });
  });
};
var textElement = {
  image: null,
  text: {
    fragments: [defaultFragment]
  }
};
var imageElement = {
  text: null,
  image: {
    image: null,
    filter: null,
    position: {
      x: 0.5,
      y: 0.5
    },
    scale: 1
  }
};
var fullBleedBackgroundImage = {
  image: {
    id: null,
    height: null,
    width: null,
    url: null
  },
  filter: null,
  position: {
    x: 0.5,
    y: 0.5
  },
  scale: 1
};
var isFragmentType = function (valueToCheck) {
  if (typeof valueToCheck === 'undefined') {
    return false;
  }

  return valueToCheck.fragments !== undefined;
};
var isImageType = function (valueToCheck) {
  if (typeof valueToCheck === 'undefined') {
    return false;
  }

  var image = valueToCheck;
  return image.id !== undefined && image.height !== undefined && image.url !== undefined && image.width !== undefined;
};
var addElement = function (panel, type, isFullPanel, isPanelLandscape, defaultElementState) {
  var image = isImageType(defaultElementState) ? __assign(__assign({}, imageElement), {
    image: __assign(__assign({}, imageElement.image), {
      image: defaultElementState
    })
  }) : imageElement;
  var text = isFragmentType(defaultElementState) ? __assign(__assign({}, textElement), {
    text: __assign({}, defaultElementState)
  }) : textElement;
  var element = type === 'image' ? image : text;
  var size = isFullPanel && type === 'image' ? {
    x: 0,
    y: 0,
    width: 1,
    height: 1
  } : isFullPanel ? {
    x: 0.05,
    y: 0.05,
    width: 0.9,
    height: 0.9
  } : isPanelLandscape ? {
    x: 0.1,
    y: 0.1,
    width: 0.35,
    height: 0.42
  } : {
    x: 0.1,
    y: 0.1,
    width: 0.5,
    height: 0.3
  };
  return __assign(__assign(__assign({}, size), {
    z: isFullPanel && type === 'image' ? 0 : hasFullPanelElement(panel) ? panel.elements.length : panel.elements.length + 1,
    rotation: 0,
    draggable: true,
    locked: false,
    isFullPanel: isFullPanel
  }), element);
};
var isElementType = function (valueToCheck) {
  var element = valueToCheck;

  if ((element.height || element.width || element.x || element.y || element.z) !== undefined) {
    return true;
  }

  return false;
};
var getCopyLocation = function (activeElement) {
  var startingPoints = {
    x: activeElement.x,
    y: activeElement.y
  };
  var endingPoints = {
    x: activeElement.x + activeElement.width,
    y: activeElement.y + activeElement.height
  };
  return {
    x: startingPoints.x + getCopyDirection(endingPoints.x),
    y: startingPoints.y + getCopyDirection(endingPoints.y)
  };
};
var getCopyDirection = function (endPoint) {
  if (endPoint <= 0.99) {
    return 0.01;
  }

  return -0.01;
};
var isInsideRightPanel = function (cardType, fullBleedLocation, panelLocation) {
  switch (cardType) {
    case 'POSTCARD':
    case 'FLATCARD':
      return fullBleedLocation === 1 && panelLocation === 0;

    case 'THREE_PANEL':
      return fullBleedLocation === 2 && panelLocation === 0;

    case 'TWO_PANEL':
    case 'TWO_PANEL_BIG':
    default:
      return fullBleedLocation === 1 && panelLocation === 1;
  }
};
var getElementLocation = function (state) {
  return state.card && typeof state.panelLocation === 'number' ? state.card.fullBleeds[state.fullBleedLocation].panels[state.panelLocation].elements.length : 0;
};
var hasFullPanelElement = function (panel) {
  return panel.elements.some(function (element) {
    return element.isFullPanel;
  });
};

var _insertFragments = function (state, fragments) {
  var start = state.start + fragments.length;
  return {
    fragments: __spread(state.fragments.slice(0, state.start), fragments, state.fragments.slice(state.end)),
    start: start,
    end: start,
    overrideProperties: {}
  };
};

var _insertCharacter = function (state, character) {
  return _insertFragments(state, [__assign(__assign({}, insertionProperties(state)), {
    text: character
  })]);
};

var _insertPlaceholder = function (state, placeholder) {
  return _insertCharacter(state, placeholder);
};

var _insertText = function (state, text) {
  return _insertFragments(state, __spread(text).map(function (character) {
    return __assign(__assign({}, insertionProperties(state)), {
      text: character
    });
  }));
};

var _insertSignature = function (state, signatureFontFamily) {
  return _insertFragments(state, [__assign(__assign({}, insertionProperties(state)), {
    signatureFontFamily: signatureFontFamily
  })]);
};

var _insertNewLine = function (state) {
  return _insertFragments(state, [__assign(__assign({}, insertionProperties(state)), {
    textAlign: insertionTextAlign(state)
  })]);
};

var _deleteFragments = function (state) {
  return _insertFragments(state.start === state.end && state.start > 1 ? __assign(__assign({}, state), {
    start: state.start - 1,
    overrideProperties: {}
  }) : state, []);
};

var _deleteForwardFragments = function (state) {
  if (state.start === state.end) {
    return {
      fragments: __spread(state.fragments.slice(0, state.start), state.fragments.slice(state.start + 1)),
      start: state.start,
      end: state.start,
      overrideProperties: {}
    };
  }

  return _insertFragments(state, []);
};

var _updateProperties = function (state, properties) {
  // If no text is highlighted
  if (state.start === state.end) {
    // If the only fragment that exists is the default fragment
    if (state.fragments[state.start - 1].textAlign) {
      return __assign(__assign({}, state), {
        fragments: __spread(state.fragments.slice(0, state.start - 1), [__assign(__assign({}, state.fragments[state.start - 1]), properties)], state.fragments.slice(state.end))
      });
    } else {
      // The cursor is somewhere in between the starting character and the ending character but no text is selected
      // We set the overrideProperties state to the properties being passed in, this sets up the future fragments to be
      // inserted with the new properties.
      // E.G I type at 16px font, I bump it up to 24px. The next letter I type will be 24px font (Same for color)
      return __assign(__assign({}, state), {
        overrideProperties: __assign(__assign({}, state.overrideProperties), properties)
      });
    }
  } else {
    // There is some chunk of text highlighted, we only alter that chunk of fragments with the new properties
    return __assign(__assign({}, state), {
      fragments: state.fragments.map(function (fragment, index) {
        return state.start <= index && index < state.end || index === state.start - 1 && fragment.textAlign ? __assign(__assign({}, fragment), properties) : fragment;
      })
    });
  }
};

var _updateTextAlign = function (state, textAlign) {
  return __assign(__assign({}, state), {
    fragments: __spread(state.fragments.slice(0, paragraphStart(state)), state.fragments.slice(paragraphStart(state), state.end).map(function (fragment) {
      return fragment.textAlign ? __assign(__assign({}, fragment), {
        textAlign: textAlign
      }) : fragment;
    }), state.fragments.slice(state.end))
  });
};

var _updateTextCasing = function (state, casing) {
  var isTextSelected = state.start !== state.end;
  var selectedFragments = isTextSelected ? state.fragments.slice(state.start, state.end) : state.fragments.slice(1);
  return __assign(__assign({}, state), {
    fragments: __spread(state.fragments.slice(0, isTextSelected ? state.start : 1), selectedFragments.map(function (fragment, index) {
      switch (casing) {
        case 'uppercase':
          return fragment.text ? __assign(__assign({}, fragment), {
            text: fragment.text.toUpperCase()
          }) : fragment;

        case 'lowercase':
          return fragment.text ? __assign(__assign({}, fragment), {
            text: fragment.text.toLowerCase()
          }) : fragment;

        case 'capitalize':
          return fragment.text ? __assign(__assign({}, fragment), {
            text: index === 0 ? fragment.text.toUpperCase() : selectedFragments[index - 1].text === ' ' ? fragment.text.toUpperCase() : fragment.text.toLowerCase()
          }) : fragment;

        default:
          return fragment;
      }
    }), state.fragments.slice(isTextSelected ? state.end : state.fragments.length))
  });
};

var textReducer = (function (state, action) {
  switch (action.type) {
    case insertCharacter.type:
      return _insertCharacter(state, action.character);

    case insertText.type:
      return _insertText(state, action.text);

    case insertFragments.type:
      return _insertFragments(state, action.fragments);

    case insertSignature.type:
      return _insertSignature(state, action.signature);

    case insertPlaceholder.type:
      return _insertPlaceholder(state, action.placeholder);

    case insertNewLine.type:
      return _insertNewLine(state);

    case deleteFragments.type:
      return _deleteFragments(state);

    case deleteForwardFragments.type:
      return _deleteForwardFragments(state);

    case selectFontFamily.type:
      return _updateProperties(state, {
        fontFamily: action.fontFamily
      });

    case selectFontSize.type:
      return _updateProperties(state, {
        fontSize: action.fontSize
      });

    case selectColor.type:
      return _updateProperties(state, {
        color: action.color
      });

    case selectTextAlign.type:
      return _updateTextAlign(state, action.textAlign);

    case updateTextCasing.type:
      return _updateTextCasing(state, action.casing);

    case clearText.type:
      return __assign(__assign({}, state), {
        start: 1,
        end: 1,
        overrideProperties: {},
        fragments: [defaultFragment]
      });

    default:
      return state;
  }
});

var Historian =
/** @class */
function () {
  function Historian(config) {
    var _this = this;

    this.addChange = function (changedObj) {
      if (_this.mutableCurrentState) {
        _this.mutableHistory.push(__assign({}, _this.mutableCurrentState));
      }

      _this.mutableCurrentState = __assign({}, changedObj);
      _this.mutableFuture = [];

      if (_this.mutableHistory.length > _this.numEntries) {
        _this.mutableHistory = _this.mutableHistory.slice(1, _this.mutableHistory.length);
      }
    };

    this.replaceCurrentState = function (changedObj) {
      _this.mutableCurrentState = __assign({}, changedObj);
      _this.mutableFuture = [];
    };

    this.undo = function () {
      if (_this.mutableHistory.length === 0) {
        return undefined;
      }

      var obj = _this.mutableHistory.pop();

      if (_this.mutableCurrentState) {
        _this.mutableFuture.push(__assign({}, _this.mutableCurrentState));
      }

      if (obj) {
        _this.mutableCurrentState = __assign({}, obj);
        return __assign({}, obj);
      }

      return undefined;
    };

    this.redo = function () {
      if (_this.mutableFuture.length === 0) {
        return undefined;
      }

      var obj = _this.mutableFuture.pop();

      if (_this.mutableCurrentState) {
        _this.mutableHistory.push(__assign({}, _this.mutableCurrentState));
      }

      if (obj) {
        _this.mutableCurrentState = __assign({}, obj);
        return __assign({}, obj);
      }

      return undefined;
    };

    this.reset = function () {
      _this.mutableCurrentState = undefined;
      _this.mutableHistory = [];
      _this.mutableFuture = [];
    };

    this.mutableHistory = [];
    this.mutableFuture = [];
    this.numEntries = config.numEntries;
    this.mutableCurrentState = config.startState;
  }

  return Historian;
}();

var CardHistorian = new Historian({
  numEntries: 100
});
var mutableActions = {
  prev: 'Bob',
  current: 'Blah',
  hasAddedBeforeReplacing: false
};
var actionsToIgnoreIfSame = ['SELECT_IMAGE_POSITION', 'SELECT_IMAGE_SCALE'];
var actionsIgnoreAltogether = ['SELECT_ELEMENT', 'SELECT_PANEL', 'ENABLE_SELECTING_ELEMENTS', 'DISABLE_SELECTING_ELEMENTS', 'REDO_EDITOR_CHANGE', 'UNDO_EDITOR_CHANGE', 'OPEN_IMAGE_DRAWER', 'OPEN_LAYOUT_DRAWER', 'OPEN_ELEMENT_INSERT_DRAWER', 'CLOSE_ELEMENT_INSERT_DRAWER', 'OPEN_ELEMENT_SETTINGS_DRAWER', 'CLOSE_ELEMENT_SETTINGS_DRAWER', 'SET_ACTIVE_IMAGE_SETTING', 'SET_ACTIVE_TEXT_SETTING', 'SET_SHOULD_REPLACE_SELECTED_IMAGE', 'SELECT_IMAGE', 'UPDATE_ELEMENT_SIZE'];

var shouldUseReplace = function (isSame, type) {
  return actionsToIgnoreIfSame.some(function (action) {
    return action === type;
  }) && isSame;
};

var ignoreAltogether = function (type) {
  return actionsIgnoreAltogether.some(function (action) {
    return action === type;
  });
};

var keepCardHistory = function (state, action) {
  var card = state.card;
  mutableActions.current = action.type;

  if (action.type === 'LOADED_CARD') {
    CardHistorian.addChange(action.card);
    return;
  }

  if (action.type === 'RESET_STATE') {
    CardHistorian.reset();
    return;
  }

  if (card && shouldUseReplace(mutableActions.current === mutableActions.prev, action.type) && !ignoreAltogether(action.type)) {
    if (!mutableActions.hasAddedBeforeReplacing) {
      CardHistorian.addChange(card);
      mutableActions.hasAddedBeforeReplacing = true;
    }

    CardHistorian.replaceCurrentState(card);
  } else if (card && !ignoreAltogether(action.type)) {
    CardHistorian.addChange(card);
    mutableActions.hasAddedBeforeReplacing = false;
  }

  mutableActions.prev = mutableActions.current;
  return;
};

var initialState = {
  fullBleedLocation: 0,
  panelLocation: 0,
  loadError: null,
  layoutToLoad: null,
  activeToolbarAction: null,
  card: null,
  canSelectElements: true,
  activeElement: {
    location: null,
    type: null
  },
  editing: 'panel'
};
var editor = (function (state, action) {
  if (state === void 0) {
    state = initialState;
  }

  var newState = editorReducer(state, action);
  keepCardHistory(newState, action);
  return newState;
});

var editorReducer = function (state, action) {
  var _a, _b, _c;

  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case addImageElement.type:
      return updatePanel(__assign(__assign({}, state), {
        editing: 'element',
        activeElement: {
          location: getElementLocation(state),
          type: 'image'
        }
      }), function (panel) {
        var _a, _b;

        return __assign(__assign({}, panel), {
          elements: panel.elements.concat(addElement(panel, 'image', !!action.isFullPanel, ((_a = state.card) === null || _a === void 0 ? void 0 : _a.orientation) === 'LANDSCAPE' && ((_b = state.card) === null || _b === void 0 ? void 0 : _b.fullBleeds[state.fullBleedLocation].name.toLowerCase()) !== 'back', action.image))
        });
      });

    case addTextElement.type:
      return updatePanel(__assign(__assign({}, state), {
        editing: 'element',
        activeElement: {
          location: getElementLocation(state),
          type: 'text'
        },
        textSelection: {
          start: 1,
          end: 1,
          overrideProperties: {}
        }
      }), function (panel) {
        var _a, _b;

        return __assign(__assign({}, panel), {
          elements: panel.elements.concat(addElement(panel, 'text', !!action.isFullPanel, ((_a = state.card) === null || _a === void 0 ? void 0 : _a.orientation) === 'LANDSCAPE' && ((_b = state.card) === null || _b === void 0 ? void 0 : _b.fullBleeds[state.fullBleedLocation].name.toLowerCase()) !== 'back'))
        });
      });

    case disableSelectingElements.type:
      return __assign(__assign({}, state), {
        canSelectElements: false
      });

    case enableSelectingElements.type:
      return __assign(__assign({}, state), {
        canSelectElements: true
      });

    case setToolbarAction.type:
      return __assign(__assign({}, state), {
        activeToolbarAction: action.toolbarAction
      });

    case loadedCard.type:
      return __assign(__assign({}, state), {
        card: action.card
      });

    case setPanelBackground.type:
      return updatePanel(state, function (panel) {
        return __assign(__assign({}, panel), {
          backgroundColor: action.color
        });
      });

    case removeElement.type:
      return updatePanel(__assign(__assign({}, state), {
        editing: 'panel',
        activeElement: {
          location: null,
          type: null
        }
      }), function (panel) {
        // set variable to distinguish when gap in z-indices is found
        var isFound = false;
        var filteredSortedPanel = panel.elements // add a location prop on each element, so that we can return the panel in the same order at the end
        .map(function (e, i) {
          e.location = i;
          return e;
        }) // // filter out element being deleted and sort elemnts by z index
        .sort(function (a, b) {
          if (a.location === b.location) {
            return 0;
          }

          if (a.location === state.activeElement.location) {
            return 1;
          }

          if (b.location === state.activeElement.location) {
            return -1;
          }

          return a.z - b.z;
        }); // Remove the last item O(1) - Optimization over O(N) filter to remove.

        filteredSortedPanel.pop();
        var newPanel = filteredSortedPanel // Locate the gap in z-indeces and decrement all z-indeces after the gap
        .map(function (element, index) {
          // this is the edge case where element with z-index of 1 gets deleted
          if (index === 0 && element.z === 2) {
            isFound = true;
          } //all other z-index gap scenarios


          if (!isFound && filteredSortedPanel[index - 1] && element.z - filteredSortedPanel[index - 1].z > 1) {
            isFound = true;
          }

          if (isFound) {
            element.z = element.z - 1;
          }

          return element;
        }) // reorder the elements according to the original index
        .sort(function (a, b) {
          if (typeof a.location === 'number' && typeof b.location === 'number') {
            return a.location - b.location;
          } else return 1;
        });
        return __assign(__assign({}, panel), {
          elements: newPanel
        });
      });

    case clearPanel.type:
      return updatePanel(__assign(__assign({}, state), {
        editing: 'panel',
        activeElement: {
          location: null,
          type: null
        }
      }), function (panel) {
        var newElements = panel.elements.filter(function (element) {
          var isElementLocked = element.locked;
          var shouldClearContent = panel.isLocked && !element.draggable && (element.image || element.text);
          return isElementLocked || shouldClearContent;
        }).map(function (element) {
          return element.locked ? element : element.image ? __assign(__assign({}, element), {
            image: {
              image: null,
              position: {
                x: 0.5,
                y: 0.5
              },
              scale: 1,
              filter: null
            }
          }) : __assign(__assign({}, element), {
            text: {
              fragments: [defaultFragment]
            }
          });
        });
        return __assign(__assign({}, panel), {
          elements: newElements,
          backgroundColor: null
        });
      });

    case selectFullBleed.type:
      return __assign(__assign({}, state), {
        fullBleedLocation: action.fullBleedLocation,
        panelLocation: 0,
        activeElement: {
          location: null,
          type: null
        },
        textSelection: undefined,
        editing: 'panel'
      });

    case selectPanel.type:
      return __assign(__assign({}, state), {
        panelLocation: action.panelLocation,
        activeElement: {
          location: null,
          type: null
        },
        activeToolbarAction: null,
        textSelection: undefined,
        editing: action.fullBleedLocation !== 0 ? 'panel' : state.editing
      });

    case selectSinglePanel.type:
      return __assign(__assign({}, state), {
        fullBleedLocation: action.fullBleedLocation,
        panelLocation: action.panelLocation,
        activeElement: {
          location: null,
          type: null
        },
        textSelection: undefined
      });

    case selectElement.type:
      return __assign(__assign({}, state), {
        panelLocation: action.panelLocation,
        activeElement: action.activeElement,
        textSelection: action.textStart ? {
          start: action.textStart,
          end: action.textEnd ? action.textEnd : action.textStart,
          overrideProperties: state.textSelection ? state.textSelection.overrideProperties : {}
        } : undefined,
        editing: 'element'
      });

    case deselectElement.type:
      return __assign(__assign({}, state), {
        editing: 'panel',
        activeElement: {
          location: null,
          type: null
        }
      });

    case selectImage.type:
      var image_1 = action.photo;
      return updateElementImage(__assign({}, state), function () {
        return {
          image: {
            id: image_1.id,
            url: decodeURI(image_1.url),
            width: image_1.width,
            height: image_1.height,
            thumbnailUrl: decodeURI(image_1.thumbnailUrl)
          },
          position: {
            x: 0.5,
            y: 0.5
          },
          scale: 1,
          filter: null
        };
      });

    case toggleElementDraggable.type:
      return __assign({}, updateElement(state, function (element) {
        return __assign(__assign({}, element), {
          draggable: !element.draggable
        });
      }));

    case selectImagePosition.type:
      var isInRange_1 = function (val) {
        return val <= 1 && val >= 0;
      };

      return updateElementImage(state, function (image) {
        return __assign(__assign({}, image), {
          position: {
            x: isInRange_1(action.x) ? action.x : image.position.x,
            y: isInRange_1(action.y) ? action.y : image.position.y
          }
        });
      });

    case selectImageScale.type:
      return updateElementImage(state, function (image) {
        // when the scale changes to 1 from anything less than 1
        // it looks like it is fine on the editor, but it
        // is actually positioned wrong, this fix below forces it to center
        // if the user likes this position, it will be fine when
        // flattened, if they want to manually move it, it will still
        // be updated as usual
        return __assign(__assign({}, image), {
          scale: action.scale
        });
      });

    case selectFilter.type:
      return updateElementImage(state, function (image) {
        return __assign(__assign({}, image), {
          filterUrl: action.url,
          filter: {
            name: action.filterName
          }
        });
      });

    case removeImage.type:
      return updateElementImage(state, function () {
        return {
          image: null,
          position: {
            x: 0.5,
            y: 0.5
          },
          scale: 1,
          filter: null
        };
      });

    case selectLayout.type:
      return __assign({}, updatePanel(__assign(__assign({}, state), {
        layoutToLoad: null
      }), function (panel) {
        var elementImages = panel.elements.filter(function (element) {
          return element.image;
        }).map(function (element) {
          return element.image;
        });
        var elementTexts = panel.elements.filter(function (element) {
          return element.text;
        }).map(function (element) {
          return element.text;
        });
        return __assign(__assign({}, panel), {
          elements: action.layout.panel.elements.map(function (element) {
            if (element.image) {
              return element.image.image ? element : __assign(__assign({}, element), {
                image: elementImages.length > 0 ? elementImages.shift() || null : element.image
              });
            } else {
              return element.text && element.text.fragments.length > 1 ? element : __assign(__assign({}, element), {
                text: elementTexts.length > 0 ? elementTexts.shift() || null : element.text
              });
            }
          })
        });
      }));

    case selectBackPanel.type:
      var id = action.layout.id;
      var layoutToLoad = typeof id === 'number' ? id.toString() : id;
      return updatePanel(__assign(__assign({}, state), {
        layoutToLoad: layoutToLoad
      }), function (panel) {
        return __assign(__assign({}, panel), {
          elements: action.layout.panel.elements
        });
      });

    case selectLayoutToLoad.type:
      return __assign(__assign({}, state), {
        layoutToLoad: action.layoutId
      });

    case setCard.type:
      return __assign(__assign({}, state), {
        card: action.card
      });

    case updateElementPosition.type:
      return updatePanel(state, function (panel) {
        return __assign(__assign({}, panel), {
          elements: panel.elements.map(function (element, location) {
            var _a, _b;

            return location === action.elementLocation ? __assign(__assign({}, element), {
              x: (_a = action.x) !== null && _a !== void 0 ? _a : element.x,
              y: (_b = action.y) !== null && _b !== void 0 ? _b : element.y
            }) : element;
          })
        });
      });

    case updateElementSize.type:
      return updatePanel(state, function (panel) {
        return __assign(__assign({}, panel), {
          elements: panel.elements.map(function (element, location) {
            var _a, _b;

            return location === action.elementLocation ? __assign(__assign({}, element), {
              width: (_a = action.width) !== null && _a !== void 0 ? _a : element.width,
              height: (_b = action.height) !== null && _b !== void 0 ? _b : element.height
            }) : element;
          })
        });
      });

    case updateElementRotation.type:
      {
        return updatePanel(state, function (panel) {
          return __assign(__assign({}, panel), {
            elements: panel.elements.map(function (element, location) {
              return location === action.elementLocation ? __assign(__assign({}, element), {
                rotation: action.rotation
              }) : element;
            })
          });
        });
      }

    case closeEditorDrawer.type:
      return __assign(__assign({}, state), {
        activeElement: {
          location: null,
          type: null
        },
        textSelection: undefined
      });

    case resetState.type:
      return __assign({}, initialState);

    case editorUndo.type:
      {
        var newCardState = CardHistorian.undo();

        if (newCardState) {
          return __assign(__assign({}, state), {
            card: newCardState
          });
        } else {
          return state;
        }
      }

    case editorRedo.type:
      {
        var newCardState = CardHistorian.redo();

        if (newCardState) {
          return __assign(__assign({}, state), {
            card: newCardState
          });
        } else {
          return state;
        }
      }

    case duplicateElement.type:
      {
        if (typeof state.fullBleedLocation === 'number' && typeof state.panelLocation === 'number' && typeof state.activeElement.location === 'number') {
          var activePanel = (_a = state.card) === null || _a === void 0 ? void 0 : _a.fullBleeds[state.fullBleedLocation].panels[state.panelLocation];
          var activeElement = activePanel === null || activePanel === void 0 ? void 0 : activePanel.elements[state.activeElement.location];

          if (isElementType(activeElement)) {
            var copy_1 = __assign(__assign(__assign({}, activeElement), getCopyLocation(activeElement)), {
              z: activeElement.z + 1
            });

            return updatePanel(__assign(__assign({}, state), {
              activeElement: {
                location: (_c = (_b = activePanel === null || activePanel === void 0 ? void 0 : activePanel.elements) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : null,
                type: activeElement.text ? 'text' : activeElement.image ? 'image' : null
              }
            }), function (panel) {
              return __assign(__assign({}, panel), {
                elements: panel.elements.concat(copy_1)
              });
            });
          }
        }

        return state;
      }

    case layerUp.type:
      {
        var tempZ_1 = 0;
        return updatePanel(state, function (panel) {
          panel.elements.forEach(function (element, index) {
            if (index === action.elementLocation) tempZ_1 = element.z;
          });
          var length = panel.elements.some(function (element) {
            return element.isFullPanel;
          }) ? panel.elements.length - 1 : panel.elements.length;
          return __assign(__assign({}, panel), {
            elements: panel.elements.map(function (element) {
              return element.isFullPanel ? __assign({}, element) : tempZ_1 === element.z ? __assign(__assign({}, element), {
                z: element.z === length ? element.z : element.z + 1
              }) : tempZ_1 === element.z - 1 ? __assign(__assign({}, element), {
                z: hasFullPanelElement(panel) && element.z === 1 ? element.z : element.z - 1
              }) : element;
            })
          });
        });
      }

    case layerDown.type:
      {
        var tempZ_2 = 0;
        return __assign({}, updatePanel(state, function (panel) {
          panel.elements.forEach(function (element, index) {
            if (index === action.elementLocation) tempZ_2 = element.z;
          });
          return __assign(__assign({}, panel), {
            elements: panel.elements.map(function (element) {
              return element.isFullPanel ? __assign({}, element) : tempZ_2 === element.z ? __assign(__assign({}, element), {
                z: element.z === 1 ? element.z : element.z - 1
              }) : tempZ_2 === element.z + 1 ? __assign(__assign({}, element), {
                z: element.z + 1
              }) : element;
            })
          });
        }));
      }

    case setEditing.type:
      {
        var isEditingElement = action.editing === 'element';
        return __assign(__assign({}, state), {
          editing: action.editing,
          activeElement: {
            location: isEditingElement ? state.activeElement.location : null,
            type: isEditingElement ? state.activeElement.type : null
          }
        });
      }

    case setFullBleedBackgroundImage.type:
      {
        var image_2 = __assign(__assign({}, fullBleedBackgroundImage), {
          image: {
            url: action.image.url,
            thumbnailUrl: action.image.thumbnailUrl,
            height: action.image.height,
            width: action.image.width,
            id: action.image.id
          }
        });

        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              image: fullBleed.backgroundElement.image ? __assign(__assign({}, fullBleed.backgroundElement.image), {
                image: action.image
              }) : image_2
            }) : null
          });
        });
      }

    case deleteFullBleedBackgroundImage.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              x: 0,
              y: 0,
              z: 0,
              width: 1,
              height: 1,
              rotation: 0,
              image: null
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundImagePosition.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          var _a, _b;

          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              image: fullBleed.backgroundElement.image ? __assign(__assign({}, fullBleed.backgroundElement.image), {
                position: {
                  x: (_a = action.x) !== null && _a !== void 0 ? _a : fullBleed.backgroundElement.image.position.x,
                  y: (_b = action.y) !== null && _b !== void 0 ? _b : fullBleed.backgroundElement.image.position.y
                }
              }) : null
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundImageScale.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              image: fullBleed.backgroundElement.image ? __assign(__assign({}, fullBleed.backgroundElement.image), {
                scale: action.scale
              }) : null
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundElementPosition.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          var _a, _b;

          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              x: (_a = action.x) !== null && _a !== void 0 ? _a : fullBleed.backgroundElement.x,
              y: (_b = action.y) !== null && _b !== void 0 ? _b : fullBleed.backgroundElement.y
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundElementSize.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          var _a, _b;

          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              width: (_a = action.width) !== null && _a !== void 0 ? _a : fullBleed.backgroundElement.width,
              height: (_b = action.height) !== null && _b !== void 0 ? _b : fullBleed.backgroundElement.height
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundElementRotation.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              rotation: action.rotation
            }) : null
          });
        });
      }

    case selectVariation.type:
      {
        return updateCard$1(state, function (card) {
          var _a, _b;

          var variations = (_b = (_a = card.variationState) === null || _a === void 0 ? void 0 : _a.variations) !== null && _b !== void 0 ? _b : [];
          var variation = variations.find(function (v) {
            return v.id === action.variationID;
          });
          if (!variation) return card;

          var elementImage = function (image) {
            return {
              image: {
                id: image.id,
                width: image.width,
                height: image.height,
                url: image.url,
                thumbnailUrl: image.thumbnailUrl
              },
              position: {
                x: 0.5,
                y: 0.5
              },
              scale: 1,
              filter: null
            };
          };

          return __assign(__assign({}, card), {
            variationState: {
              selectedVariationID: action.variationID,
              variations: variations
            },
            fullBleeds: card.fullBleeds.map(function (fullBleed, fullBleedLocation) {
              return __assign(__assign({}, fullBleed), {
                panels: fullBleed.panels.map(function (panel, panelLocation) {
                  return __assign(__assign({}, panel), {
                    elements: panel.elements.map(function (element) {
                      return __assign(__assign({}, element), {
                        image: element.image ? fullBleedLocation === 0 && panelLocation === 0 && element.locked ? elementImage(variation.frontImage) : variation.insideRightImage && isInsideRightPanel(card.type, fullBleedLocation, panelLocation) && element.locked ? elementImage(variation.insideRightImage) : element.image : element.image
                      });
                    })
                  });
                })
              });
            })
          });
        });
      }

    case enablePreviewMode.type:
      {
        var newState = __assign({}, state);

        return __assign(__assign({}, initialState), {
          card: newState.card,
          fullBleedLocation: newState.fullBleedLocation
        });
      }

    case updateClientAsset.type:
      {
        return updateElementImage(state, function (image) {
          var _a, _b, _c, _d;

          return __assign(__assign({}, image), {
            image: __assign(__assign({}, image.image), {
              id: (_a = action.image.id) !== null && _a !== void 0 ? _a : '',
              height: action.image.height,
              width: action.image.width,
              url: (_b = action.image.url) !== null && _b !== void 0 ? _b : '',
              thumbnailUrl: (_d = (_c = action.image) === null || _c === void 0 ? void 0 : _c.thumbnailUrl) !== null && _d !== void 0 ? _d : ''
            })
          });
        });
      }

    default:
      if (state.textSelection) {
        var _d = textReducer(textState(state), action),
            fragments_1 = _d.fragments,
            textSelection = __rest(_d, ["fragments"]);

        return __assign(__assign({}, updateElement(state, function (element) {
          return __assign(__assign({}, element), {
            text: element.text ? {
              fragments: fragments_1
            } : null
          });
        })), {
          textSelection: textSelection
        });
      } else {
        return state;
      }

  }
};

var initialState$1 = {
  loading: false,
  images: [],
  hasMore: true
};
var images = (function (state, action) {
  if (state === void 0) {
    state = initialState$1;
  }

  switch (action.type) {
    case showImages.type:
      return __assign(__assign({}, state), {
        loading: true
      });

    default:
      return state;
  }
});

var initialState$2 = {
  isElementInsertOpen: false,
  elementInsertDrawerType: null,
  isElementSettingsOpen: false,
  elementSettingsDrawerType: null,
  activeImageSetting: null,
  activeTextSetting: null,
  isTextCursorActive: false,
  shouldReplaceSelectedImage: false,
  showBetaBanner: true,
  interactionMode: 'edit',
  release: {
    data: null,
    hasSeen: false,
    isOpen: true
  },
  isImageUploaderWidgetActive: false,
  hasUploadedImage: false
}; // Can we put a flag on release and persist it to control if the release has been seen or not?

var editorChrome = (function (state, action) {
  var _a;

  if (state === void 0) {
    state = initialState$2;
  }

  switch (action.type) {
    case openElementInsertDrawer.type:
      return __assign(__assign({}, state), {
        isElementInsertOpen: true,
        elementInsertDrawerType: action.insertType
      });

    case closeElementInsertDrawer.type:
      return __assign(__assign({}, state), {
        isElementInsertOpen: false,
        elementInsertDrawerType: null
      });

    case openElementSettingsDrawer.type:
      return __assign(__assign({}, state), {
        isElementSettingsOpen: true,
        elementSettingsDrawerType: action.settingType,
        activeImageSetting: null,
        activeTextSetting: null,
        isImageUploaderWidgetActive: state.isImageUploaderWidgetActive && action.settingType === 'panel'
      });

    case closeElementSettingsDrawer.type:
      return __assign(__assign({}, state), {
        isElementSettingsOpen: false,
        activeImageSetting: null,
        activeTextSetting: null,
        isImageUploaderWidgetActive: false
      });

    case setActiveImageSetting.type:
      return __assign(__assign({}, state), {
        activeImageSetting: action.activeSetting
      });

    case setActiveTextSetting.type:
      return __assign(__assign({}, state), {
        activeTextSetting: action.activeSetting
      });

    case setShouldReplaceSelectedImage.type:
      return __assign(__assign({}, state), {
        shouldReplaceSelectedImage: action.shouldReplaceSelectedImage
      });

    case setIsTextCursorActive.type:
      return __assign(__assign({}, state), {
        isTextCursorActive: action.isTextCursorActive
      });

    case closeBetaBanner.type:
      return __assign(__assign({}, state), {
        showBetaBanner: false
      });

    case toggleInteractionMode.type:
      var isPreviewMode = state.interactionMode === 'preview';
      return __assign(__assign({}, state), {
        interactionMode: isPreviewMode ? 'edit' : 'preview',
        isElementInsertOpen: false,
        elementInsertDrawerType: null,
        elementSettingsDrawerType: isPreviewMode ? null : state.elementSettingsDrawerType,
        isElementSettingsOpen: isPreviewMode ? false : state.isElementInsertOpen,
        isTextCursorActive: false,
        shouldReplaceSelectedImage: false
      });

    case setReleaseData.type:
      var _b = action.releaseData,
          featureList = _b.featureList,
          rest = __rest(_b, ["featureList"]);

      var featureQueue = new Queue();
      featureQueue.addAll(featureList);
      return __assign(__assign({}, state), {
        release: __assign(__assign({}, state.release), {
          data: __assign(__assign({}, rest), {
            featureQueue: featureQueue
          })
        })
      });

    case popReleaseFeature.type:
      if (state.release.data) {
        if (state.release.data.featureQueue.size() === 0) {
          return __assign(__assign({}, state), {
            release: __assign({}, state.release)
          });
        }

        var newState = __assign({}, state);

        (_a = newState.release.data) === null || _a === void 0 ? void 0 : _a.featureQueue.dequeue();
        return newState;
      } else {
        return __assign({}, state);
      }

    case setReleaseOpenState.type:
      return __assign(__assign({}, state), {
        release: __assign(__assign({}, state.release), {
          isOpen: action.isOpen
        })
      });

    case toggleImageUploaderWidget.type:
      return __assign(__assign({}, state), {
        isImageUploaderWidgetActive: !state.isImageUploaderWidgetActive
      });

    case setHasUploadedImage.type:
      return __assign(__assign({}, state), {
        hasUploadedImage: action.hasUploadedImage
      });

    default:
      return state;
  }
});

var rootReducer = combineReducers({
  images: images,
  editor: editor,
  editorChrome: editorChrome
});

var appReducer = function (state, action) {
  if (action.type === 'SAVED_AND_SENT') {
    // Passing undefined into rootReducer seems odd here but it comes straight from Dan Abramov via:
    // https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
    return rootReducer(undefined, action);
  }

  return rootReducer(state, action);
}; // const persistConfig = {
//   key: 'root',
//   storage,
//   whitelist: ['editorChrome'],
// }
// const persistedReducer = persistReducer(persistConfig, appReducer)
// export const store = createStore(persistedReducer, {}, composeWithDevTools())
// export const persistor = persistStore(store)


var store = createStore(appReducer, {}, composeWithDevTools());

var GlobalEditorProvider = function (_a) {
  var children = _a.children;
  return jsx(Provider, {
    store: store
  }, children);
};

export { GlobalEditor, GlobalEditorProvider };
